/*!
  * Bootstrap v4.3.1 (https://getbootstrap.com/)
  * Copyright 2011-2019 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery'), require('popper.js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
  (global = global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
}(this, function (exports, $, Popper) { 'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
  Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.3.1): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var TRANSITION_END = 'transitionend';
  var MAX_UID = 1000000;
  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined; // eslint-disable-line no-undefined
      }
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    $.fn.emulateTransitionEnd = transitionEndEmulator;
    $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }
  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */


  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (err) {
        return null;
      }
    },
    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
      if (!element) {
        return 0;
      } // Get transition-duration of the element


      var transitionDuration = $(element).css('transition-duration');
      var transitionDelay = $(element).css('transition-delay');
      var floatTransitionDuration = parseFloat(transitionDuration);
      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      } // If multiple durations are defined, take the first


      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(TRANSITION_END);
    },
    // TODO: Remove in v5
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    },
    findShadowRoot: function findShadowRoot(element) {
      if (!document.documentElement.attachShadow) {
        return null;
      } // Can find the shadow root otherwise it'll return the document


      if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }

      if (element instanceof ShadowRoot) {
        return element;
      } // when we don't find a shadow root


      if (!element.parentNode) {
        return null;
      }

      return Util.findShadowRoot(element.parentNode);
    }
  };
  setTransitionEndSupport();

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'alert';
  var VERSION = '4.3.1';
  var DATA_KEY = 'bs.alert';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var Selector = {
    DISMISS: '[data-dismiss="alert"]'
  };
  var Event = {
    CLOSE: "close" + EVENT_KEY,
    CLOSED: "closed" + EVENT_KEY,
    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    ALERT: 'alert',
    FADE: 'fade',
    SHOW: 'show'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Alert =
  /*#__PURE__*/
  function () {
    function Alert(element) {
      this._element = element;
    } // Getters


    var _proto = Alert.prototype;

    // Public
    _proto.close = function close(element) {
      var rootElement = this._element;

      if (element) {
        rootElement = this._getRootElement(element);
      }

      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    } // Private
    ;

    _proto._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = document.querySelector(selector);
      }

      if (!parent) {
        parent = $(element).closest("." + ClassName.ALERT)[0];
      }

      return parent;
    };

    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $.Event(Event.CLOSE);
      $(element).trigger(closeEvent);
      return closeEvent;
    };

    _proto._removeElement = function _removeElement(element) {
      var _this = this;

      $(element).removeClass(ClassName.SHOW);

      if (!$(element).hasClass(ClassName.FADE)) {
        this._destroyElement(element);

        return;
      }

      var transitionDuration = Util.getTransitionDurationFromElement(element);
      $(element).one(Util.TRANSITION_END, function (event) {
        return _this._destroyElement(element, event);
      }).emulateTransitionEnd(transitionDuration);
    };

    _proto._destroyElement = function _destroyElement(element) {
      $(element).detach().trigger(Event.CLOSED).remove();
    } // Static
    ;

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);
        var data = $element.data(DATA_KEY);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }]);

    return Alert;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Alert._jQueryInterface;
  $.fn[NAME].Constructor = Alert;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Alert._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$1 = 'button';
  var VERSION$1 = '4.3.1';
  var DATA_KEY$1 = 'bs.button';
  var EVENT_KEY$1 = "." + DATA_KEY$1;
  var DATA_API_KEY$1 = '.data-api';
  var JQUERY_NO_CONFLICT$1 = $.fn[NAME$1];
  var ClassName$1 = {
    ACTIVE: 'active',
    BUTTON: 'btn',
    FOCUS: 'focus'
  };
  var Selector$1 = {
    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
    DATA_TOGGLE: '[data-toggle="buttons"]',
    INPUT: 'input:not([type="hidden"])',
    ACTIVE: '.active',
    BUTTON: '.btn'
  };
  var Event$1 = {
    CLICK_DATA_API: "click" + EVENT_KEY$1 + DATA_API_KEY$1,
    FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY$1 + DATA_API_KEY$1 + " " + ("blur" + EVENT_KEY$1 + DATA_API_KEY$1)
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Button =
  /*#__PURE__*/
  function () {
    function Button(element) {
      this._element = element;
    } // Getters


    var _proto = Button.prototype;

    // Public
    _proto.toggle = function toggle() {
      var triggerChangeEvent = true;
      var addAriaPressed = true;
      var rootElement = $(this._element).closest(Selector$1.DATA_TOGGLE)[0];

      if (rootElement) {
        var input = this._element.querySelector(Selector$1.INPUT);

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && this._element.classList.contains(ClassName$1.ACTIVE)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = rootElement.querySelector(Selector$1.ACTIVE);

              if (activeElement) {
                $(activeElement).removeClass(ClassName$1.ACTIVE);
              }
            }
          }

          if (triggerChangeEvent) {
            if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
              return;
            }

            input.checked = !this._element.classList.contains(ClassName$1.ACTIVE);
            $(input).trigger('change');
          }

          input.focus();
          addAriaPressed = false;
        }
      }

      if (addAriaPressed) {
        this._element.setAttribute('aria-pressed', !this._element.classList.contains(ClassName$1.ACTIVE));
      }

      if (triggerChangeEvent) {
        $(this._element).toggleClass(ClassName$1.ACTIVE);
      }
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY$1);
      this._element = null;
    } // Static
    ;

    Button._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$1);

        if (!data) {
          data = new Button(this);
          $(this).data(DATA_KEY$1, data);
        }

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$1;
      }
    }]);

    return Button;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$1.CLICK_DATA_API, Selector$1.DATA_TOGGLE_CARROT, function (event) {
    event.preventDefault();
    var button = event.target;

    if (!$(button).hasClass(ClassName$1.BUTTON)) {
      button = $(button).closest(Selector$1.BUTTON);
    }

    Button._jQueryInterface.call($(button), 'toggle');
  }).on(Event$1.FOCUS_BLUR_DATA_API, Selector$1.DATA_TOGGLE_CARROT, function (event) {
    var button = $(event.target).closest(Selector$1.BUTTON)[0];
    $(button).toggleClass(ClassName$1.FOCUS, /^focus(in)?$/.test(event.type));
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$1] = Button._jQueryInterface;
  $.fn[NAME$1].Constructor = Button;

  $.fn[NAME$1].noConflict = function () {
    $.fn[NAME$1] = JQUERY_NO_CONFLICT$1;
    return Button._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$2 = 'carousel';
  var VERSION$2 = '4.3.1';
  var DATA_KEY$2 = 'bs.carousel';
  var EVENT_KEY$2 = "." + DATA_KEY$2;
  var DATA_API_KEY$2 = '.data-api';
  var JQUERY_NO_CONFLICT$2 = $.fn[NAME$2];
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

  var SWIPE_THRESHOLD = 40;
  var Default = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true,
    touch: true
  };
  var DefaultType = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean',
    touch: 'boolean'
  };
  var Direction = {
    NEXT: 'next',
    PREV: 'prev',
    LEFT: 'left',
    RIGHT: 'right'
  };
  var Event$2 = {
    SLIDE: "slide" + EVENT_KEY$2,
    SLID: "slid" + EVENT_KEY$2,
    KEYDOWN: "keydown" + EVENT_KEY$2,
    MOUSEENTER: "mouseenter" + EVENT_KEY$2,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$2,
    TOUCHSTART: "touchstart" + EVENT_KEY$2,
    TOUCHMOVE: "touchmove" + EVENT_KEY$2,
    TOUCHEND: "touchend" + EVENT_KEY$2,
    POINTERDOWN: "pointerdown" + EVENT_KEY$2,
    POINTERUP: "pointerup" + EVENT_KEY$2,
    DRAG_START: "dragstart" + EVENT_KEY$2,
    LOAD_DATA_API: "load" + EVENT_KEY$2 + DATA_API_KEY$2,
    CLICK_DATA_API: "click" + EVENT_KEY$2 + DATA_API_KEY$2
  };
  var ClassName$2 = {
    CAROUSEL: 'carousel',
    ACTIVE: 'active',
    SLIDE: 'slide',
    RIGHT: 'carousel-item-right',
    LEFT: 'carousel-item-left',
    NEXT: 'carousel-item-next',
    PREV: 'carousel-item-prev',
    ITEM: 'carousel-item',
    POINTER_EVENT: 'pointer-event'
  };
  var Selector$2 = {
    ACTIVE: '.active',
    ACTIVE_ITEM: '.active.carousel-item',
    ITEM: '.carousel-item',
    ITEM_IMG: '.carousel-item img',
    NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
    INDICATORS: '.carousel-indicators',
    DATA_SLIDE: '[data-slide], [data-slide-to]',
    DATA_RIDE: '[data-ride="carousel"]'
  };
  var PointerType = {
    TOUCH: 'touch',
    PEN: 'pen'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Carousel =
  /*#__PURE__*/
  function () {
    function Carousel(element, config) {
      this._items = null;
      this._interval = null;
      this._activeElement = null;
      this._isPaused = false;
      this._isSliding = false;
      this.touchTimeout = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this._config = this._getConfig(config);
      this._element = element;
      this._indicatorsElement = this._element.querySelector(Selector$2.INDICATORS);
      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

      this._addEventListeners();
    } // Getters


    var _proto = Carousel.prototype;

    // Public
    _proto.next = function next() {
      if (!this._isSliding) {
        this._slide(Direction.NEXT);
      }
    };

    _proto.nextWhenVisible = function nextWhenVisible() {
      // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible
      if (!document.hidden && $(this._element).is(':visible') && $(this._element).css('visibility') !== 'hidden') {
        this.next();
      }
    };

    _proto.prev = function prev() {
      if (!this._isSliding) {
        this._slide(Direction.PREV);
      }
    };

    _proto.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (this._element.querySelector(Selector$2.NEXT_PREV)) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    _proto.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    _proto.to = function to(index) {
      var _this = this;

      this._activeElement = this._element.querySelector(Selector$2.ACTIVE_ITEM);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $(this._element).one(Event$2.SLID, function () {
          return _this.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

      this._slide(direction, this._items[index]);
    };

    _proto.dispose = function dispose() {
      $(this._element).off(EVENT_KEY$2);
      $.removeData(this._element, DATA_KEY$2);
      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, Default, config);
      Util.typeCheckConfig(NAME$2, config, DefaultType);
      return config;
    };

    _proto._handleSwipe = function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX; // swipe left

      if (direction > 0) {
        this.prev();
      } // swipe right


      if (direction < 0) {
        this.next();
      }
    };

    _proto._addEventListeners = function _addEventListeners() {
      var _this2 = this;

      if (this._config.keyboard) {
        $(this._element).on(Event$2.KEYDOWN, function (event) {
          return _this2._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        $(this._element).on(Event$2.MOUSEENTER, function (event) {
          return _this2.pause(event);
        }).on(Event$2.MOUSELEAVE, function (event) {
          return _this2.cycle(event);
        });
      }

      if (this._config.touch) {
        this._addTouchEventListeners();
      }
    };

    _proto._addTouchEventListeners = function _addTouchEventListeners() {
      var _this3 = this;

      if (!this._touchSupported) {
        return;
      }

      var start = function start(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchStartX = event.originalEvent.clientX;
        } else if (!_this3._pointerEvent) {
          _this3.touchStartX = event.originalEvent.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        if (event.originalEvent.touches && event.originalEvent.touches.length > 1) {
          _this3.touchDeltaX = 0;
        } else {
          _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
        }
      };

      var end = function end(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
        }

        _this3._handleSwipe();

        if (_this3._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling
          _this3.pause();

          if (_this3.touchTimeout) {
            clearTimeout(_this3.touchTimeout);
          }

          _this3.touchTimeout = setTimeout(function (event) {
            return _this3.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
        }
      };

      $(this._element.querySelectorAll(Selector$2.ITEM_IMG)).on(Event$2.DRAG_START, function (e) {
        return e.preventDefault();
      });

      if (this._pointerEvent) {
        $(this._element).on(Event$2.POINTERDOWN, function (event) {
          return start(event);
        });
        $(this._element).on(Event$2.POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(ClassName$2.POINTER_EVENT);
      } else {
        $(this._element).on(Event$2.TOUCHSTART, function (event) {
          return start(event);
        });
        $(this._element).on(Event$2.TOUCHMOVE, function (event) {
          return move(event);
        });
        $(this._element).on(Event$2.TOUCHEND, function (event) {
          return end(event);
        });
      }
    };

    _proto._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;

        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;

        default:
      }
    };

    _proto._getItemIndex = function _getItemIndex(element) {
      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(Selector$2.ITEM)) : [];
      return this._items.indexOf(element);
    };

    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === Direction.NEXT;
      var isPrevDirection = direction === Direction.PREV;

      var activeIndex = this._getItemIndex(activeElement);

      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === Direction.PREV ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;
      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);

      var fromIndex = this._getItemIndex(this._element.querySelector(Selector$2.ACTIVE_ITEM));

      var slideEvent = $.Event(Event$2.SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });
      $(this._element).trigger(slideEvent);
      return slideEvent;
    };

    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(Selector$2.ACTIVE));
        $(indicators).removeClass(ClassName$2.ACTIVE);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $(nextIndicator).addClass(ClassName$2.ACTIVE);
        }
      }
    };

    _proto._slide = function _slide(direction, element) {
      var _this4 = this;

      var activeElement = this._element.querySelector(Selector$2.ACTIVE_ITEM);

      var activeElementIndex = this._getItemIndex(activeElement);

      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var nextElementIndex = this._getItemIndex(nextElement);

      var isCycling = Boolean(this._interval);
      var directionalClassName;
      var orderClassName;
      var eventDirectionName;

      if (direction === Direction.NEXT) {
        directionalClassName = ClassName$2.LEFT;
        orderClassName = ClassName$2.NEXT;
        eventDirectionName = Direction.LEFT;
      } else {
        directionalClassName = ClassName$2.RIGHT;
        orderClassName = ClassName$2.PREV;
        eventDirectionName = Direction.RIGHT;
      }

      if (nextElement && $(nextElement).hasClass(ClassName$2.ACTIVE)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      var slidEvent = $.Event(Event$2.SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });

      if ($(this._element).hasClass(ClassName$2.SLIDE)) {
        $(nextElement).addClass(orderClassName);
        Util.reflow(nextElement);
        $(activeElement).addClass(directionalClassName);
        $(nextElement).addClass(directionalClassName);
        var nextElementInterval = parseInt(nextElement.getAttribute('data-interval'), 10);

        if (nextElementInterval) {
          this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
          this._config.interval = nextElementInterval;
        } else {
          this._config.interval = this._config.defaultInterval || this._config.interval;
        }

        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
        $(activeElement).one(Util.TRANSITION_END, function () {
          $(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName$2.ACTIVE);
          $(activeElement).removeClass(ClassName$2.ACTIVE + " " + orderClassName + " " + directionalClassName);
          _this4._isSliding = false;
          setTimeout(function () {
            return $(_this4._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        $(activeElement).removeClass(ClassName$2.ACTIVE);
        $(nextElement).addClass(ClassName$2.ACTIVE);
        this._isSliding = false;
        $(this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    } // Static
    ;

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$2);

        var _config = _objectSpread({}, Default, $(this).data());

        if (typeof config === 'object') {
          _config = _objectSpread({}, _config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $(this).data(DATA_KEY$2, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (typeof data[action] === 'undefined') {
            throw new TypeError("No method named \"" + action + "\"");
          }

          data[action]();
        } else if (_config.interval && _config.ride) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $(selector)[0];

      if (!target || !$(target).hasClass(ClassName$2.CAROUSEL)) {
        return;
      }

      var config = _objectSpread({}, $(target).data(), $(this).data());

      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($(target), config);

      if (slideIndex) {
        $(target).data(DATA_KEY$2).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$2;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Carousel;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$2.CLICK_DATA_API, Selector$2.DATA_SLIDE, Carousel._dataApiClickHandler);
  $(window).on(Event$2.LOAD_DATA_API, function () {
    var carousels = [].slice.call(document.querySelectorAll(Selector$2.DATA_RIDE));

    for (var i = 0, len = carousels.length; i < len; i++) {
      var $carousel = $(carousels[i]);

      Carousel._jQueryInterface.call($carousel, $carousel.data());
    }
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$2] = Carousel._jQueryInterface;
  $.fn[NAME$2].Constructor = Carousel;

  $.fn[NAME$2].noConflict = function () {
    $.fn[NAME$2] = JQUERY_NO_CONFLICT$2;
    return Carousel._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$3 = 'collapse';
  var VERSION$3 = '4.3.1';
  var DATA_KEY$3 = 'bs.collapse';
  var EVENT_KEY$3 = "." + DATA_KEY$3;
  var DATA_API_KEY$3 = '.data-api';
  var JQUERY_NO_CONFLICT$3 = $.fn[NAME$3];
  var Default$1 = {
    toggle: true,
    parent: ''
  };
  var DefaultType$1 = {
    toggle: 'boolean',
    parent: '(string|element)'
  };
  var Event$3 = {
    SHOW: "show" + EVENT_KEY$3,
    SHOWN: "shown" + EVENT_KEY$3,
    HIDE: "hide" + EVENT_KEY$3,
    HIDDEN: "hidden" + EVENT_KEY$3,
    CLICK_DATA_API: "click" + EVENT_KEY$3 + DATA_API_KEY$3
  };
  var ClassName$3 = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };
  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };
  var Selector$3 = {
    ACTIVES: '.show, .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Collapse =
  /*#__PURE__*/
  function () {
    function Collapse(element, config) {
      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
      var toggleList = [].slice.call(document.querySelectorAll(Selector$3.DATA_TOGGLE));

      for (var i = 0, len = toggleList.length; i < len; i++) {
        var elem = toggleList[i];
        var selector = Util.getSelectorFromElement(elem);
        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
          return foundElem === element;
        });

        if (selector !== null && filterElement.length > 0) {
          this._selector = selector;

          this._triggerArray.push(elem);
        }
      }

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // Getters


    var _proto = Collapse.prototype;

    // Public
    _proto.toggle = function toggle() {
      if ($(this._element).hasClass(ClassName$3.SHOW)) {
        this.hide();
      } else {
        this.show();
      }
    };

    _proto.show = function show() {
      var _this = this;

      if (this._isTransitioning || $(this._element).hasClass(ClassName$3.SHOW)) {
        return;
      }

      var actives;
      var activesData;

      if (this._parent) {
        actives = [].slice.call(this._parent.querySelectorAll(Selector$3.ACTIVES)).filter(function (elem) {
          if (typeof _this._config.parent === 'string') {
            return elem.getAttribute('data-parent') === _this._config.parent;
          }

          return elem.classList.contains(ClassName$3.COLLAPSE);
        });

        if (actives.length === 0) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $(actives).not(this._selector).data(DATA_KEY$3);

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $.Event(Event$3.SHOW);
      $(this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($(actives).not(this._selector), 'hide');

        if (!activesData) {
          $(actives).data(DATA_KEY$3, null);
        }
      }

      var dimension = this._getDimension();

      $(this._element).removeClass(ClassName$3.COLLAPSE).addClass(ClassName$3.COLLAPSING);
      this._element.style[dimension] = 0;

      if (this._triggerArray.length) {
        $(this._triggerArray).removeClass(ClassName$3.COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $(_this._element).removeClass(ClassName$3.COLLAPSING).addClass(ClassName$3.COLLAPSE).addClass(ClassName$3.SHOW);
        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $(_this._element).trigger(Event$3.SHOWN);
      };

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll" + capitalizedDimension;
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      this._element.style[dimension] = this._element[scrollSize] + "px";
    };

    _proto.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning || !$(this._element).hasClass(ClassName$3.SHOW)) {
        return;
      }

      var startEvent = $.Event(Event$3.HIDE);
      $(this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
      Util.reflow(this._element);
      $(this._element).addClass(ClassName$3.COLLAPSING).removeClass(ClassName$3.COLLAPSE).removeClass(ClassName$3.SHOW);
      var triggerArrayLength = this._triggerArray.length;

      if (triggerArrayLength > 0) {
        for (var i = 0; i < triggerArrayLength; i++) {
          var trigger = this._triggerArray[i];
          var selector = Util.getSelectorFromElement(trigger);

          if (selector !== null) {
            var $elem = $([].slice.call(document.querySelectorAll(selector)));

            if (!$elem.hasClass(ClassName$3.SHOW)) {
              $(trigger).addClass(ClassName$3.COLLAPSED).attr('aria-expanded', false);
            }
          }
        }
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);

        $(_this2._element).removeClass(ClassName$3.COLLAPSING).addClass(ClassName$3.COLLAPSE).trigger(Event$3.HIDDEN);
      };

      this._element.style[dimension] = '';
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
    };

    _proto.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY$3);
      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, Default$1, config);
      config.toggle = Boolean(config.toggle); // Coerce string values

      Util.typeCheckConfig(NAME$3, config, DefaultType$1);
      return config;
    };

    _proto._getDimension = function _getDimension() {
      var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
    };

    _proto._getParent = function _getParent() {
      var _this3 = this;

      var parent;

      if (Util.isElement(this._config.parent)) {
        parent = this._config.parent; // It's a jQuery object

        if (typeof this._config.parent.jquery !== 'undefined') {
          parent = this._config.parent[0];
        }
      } else {
        parent = document.querySelector(this._config.parent);
      }

      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
      var children = [].slice.call(parent.querySelectorAll(selector));
      $(children).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });
      return parent;
    };

    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      var isOpen = $(element).hasClass(ClassName$3.SHOW);

      if (triggerArray.length) {
        $(triggerArray).toggleClass(ClassName$3.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
      }
    } // Static
    ;

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? document.querySelector(selector) : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY$3);

        var _config = _objectSpread({}, Default$1, $this.data(), typeof config === 'object' && config ? config : {});

        if (!data && _config.toggle && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $this.data(DATA_KEY$3, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$3;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$1;
      }
    }]);

    return Collapse;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$3.CLICK_DATA_API, Selector$3.DATA_TOGGLE, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }

    var $trigger = $(this);
    var selector = Util.getSelectorFromElement(this);
    var selectors = [].slice.call(document.querySelectorAll(selector));
    $(selectors).each(function () {
      var $target = $(this);
      var data = $target.data(DATA_KEY$3);
      var config = data ? 'toggle' : $trigger.data();

      Collapse._jQueryInterface.call($target, config);
    });
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$3] = Collapse._jQueryInterface;
  $.fn[NAME$3].Constructor = Collapse;

  $.fn[NAME$3].noConflict = function () {
    $.fn[NAME$3] = JQUERY_NO_CONFLICT$3;
    return Collapse._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$4 = 'dropdown';
  var VERSION$4 = '4.3.1';
  var DATA_KEY$4 = 'bs.dropdown';
  var EVENT_KEY$4 = "." + DATA_KEY$4;
  var DATA_API_KEY$4 = '.data-api';
  var JQUERY_NO_CONFLICT$4 = $.fn[NAME$4];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
  var Event$4 = {
    HIDE: "hide" + EVENT_KEY$4,
    HIDDEN: "hidden" + EVENT_KEY$4,
    SHOW: "show" + EVENT_KEY$4,
    SHOWN: "shown" + EVENT_KEY$4,
    CLICK: "click" + EVENT_KEY$4,
    CLICK_DATA_API: "click" + EVENT_KEY$4 + DATA_API_KEY$4,
    KEYDOWN_DATA_API: "keydown" + EVENT_KEY$4 + DATA_API_KEY$4,
    KEYUP_DATA_API: "keyup" + EVENT_KEY$4 + DATA_API_KEY$4
  };
  var ClassName$4 = {
    DISABLED: 'disabled',
    SHOW: 'show',
    DROPUP: 'dropup',
    DROPRIGHT: 'dropright',
    DROPLEFT: 'dropleft',
    MENURIGHT: 'dropdown-menu-right',
    MENULEFT: 'dropdown-menu-left',
    POSITION_STATIC: 'position-static'
  };
  var Selector$4 = {
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    MENU: '.dropdown-menu',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
  };
  var AttachmentMap = {
    TOP: 'top-start',
    TOPEND: 'top-end',
    BOTTOM: 'bottom-start',
    BOTTOMEND: 'bottom-end',
    RIGHT: 'right-start',
    RIGHTEND: 'right-end',
    LEFT: 'left-start',
    LEFTEND: 'left-end'
  };
  var Default$2 = {
    offset: 0,
    flip: true,
    boundary: 'scrollParent',
    reference: 'toggle',
    display: 'dynamic'
  };
  var DefaultType$2 = {
    offset: '(number|string|function)',
    flip: 'boolean',
    boundary: '(string|element)',
    reference: '(string|element)',
    display: 'string'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Dropdown =
  /*#__PURE__*/
  function () {
    function Dropdown(element, config) {
      this._element = element;
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();

      this._addEventListeners();
    } // Getters


    var _proto = Dropdown.prototype;

    // Public
    _proto.toggle = function toggle() {
      if (this._element.disabled || $(this._element).hasClass(ClassName$4.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this._element);

      var isActive = $(this._menu).hasClass(ClassName$4.SHOW);

      Dropdown._clearMenus();

      if (isActive) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $.Event(Event$4.SHOW, relatedTarget);
      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      } // Disable totally Popper.js for Dropdown in Navbar


      if (!this._inNavbar) {
        /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */
        if (typeof Popper === 'undefined') {
          throw new TypeError('Bootstrap\'s dropdowns require Popper.js (https://popper.js.org/)');
        }

        var referenceElement = this._element;

        if (this._config.reference === 'parent') {
          referenceElement = parent;
        } else if (Util.isElement(this._config.reference)) {
          referenceElement = this._config.reference; // Check if it's jQuery element

          if (typeof this._config.reference.jquery !== 'undefined') {
            referenceElement = this._config.reference[0];
          }
        } // If boundary is not `scrollParent`, then set position to `static`
        // to allow the menu to "escape" the scroll parent's boundaries
        // https://github.com/twbs/bootstrap/issues/24251


        if (this._config.boundary !== 'scrollParent') {
          $(parent).addClass(ClassName$4.POSITION_STATIC);
        }

        this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && $(parent).closest(Selector$4.NAVBAR_NAV).length === 0) {
        $(document.body).children().on('mouseover', null, $.noop);
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      $(this._menu).toggleClass(ClassName$4.SHOW);
      $(parent).toggleClass(ClassName$4.SHOW).trigger($.Event(Event$4.SHOWN, relatedTarget));
    };

    _proto.show = function show() {
      if (this._element.disabled || $(this._element).hasClass(ClassName$4.DISABLED) || $(this._menu).hasClass(ClassName$4.SHOW)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $.Event(Event$4.SHOW, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      $(this._menu).toggleClass(ClassName$4.SHOW);
      $(parent).toggleClass(ClassName$4.SHOW).trigger($.Event(Event$4.SHOWN, relatedTarget));
    };

    _proto.hide = function hide() {
      if (this._element.disabled || $(this._element).hasClass(ClassName$4.DISABLED) || !$(this._menu).hasClass(ClassName$4.SHOW)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var hideEvent = $.Event(Event$4.HIDE, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $(parent).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(this._menu).toggleClass(ClassName$4.SHOW);
      $(parent).toggleClass(ClassName$4.SHOW).trigger($.Event(Event$4.HIDDEN, relatedTarget));
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY$4);
      $(this._element).off(EVENT_KEY$4);
      this._element = null;
      this._menu = null;

      if (this._popper !== null) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    _proto.update = function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Private
    ;

    _proto._addEventListeners = function _addEventListeners() {
      var _this = this;

      $(this._element).on(Event$4.CLICK, function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.toggle();
      });
    };

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, this.constructor.Default, $(this._element).data(), config);
      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getMenuElement = function _getMenuElement() {
      if (!this._menu) {
        var parent = Dropdown._getParentFromElement(this._element);

        if (parent) {
          this._menu = parent.querySelector(Selector$4.MENU);
        }
      }

      return this._menu;
    };

    _proto._getPlacement = function _getPlacement() {
      var $parentDropdown = $(this._element.parentNode);
      var placement = AttachmentMap.BOTTOM; // Handle dropup

      if ($parentDropdown.hasClass(ClassName$4.DROPUP)) {
        placement = AttachmentMap.TOP;

        if ($(this._menu).hasClass(ClassName$4.MENURIGHT)) {
          placement = AttachmentMap.TOPEND;
        }
      } else if ($parentDropdown.hasClass(ClassName$4.DROPRIGHT)) {
        placement = AttachmentMap.RIGHT;
      } else if ($parentDropdown.hasClass(ClassName$4.DROPLEFT)) {
        placement = AttachmentMap.LEFT;
      } else if ($(this._menu).hasClass(ClassName$4.MENURIGHT)) {
        placement = AttachmentMap.BOTTOMEND;
      }

      return placement;
    };

    _proto._detectNavbar = function _detectNavbar() {
      return $(this._element).closest('.navbar').length > 0;
    };

    _proto._getOffset = function _getOffset() {
      var _this2 = this;

      var offset = {};

      if (typeof this._config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _objectSpread({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});
          return data;
        };
      } else {
        offset.offset = this._config.offset;
      }

      return offset;
    };

    _proto._getPopperConfig = function _getPopperConfig() {
      var popperConfig = {
        placement: this._getPlacement(),
        modifiers: {
          offset: this._getOffset(),
          flip: {
            enabled: this._config.flip
          },
          preventOverflow: {
            boundariesElement: this._config.boundary
          }
        } // Disable Popper.js if we have a static display

      };

      if (this._config.display === 'static') {
        popperConfig.modifiers.applyStyle = {
          enabled: false
        };
      }

      return popperConfig;
    } // Static
    ;

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$4);

        var _config = typeof config === 'object' ? config : null;

        if (!data) {
          data = new Dropdown(this, _config);
          $(this).data(DATA_KEY$4, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
        return;
      }

      var toggles = [].slice.call(document.querySelectorAll(Selector$4.DATA_TOGGLE));

      for (var i = 0, len = toggles.length; i < len; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);

        var context = $(toggles[i]).data(DATA_KEY$4);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (event && event.type === 'click') {
          relatedTarget.clickEvent = event;
        }

        if (!context) {
          continue;
        }

        var dropdownMenu = context._menu;

        if (!$(parent).hasClass(ClassName$4.SHOW)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $.contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $.Event(Event$4.HIDE, relatedTarget);
        $(parent).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          continue;
        } // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support


        if ('ontouchstart' in document.documentElement) {
          $(document.body).children().off('mouseover', null, $.noop);
        }

        toggles[i].setAttribute('aria-expanded', 'false');
        $(dropdownMenu).removeClass(ClassName$4.SHOW);
        $(parent).removeClass(ClassName$4.SHOW).trigger($.Event(Event$4.HIDDEN, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = document.querySelector(selector);
      }

      return parent || element.parentNode;
    } // eslint-disable-next-line complexity
    ;

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $(event.target).closest(Selector$4.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.disabled || $(this).hasClass(ClassName$4.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);

      var isActive = $(parent).hasClass(ClassName$4.SHOW);

      if (!isActive || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
        if (event.which === ESCAPE_KEYCODE) {
          var toggle = parent.querySelector(Selector$4.DATA_TOGGLE);
          $(toggle).trigger('focus');
        }

        $(this).trigger('click');
        return;
      }

      var items = [].slice.call(parent.querySelectorAll(Selector$4.VISIBLE_ITEMS));

      if (items.length === 0) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // Up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // Down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$4;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$2;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$2;
      }
    }]);

    return Dropdown;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$4.KEYDOWN_DATA_API, Selector$4.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event$4.KEYDOWN_DATA_API, Selector$4.MENU, Dropdown._dataApiKeydownHandler).on(Event$4.CLICK_DATA_API + " " + Event$4.KEYUP_DATA_API, Dropdown._clearMenus).on(Event$4.CLICK_DATA_API, Selector$4.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();

    Dropdown._jQueryInterface.call($(this), 'toggle');
  }).on(Event$4.CLICK_DATA_API, Selector$4.FORM_CHILD, function (e) {
    e.stopPropagation();
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$4] = Dropdown._jQueryInterface;
  $.fn[NAME$4].Constructor = Dropdown;

  $.fn[NAME$4].noConflict = function () {
    $.fn[NAME$4] = JQUERY_NO_CONFLICT$4;
    return Dropdown._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$5 = 'modal';
  var VERSION$5 = '4.3.1';
  var DATA_KEY$5 = 'bs.modal';
  var EVENT_KEY$5 = "." + DATA_KEY$5;
  var DATA_API_KEY$5 = '.data-api';
  var JQUERY_NO_CONFLICT$5 = $.fn[NAME$5];
  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default$3 = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType$3 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  var Event$5 = {
    HIDE: "hide" + EVENT_KEY$5,
    HIDDEN: "hidden" + EVENT_KEY$5,
    SHOW: "show" + EVENT_KEY$5,
    SHOWN: "shown" + EVENT_KEY$5,
    FOCUSIN: "focusin" + EVENT_KEY$5,
    RESIZE: "resize" + EVENT_KEY$5,
    CLICK_DISMISS: "click.dismiss" + EVENT_KEY$5,
    KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY$5,
    MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY$5,
    MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY$5,
    CLICK_DATA_API: "click" + EVENT_KEY$5 + DATA_API_KEY$5
  };
  var ClassName$5 = {
    SCROLLABLE: 'modal-dialog-scrollable',
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector$5 = {
    DIALOG: '.modal-dialog',
    MODAL_BODY: '.modal-body',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Modal =
  /*#__PURE__*/
  function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = element.querySelector(Selector$5.DIALOG);
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._scrollbarWidth = 0;
    } // Getters


    var _proto = Modal.prototype;

    // Public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isShown || this._isTransitioning) {
        return;
      }

      if ($(this._element).hasClass(ClassName$5.FADE)) {
        this._isTransitioning = true;
      }

      var showEvent = $.Event(Event$5.SHOW, {
        relatedTarget: relatedTarget
      });
      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      $(this._element).on(Event$5.CLICK_DISMISS, Selector$5.DATA_DISMISS, function (event) {
        return _this.hide(event);
      });
      $(this._dialog).on(Event$5.MOUSEDOWN_DISMISS, function () {
        $(_this._element).one(Event$5.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (!this._isShown || this._isTransitioning) {
        return;
      }

      var hideEvent = $.Event(Event$5.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = $(this._element).hasClass(ClassName$5.FADE);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $(document).off(Event$5.FOCUSIN);
      $(this._element).removeClass(ClassName$5.SHOW);
      $(this._element).off(Event$5.CLICK_DISMISS);
      $(this._dialog).off(Event$5.MOUSEDOWN_DISMISS);

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      [window, this._element, this._dialog].forEach(function (htmlElement) {
        return $(htmlElement).off(EVENT_KEY$5);
      });
      /**
       * `document` has 2 events `Event.FOCUSIN` and `Event.CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `Event.CLICK_DATA_API` event that should remain
       */

      $(document).off(Event$5.FOCUSIN);
      $.removeData(this._element, DATA_KEY$5);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._isTransitioning = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, Default$3, config);
      Util.typeCheckConfig(NAME$5, config, DefaultType$3);
      return config;
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this3 = this;

      var transition = $(this._element).hasClass(ClassName$5.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      if ($(this._dialog).hasClass(ClassName$5.SCROLLABLE)) {
        this._dialog.querySelector(Selector$5.MODAL_BODY).scrollTop = 0;
      } else {
        this._element.scrollTop = 0;
      }

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName$5.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event$5.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this3._config.focus) {
          _this3._element.focus();
        }

        _this3._isTransitioning = false;
        $(_this3._element).trigger(shownEvent);
      };

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this4 = this;

      $(document).off(Event$5.FOCUSIN) // Guard against infinite focus loop
      .on(Event$5.FOCUSIN, function (event) {
        if (document !== event.target && _this4._element !== event.target && $(_this4._element).has(event.target).length === 0) {
          _this4._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this5 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event$5.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE$1) {
            event.preventDefault();

            _this5.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event$5.KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $(window).on(Event$5.RESIZE, function (event) {
          return _this6.handleUpdate(event);
        });
      } else {
        $(window).off(Event$5.RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this7 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName$5.OPEN);

        _this7._resetAdjustments();

        _this7._resetScrollbar();

        $(_this7._element).trigger(Event$5.HIDDEN);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this8 = this;

      var animate = $(this._element).hasClass(ClassName$5.FADE) ? ClassName$5.FADE : '';

      if (this._isShown && this._config.backdrop) {
        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName$5.BACKDROP;

        if (animate) {
          this._backdrop.classList.add(animate);
        }

        $(this._backdrop).appendTo(document.body);
        $(this._element).on(Event$5.CLICK_DISMISS, function (event) {
          if (_this8._ignoreBackdropClick) {
            _this8._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this8._config.backdrop === 'static') {
            _this8._element.focus();
          } else {
            _this8.hide();
          }
        });

        if (animate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName$5.SHOW);

        if (!callback) {
          return;
        }

        if (!animate) {
          callback();
          return;
        }

        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName$5.SHOW);

        var callbackRemove = function callbackRemove() {
          _this8._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if ($(this._element).hasClass(ClassName$5.FADE)) {
          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------
    ;

    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this9 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        var fixedContent = [].slice.call(document.querySelectorAll(Selector$5.FIXED_CONTENT));
        var stickyContent = [].slice.call(document.querySelectorAll(Selector$5.STICKY_CONTENT)); // Adjust fixed content padding

        $(fixedContent).each(function (index, element) {
          var actualPadding = element.style.paddingRight;
          var calculatedPadding = $(element).css('padding-right');
          $(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $(stickyContent).each(function (index, element) {
          var actualMargin = element.style.marginRight;
          var calculatedMargin = $(element).css('margin-right');
          $(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $(document.body).css('padding-right');
        $(document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }

      $(document.body).addClass(ClassName$5.OPEN);
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      var fixedContent = [].slice.call(document.querySelectorAll(Selector$5.FIXED_CONTENT));
      $(fixedContent).each(function (index, element) {
        var padding = $(element).data('padding-right');
        $(element).removeData('padding-right');
        element.style.paddingRight = padding ? padding : '';
      }); // Restore sticky content

      var elements = [].slice.call(document.querySelectorAll("" + Selector$5.STICKY_CONTENT));
      $(elements).each(function (index, element) {
        var margin = $(element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $(element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $(document.body).data('padding-right');
      $(document.body).removeData('padding-right');
      document.body.style.paddingRight = padding ? padding : '';
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName$5.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    } // Static
    ;

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$5);

        var _config = _objectSpread({}, Default$3, $(this).data(), typeof config === 'object' && config ? config : {});

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY$5, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$5;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$3;
      }
    }]);

    return Modal;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$5.CLICK_DATA_API, Selector$5.DATA_TOGGLE, function (event) {
    var _this10 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = document.querySelector(selector);
    }

    var config = $(target).data(DATA_KEY$5) ? 'toggle' : _objectSpread({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event$5.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // Only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event$5.HIDDEN, function () {
        if ($(_this10).is(':visible')) {
          _this10.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$5] = Modal._jQueryInterface;
  $.fn[NAME$5].Constructor = Modal;

  $.fn[NAME$5].noConflict = function () {
    $.fn[NAME$5] = JQUERY_NO_CONFLICT$5;
    return Modal._jQueryInterface;
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.3.1): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */
  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
    /**
     * A pattern that recognizes a commonly useful subset of URLs that are safe.
     *
     * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
     */

  };
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */

  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase();

    if (allowedAttributeList.indexOf(attrName) !== -1) {
      if (uriAttrs.indexOf(attrName) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
      }

      return true;
    }

    var regExp = allowedAttributeList.filter(function (attrRegex) {
      return attrRegex instanceof RegExp;
    }); // Check if a regular expression validates the attribute.

    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true;
      }
    }

    return false;
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml;
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml);
    }

    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var whitelistKeys = Object.keys(whiteList);
    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));

    var _loop = function _loop(i, len) {
      var el = elements[i];
      var elName = el.nodeName.toLowerCase();

      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
        el.parentNode.removeChild(el);
        return "continue";
      }

      var attributeList = [].slice.call(el.attributes);
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
      attributeList.forEach(function (attr) {
        if (!allowedAttribute(attr, whitelistedAttributes)) {
          el.removeAttribute(attr.nodeName);
        }
      });
    };

    for (var i = 0, len = elements.length; i < len; i++) {
      var _ret = _loop(i, len);

      if (_ret === "continue") continue;
    }

    return createdDocument.body.innerHTML;
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$6 = 'tooltip';
  var VERSION$6 = '4.3.1';
  var DATA_KEY$6 = 'bs.tooltip';
  var EVENT_KEY$6 = "." + DATA_KEY$6;
  var JQUERY_NO_CONFLICT$6 = $.fn[NAME$6];
  var CLASS_PREFIX = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
  var DefaultType$4 = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string|function)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    whiteList: 'object'
  };
  var AttachmentMap$1 = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default$4 = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent',
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
  };
  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };
  var Event$6 = {
    HIDE: "hide" + EVENT_KEY$6,
    HIDDEN: "hidden" + EVENT_KEY$6,
    SHOW: "show" + EVENT_KEY$6,
    SHOWN: "shown" + EVENT_KEY$6,
    INSERTED: "inserted" + EVENT_KEY$6,
    CLICK: "click" + EVENT_KEY$6,
    FOCUSIN: "focusin" + EVENT_KEY$6,
    FOCUSOUT: "focusout" + EVENT_KEY$6,
    MOUSEENTER: "mouseenter" + EVENT_KEY$6,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$6
  };
  var ClassName$6 = {
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector$6 = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner',
    ARROW: '.arrow'
  };
  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Tooltip =
  /*#__PURE__*/
  function () {
    function Tooltip(element, config) {
      /**
       * Check for Popper dependency
       * Popper - https://popper.js.org
       */
      if (typeof Popper === 'undefined') {
        throw new TypeError('Bootstrap\'s tooltips require Popper.js (https://popper.js.org/)');
      } // private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($(this.getTipElement()).hasClass(ClassName$6.SHOW)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $.removeData(this.element, this.constructor.DATA_KEY);
      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper !== null) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $(this.element).trigger(showEvent);
        var shadowRoot = Util.findShadowRoot(this.element);
        var isInTheDom = $.contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName$6.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);

        var container = this._getContainer();

        $(tip).data(this.constructor.DATA_KEY, this);

        if (!$.contains(this.element.ownerDocument.documentElement, this.tip)) {
          $(tip).appendTo(container);
        }

        $(this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper(this.element, tip, {
          placement: attachment,
          modifiers: {
            offset: this._getOffset(),
            flip: {
              behavior: this.config.fallbackPlacement
            },
            arrow: {
              element: Selector$6.ARROW
            },
            preventOverflow: {
              boundariesElement: this.config.boundary
            }
          },
          onCreate: function onCreate(data) {
            if (data.originalPlacement !== data.placement) {
              _this._handlePopperPlacementChange(data);
            }
          },
          onUpdate: function onUpdate(data) {
            return _this._handlePopperPlacementChange(data);
          }
        });
        $(tip).addClass(ClassName$6.SHOW); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $(document.body).children().on('mouseover', null, $.noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $(_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this._leave(null, _this);
          }
        };

        if ($(this.tip).hasClass(ClassName$6.FADE)) {
          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName$6.SHOW); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $(document.body).children().off('mouseover', null, $.noop);
      }

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if ($(this.tip).hasClass(ClassName$6.FADE)) {
        var transitionDuration = Util.getTransitionDurationFromElement(tip);
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Protected
    ;

    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $(this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var tip = this.getTipElement();
      this.setElementContent($(tip.querySelectorAll(Selector$6.TOOLTIP_INNER)), this.getTitle());
      $(tip).removeClass(ClassName$6.FADE + " " + ClassName$6.SHOW);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (this.config.html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }

        return;
      }

      if (this.config.html) {
        if (this.config.sanitize) {
          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
        }

        $element.html(content);
      } else {
        $element.text(content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    } // Private
    ;

    _proto._getOffset = function _getOffset() {
      var _this3 = this;

      var offset = {};

      if (typeof this.config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _objectSpread({}, data.offsets, _this3.config.offset(data.offsets, _this3.element) || {});
          return data;
        };
      } else {
        offset.offset = this.config.offset;
      }

      return offset;
    };

    _proto._getContainer = function _getContainer() {
      if (this.config.container === false) {
        return document.body;
      }

      if (Util.isElement(this.config.container)) {
        return $(this.config.container);
      }

      return $(document).find(this.config.container);
    };

    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap$1[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this4 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this4.element).on(_this4.constructor.Event.CLICK, _this4.config.selector, function (event) {
            return _this4.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSEENTER : _this4.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSELEAVE : _this4.constructor.Event.FOCUSOUT;
          $(_this4.element).on(eventIn, _this4.config.selector, function (event) {
            return _this4._enter(event);
          }).on(eventOut, _this4.config.selector, function (event) {
            return _this4._leave(event);
          });
        }
      });
      $(this.element).closest('.modal').on('hide.bs.modal', function () {
        if (_this4.element) {
          _this4.hide();
        }
      });

      if (this.config.selector) {
        this.config = _objectSpread({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName$6.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      var dataAttributes = $(this.element).data();
      Object.keys(dataAttributes).forEach(function (dataAttr) {
        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
          delete dataAttributes[dataAttr];
        }
      });
      config = _objectSpread({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);

      if (config.sanitize) {
        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
      }

      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $(this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
      var popperInstance = popperData.instance;
      this.tip = popperInstance.popper;

      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(popperData.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $(tip).removeClass(ClassName$6.FADE);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    } // Static
    ;

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$6);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY$6, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$6;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$4;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$6;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$6;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event$6;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$6;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$4;
      }
    }]);

    return Tooltip;
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME$6] = Tooltip._jQueryInterface;
  $.fn[NAME$6].Constructor = Tooltip;

  $.fn[NAME$6].noConflict = function () {
    $.fn[NAME$6] = JQUERY_NO_CONFLICT$6;
    return Tooltip._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$7 = 'popover';
  var VERSION$7 = '4.3.1';
  var DATA_KEY$7 = 'bs.popover';
  var EVENT_KEY$7 = "." + DATA_KEY$7;
  var JQUERY_NO_CONFLICT$7 = $.fn[NAME$7];
  var CLASS_PREFIX$1 = 'bs-popover';
  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');

  var Default$5 = _objectSpread({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
  });

  var DefaultType$5 = _objectSpread({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var ClassName$7 = {
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector$7 = {
    TITLE: '.popover-header',
    CONTENT: '.popover-body'
  };
  var Event$7 = {
    HIDE: "hide" + EVENT_KEY$7,
    HIDDEN: "hidden" + EVENT_KEY$7,
    SHOW: "show" + EVENT_KEY$7,
    SHOWN: "shown" + EVENT_KEY$7,
    INSERTED: "inserted" + EVENT_KEY$7,
    CLICK: "click" + EVENT_KEY$7,
    FOCUSIN: "focusin" + EVENT_KEY$7,
    FOCUSOUT: "focusout" + EVENT_KEY$7,
    MOUSEENTER: "mouseenter" + EVENT_KEY$7,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$7
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Popover =
  /*#__PURE__*/
  function (_Tooltip) {
    _inheritsLoose(Popover, _Tooltip);

    function Popover() {
      return _Tooltip.apply(this, arguments) || this;
    }

    var _proto = Popover.prototype;

    // Overrides
    _proto.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $(this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $(this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $(this.getTipElement()); // We use append for html objects to maintain js events

      this.setElementContent($tip.find(Selector$7.TITLE), this.getTitle());

      var content = this._getContent();

      if (typeof content === 'function') {
        content = content.call(this.element);
      }

      this.setElementContent($tip.find(Selector$7.CONTENT), content);
      $tip.removeClass(ClassName$7.FADE + " " + ClassName$7.SHOW);
    } // Private
    ;

    _proto._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || this.config.content;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $(this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    } // Static
    ;

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$7);

        var _config = typeof config === 'object' ? config : null;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $(this).data(DATA_KEY$7, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: "VERSION",
      // Getters
      get: function get() {
        return VERSION$7;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$5;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$7;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$7;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event$7;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$7;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$5;
      }
    }]);

    return Popover;
  }(Tooltip);
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME$7] = Popover._jQueryInterface;
  $.fn[NAME$7].Constructor = Popover;

  $.fn[NAME$7].noConflict = function () {
    $.fn[NAME$7] = JQUERY_NO_CONFLICT$7;
    return Popover._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$8 = 'scrollspy';
  var VERSION$8 = '4.3.1';
  var DATA_KEY$8 = 'bs.scrollspy';
  var EVENT_KEY$8 = "." + DATA_KEY$8;
  var DATA_API_KEY$6 = '.data-api';
  var JQUERY_NO_CONFLICT$8 = $.fn[NAME$8];
  var Default$6 = {
    offset: 10,
    method: 'auto',
    target: ''
  };
  var DefaultType$6 = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };
  var Event$8 = {
    ACTIVATE: "activate" + EVENT_KEY$8,
    SCROLL: "scroll" + EVENT_KEY$8,
    LOAD_DATA_API: "load" + EVENT_KEY$8 + DATA_API_KEY$6
  };
  var ClassName$8 = {
    DROPDOWN_ITEM: 'dropdown-item',
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active'
  };
  var Selector$8 = {
    DATA_SPY: '[data-spy="scroll"]',
    ACTIVE: '.active',
    NAV_LIST_GROUP: '.nav, .list-group',
    NAV_LINKS: '.nav-link',
    NAV_ITEMS: '.nav-item',
    LIST_ITEMS: '.list-group-item',
    DROPDOWN: '.dropdown',
    DROPDOWN_ITEMS: '.dropdown-item',
    DROPDOWN_TOGGLE: '.dropdown-toggle'
  };
  var OffsetMethod = {
    OFFSET: 'offset',
    POSITION: 'position'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var ScrollSpy =
  /*#__PURE__*/
  function () {
    function ScrollSpy(element, config) {
      var _this = this;

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + " " + Selector$8.NAV_LINKS + "," + (this._config.target + " " + Selector$8.LIST_ITEMS + ",") + (this._config.target + " " + Selector$8.DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;
      $(this._scrollElement).on(Event$8.SCROLL, function (event) {
        return _this._process(event);
      });
      this.refresh();

      this._process();
    } // Getters


    var _proto = ScrollSpy.prototype;

    // Public
    _proto.refresh = function refresh() {
      var _this2 = this;

      var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = [].slice.call(document.querySelectorAll(this._selector));
      targets.map(function (element) {
        var target;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = document.querySelector(targetSelector);
        }

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            // TODO (fat): remove sketch reliance on jQuery position/offset
            return [$(target)[offsetMethod]().top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this2._offsets.push(item[0]);

        _this2._targets.push(item[1]);
      });
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY$8);
      $(this._scrollElement).off(EVENT_KEY$8);
      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, Default$6, typeof config === 'object' && config ? config : {});

      if (typeof config.target !== 'string') {
        var id = $(config.target).attr('id');

        if (!id) {
          id = Util.getUID(NAME$8);
          $(config.target).attr('id', id);
        }

        config.target = "#" + id;
      }

      Util.typeCheckConfig(NAME$8, config, DefaultType$6);
      return config;
    };

    _proto._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    _proto._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    _proto._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    };

    _proto._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      var offsetLength = this._offsets.length;

      for (var i = offsetLength; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    _proto._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',').map(function (selector) {
        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
      });

      var $link = $([].slice.call(document.querySelectorAll(queries.join(','))));

      if ($link.hasClass(ClassName$8.DROPDOWN_ITEM)) {
        $link.closest(Selector$8.DROPDOWN).find(Selector$8.DROPDOWN_TOGGLE).addClass(ClassName$8.ACTIVE);
        $link.addClass(ClassName$8.ACTIVE);
      } else {
        // Set triggered link as active
        $link.addClass(ClassName$8.ACTIVE); // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

        $link.parents(Selector$8.NAV_LIST_GROUP).prev(Selector$8.NAV_LINKS + ", " + Selector$8.LIST_ITEMS).addClass(ClassName$8.ACTIVE); // Handle special case when .nav-link is inside .nav-item

        $link.parents(Selector$8.NAV_LIST_GROUP).prev(Selector$8.NAV_ITEMS).children(Selector$8.NAV_LINKS).addClass(ClassName$8.ACTIVE);
      }

      $(this._scrollElement).trigger(Event$8.ACTIVATE, {
        relatedTarget: target
      });
    };

    _proto._clear = function _clear() {
      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
        return node.classList.contains(ClassName$8.ACTIVE);
      }).forEach(function (node) {
        return node.classList.remove(ClassName$8.ACTIVE);
      });
    } // Static
    ;

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY$8);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $(this).data(DATA_KEY$8, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$8;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$6;
      }
    }]);

    return ScrollSpy;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(window).on(Event$8.LOAD_DATA_API, function () {
    var scrollSpys = [].slice.call(document.querySelectorAll(Selector$8.DATA_SPY));
    var scrollSpysLength = scrollSpys.length;

    for (var i = scrollSpysLength; i--;) {
      var $spy = $(scrollSpys[i]);

      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$8] = ScrollSpy._jQueryInterface;
  $.fn[NAME$8].Constructor = ScrollSpy;

  $.fn[NAME$8].noConflict = function () {
    $.fn[NAME$8] = JQUERY_NO_CONFLICT$8;
    return ScrollSpy._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$9 = 'tab';
  var VERSION$9 = '4.3.1';
  var DATA_KEY$9 = 'bs.tab';
  var EVENT_KEY$9 = "." + DATA_KEY$9;
  var DATA_API_KEY$7 = '.data-api';
  var JQUERY_NO_CONFLICT$9 = $.fn[NAME$9];
  var Event$9 = {
    HIDE: "hide" + EVENT_KEY$9,
    HIDDEN: "hidden" + EVENT_KEY$9,
    SHOW: "show" + EVENT_KEY$9,
    SHOWN: "shown" + EVENT_KEY$9,
    CLICK_DATA_API: "click" + EVENT_KEY$9 + DATA_API_KEY$7
  };
  var ClassName$9 = {
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector$9 = {
    DROPDOWN: '.dropdown',
    NAV_LIST_GROUP: '.nav, .list-group',
    ACTIVE: '.active',
    ACTIVE_UL: '> li > .active',
    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
    DROPDOWN_TOGGLE: '.dropdown-toggle',
    DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Tab =
  /*#__PURE__*/
  function () {
    function Tab(element) {
      this._element = element;
    } // Getters


    var _proto = Tab.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName$9.ACTIVE) || $(this._element).hasClass(ClassName$9.DISABLED)) {
        return;
      }

      var target;
      var previous;
      var listElement = $(this._element).closest(Selector$9.NAV_LIST_GROUP)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? Selector$9.ACTIVE_UL : Selector$9.ACTIVE;
        previous = $.makeArray($(listElement).find(itemSelector));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $.Event(Event$9.HIDE, {
        relatedTarget: this._element
      });
      var showEvent = $.Event(Event$9.SHOW, {
        relatedTarget: previous
      });

      if (previous) {
        $(previous).trigger(hideEvent);
      }

      $(this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = document.querySelector(selector);
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $.Event(Event$9.HIDDEN, {
          relatedTarget: _this._element
        });
        var shownEvent = $.Event(Event$9.SHOWN, {
          relatedTarget: previous
        });
        $(previous).trigger(hiddenEvent);
        $(_this._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY$9);
      this._element = null;
    } // Private
    ;

    _proto._activate = function _activate(element, container, callback) {
      var _this2 = this;

      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $(container).find(Selector$9.ACTIVE_UL) : $(container).children(Selector$9.ACTIVE);
      var active = activeElements[0];
      var isTransitioning = callback && active && $(active).hasClass(ClassName$9.FADE);

      var complete = function complete() {
        return _this2._transitionComplete(element, active, callback);
      };

      if (active && isTransitioning) {
        var transitionDuration = Util.getTransitionDurationFromElement(active);
        $(active).removeClass(ClassName$9.SHOW).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
      if (active) {
        $(active).removeClass(ClassName$9.ACTIVE);
        var dropdownChild = $(active.parentNode).find(Selector$9.DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $(dropdownChild).removeClass(ClassName$9.ACTIVE);
        }

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      $(element).addClass(ClassName$9.ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      Util.reflow(element);

      if (element.classList.contains(ClassName$9.FADE)) {
        element.classList.add(ClassName$9.SHOW);
      }

      if (element.parentNode && $(element.parentNode).hasClass(ClassName$9.DROPDOWN_MENU)) {
        var dropdownElement = $(element).closest(Selector$9.DROPDOWN)[0];

        if (dropdownElement) {
          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(Selector$9.DROPDOWN_TOGGLE));
          $(dropdownToggleList).addClass(ClassName$9.ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    } // Static
    ;

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY$9);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY$9, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$9;
      }
    }]);

    return Tab;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event$9.CLICK_DATA_API, Selector$9.DATA_TOGGLE, function (event) {
    event.preventDefault();

    Tab._jQueryInterface.call($(this), 'show');
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME$9] = Tab._jQueryInterface;
  $.fn[NAME$9].Constructor = Tab;

  $.fn[NAME$9].noConflict = function () {
    $.fn[NAME$9] = JQUERY_NO_CONFLICT$9;
    return Tab._jQueryInterface;
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME$a = 'toast';
  var VERSION$a = '4.3.1';
  var DATA_KEY$a = 'bs.toast';
  var EVENT_KEY$a = "." + DATA_KEY$a;
  var JQUERY_NO_CONFLICT$a = $.fn[NAME$a];
  var Event$a = {
    CLICK_DISMISS: "click.dismiss" + EVENT_KEY$a,
    HIDE: "hide" + EVENT_KEY$a,
    HIDDEN: "hidden" + EVENT_KEY$a,
    SHOW: "show" + EVENT_KEY$a,
    SHOWN: "shown" + EVENT_KEY$a
  };
  var ClassName$a = {
    FADE: 'fade',
    HIDE: 'hide',
    SHOW: 'show',
    SHOWING: 'showing'
  };
  var DefaultType$7 = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
  };
  var Default$7 = {
    animation: true,
    autohide: true,
    delay: 500
  };
  var Selector$a = {
    DATA_DISMISS: '[data-dismiss="toast"]'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Toast =
  /*#__PURE__*/
  function () {
    function Toast(element, config) {
      this._element = element;
      this._config = this._getConfig(config);
      this._timeout = null;

      this._setListeners();
    } // Getters


    var _proto = Toast.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      $(this._element).trigger(Event$a.SHOW);

      if (this._config.animation) {
        this._element.classList.add(ClassName$a.FADE);
      }

      var complete = function complete() {
        _this._element.classList.remove(ClassName$a.SHOWING);

        _this._element.classList.add(ClassName$a.SHOW);

        $(_this._element).trigger(Event$a.SHOWN);

        if (_this._config.autohide) {
          _this.hide();
        }
      };

      this._element.classList.remove(ClassName$a.HIDE);

      this._element.classList.add(ClassName$a.SHOWING);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto.hide = function hide(withoutTimeout) {
      var _this2 = this;

      if (!this._element.classList.contains(ClassName$a.SHOW)) {
        return;
      }

      $(this._element).trigger(Event$a.HIDE);

      if (withoutTimeout) {
        this._close();
      } else {
        this._timeout = setTimeout(function () {
          _this2._close();
        }, this._config.delay);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      this._timeout = null;

      if (this._element.classList.contains(ClassName$a.SHOW)) {
        this._element.classList.remove(ClassName$a.SHOW);
      }

      $(this._element).off(Event$a.CLICK_DISMISS);
      $.removeData(this._element, DATA_KEY$a);
      this._element = null;
      this._config = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _objectSpread({}, Default$7, $(this._element).data(), typeof config === 'object' && config ? config : {});
      Util.typeCheckConfig(NAME$a, config, this.constructor.DefaultType);
      return config;
    };

    _proto._setListeners = function _setListeners() {
      var _this3 = this;

      $(this._element).on(Event$a.CLICK_DISMISS, Selector$a.DATA_DISMISS, function () {
        return _this3.hide(true);
      });
    };

    _proto._close = function _close() {
      var _this4 = this;

      var complete = function complete() {
        _this4._element.classList.add(ClassName$a.HIDE);

        $(_this4._element).trigger(Event$a.HIDDEN);
      };

      this._element.classList.remove(ClassName$a.SHOW);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    } // Static
    ;

    Toast._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);
        var data = $element.data(DATA_KEY$a);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new Toast(this, _config);
          $element.data(DATA_KEY$a, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](this);
        }
      });
    };

    _createClass(Toast, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$a;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$7;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$7;
      }
    }]);

    return Toast;
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME$a] = Toast._jQueryInterface;
  $.fn[NAME$a].Constructor = Toast;

  $.fn[NAME$a].noConflict = function () {
    $.fn[NAME$a] = JQUERY_NO_CONFLICT$a;
    return Toast._jQueryInterface;
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.3.1): index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  (function () {
    if (typeof $ === 'undefined') {
      throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
    }

    var version = $.fn.jquery.split(' ')[0].split('.');
    var minMajor = 1;
    var ltMajor = 2;
    var minMinor = 9;
    var minPatch = 1;
    var maxMajor = 4;

    if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
      throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
    }
  })();

  exports.Util = Util;
  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=bootstrap.js.map

(function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ];

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

  function allowedAttribute (attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml (unsafeElements, whiteList, sanitizeFn) {
    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeElements);
    }

    var whitelistKeys = Object.keys(whiteList);

    for (var i = 0, len = unsafeElements.length; i < len; i++) {
      var elements = unsafeElements[i].querySelectorAll('*');

      for (var j = 0, len2 = elements.length; j < len2; j++) {
        var el = elements[j];
        var elName = el.nodeName.toLowerCase();

        if (whitelistKeys.indexOf(elName) === -1) {
          el.parentNode.removeChild(el);

          continue;
        }

        var attributeList = [].slice.call(el.attributes);
        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
          var attr = attributeList[k];

          if (!allowedAttribute(attr, whitelistedAttributes)) {
            el.removeAttribute(attr.nodeName);
          }
        }
      }
    }
  }

  // Polyfill for browsers with no classList support
  // Remove in v2
  if (!('classList' in document.createElement('_'))) {
    (function (view) {
      if (!('Element' in view)) return;

      var classListProp = 'classList',
          protoProp = 'prototype',
          elemCtrProto = view.Element[protoProp],
          objCtr = Object,
          classListGetter = function () {
            var $elem = $(this);

            return {
              add: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.addClass(classes);
              },
              remove: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.removeClass(classes);
              },
              toggle: function (classes, force) {
                return $elem.toggleClass(classes, force);
              },
              contains: function (classes) {
                return $elem.hasClass(classes);
              }
            }
          };

      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter,
          enumerable: true,
          configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) { // IE 8 doesn't support enumerable:true
          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }
    }(window));
  }

  var testElement = document.createElement('_');

  testElement.classList.add('c1', 'c2');

  if (!testElement.classList.contains('c2')) {
    var _add = DOMTokenList.prototype.add,
        _remove = DOMTokenList.prototype.remove;

    DOMTokenList.prototype.add = function () {
      Array.prototype.forEach.call(arguments, _add.bind(this));
    }

    DOMTokenList.prototype.remove = function () {
      Array.prototype.forEach.call(arguments, _remove.bind(this));
    }
  }

  testElement.classList.toggle('c3', false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains('c3')) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function (token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };
  }

  testElement = null;

  // shallow array comparison
  function isEqual (array1, array2) {
    return array1.length === array2.length && array1.every(function (element, index) {
      return element === array2[index];
    });
  };

  // <editor-fold desc="Shims">
  if (!String.prototype.startsWith) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var toString = {}.toString;
      var startsWith = function (search) {
        if (this == null) {
          throw new TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw new TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        var index = -1;
        while (++index < searchLength) {
          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
            return false;
          }
        }
        return true;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'startsWith', {
          'value': startsWith,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.startsWith = startsWith;
      }
    }());
  }

  if (!Object.keys) {
    Object.keys = function (
      o, // object
      k, // key
      r  // result array
    ) {
      // initialize object and result
      r = [];
      // iterate over object keys
      for (k in o) {
        // fill result array with non-prototypical keys
        r.hasOwnProperty.call(o, k) && r.push(k);
      }
      // return result
      return r;
    };
  }

  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
      get: function () {
        return this.querySelectorAll(':checked');
      }
    });
  }

  function getSelectedOptions (select, ignoreDisabled) {
    var selectedOptions = select.selectedOptions,
        options = [],
        opt;

    if (ignoreDisabled) {
      for (var i = 0, len = selectedOptions.length; i < len; i++) {
        opt = selectedOptions[i];

        if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
          options.push(opt);
        }
      }

      return options;
    }

    return selectedOptions;
  }

  // much faster than $.val()
  function getSelectValues (select, selectedOptions) {
    var value = [],
        options = selectedOptions || select.selectedOptions,
        opt;

    for (var i = 0, len = options.length; i < len; i++) {
      opt = options[i];

      if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
        value.push(opt.value || opt.text);
      }
    }

    if (!select.multiple) {
      return !value.length ? null : value[0];
    }

    return value;
  }

  // set data-selected on select element if the value has been programmatically selected
  // prior to initialization of bootstrap-select
  // * consider removing or replacing an alternative method *
  var valHooks = {
    useDefault: false,
    _set: $.valHooks.select.set
  };

  $.valHooks.select.set = function (elem, value) {
    if (value && !valHooks.useDefault) $(elem).data('selected', true);

    return valHooks._set.apply(this, arguments);
  };

  var changedArguments = null;

  var EventIsSupported = (function () {
    try {
      new Event('change');
      return true;
    } catch (e) {
      return false;
    }
  })();

  $.fn.triggerNative = function (eventName) {
    var el = this[0],
        event;

    if (el.dispatchEvent) { // for modern browsers & IE9+
      if (EventIsSupported) {
        // For modern browsers
        event = new Event(eventName, {
          bubbles: true
        });
      } else {
        // For IE since it doesn't support Event constructor
        event = document.createEvent('Event');
        event.initEvent(eventName, true, false);
      }

      el.dispatchEvent(event);
    } else if (el.fireEvent) { // for IE8
      event = document.createEventObject();
      event.eventType = eventName;
      el.fireEvent('on' + eventName, event);
    } else {
      // fall back to jQuery.trigger
      this.trigger(eventName);
    }
  };
  // </editor-fold>

  function stringSearch (li, searchString, method, normalize) {
    var stringTypes = [
          'display',
          'subtext',
          'tokens'
        ],
        searchSuccess = false;

    for (var i = 0; i < stringTypes.length; i++) {
      var stringType = stringTypes[i],
          string = li[stringType];

      if (string) {
        string = string.toString();

        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
        if (stringType === 'display') {
          string = string.replace(/<[^>]+>/g, '');
        }

        if (normalize) string = normalizeToBase(string);
        string = string.toUpperCase();

        if (method === 'contains') {
          searchSuccess = string.indexOf(searchString) >= 0;
        } else {
          searchSuccess = string.startsWith(searchString);
        }

        if (searchSuccess) break;
      }
    }

    return searchSuccess;
  }

  function toInteger (value) {
    return parseInt(value, 10) || 0;
  }

  // Borrowed from Lodash (_.deburr)
  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to compose unicode character classes. */
  var rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;

  /** Used to compose unicode capture groups. */
  var rsCombo = '[' + rsComboRange + ']';

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  function deburrLetter (key) {
    return deburredLetters[key];
  };

  function normalizeToBase (string) {
    string = string.toString();
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
  }

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function (map) {
    var escaper = function (match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function (string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };

  var htmlEscape = createEscaper(escapeMap);

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var keyCodeMap = {
    32: ' ',
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    59: ';',
    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',
    96: '0',
    97: '1',
    98: '2',
    99: '3',
    100: '4',
    101: '5',
    102: '6',
    103: '7',
    104: '8',
    105: '9'
  };

  var keyCodes = {
    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
    ENTER: 13, // KeyboardEvent.which value for Enter key
    SPACE: 32, // KeyboardEvent.which value for space key
    TAB: 9, // KeyboardEvent.which value for tab key
    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
  }

  var version = {
    success: false,
    major: '3'
  };

  try {
    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
    version.major = version.full[0];
    version.success = true;
  } catch (err) {
    // do nothing
  }

  var selectId = 0;

  var EVENT_KEY = '.bs.select';

  var classNames = {
    DISABLED: 'disabled',
    DIVIDER: 'divider',
    SHOW: 'open',
    DROPUP: 'dropup',
    MENU: 'dropdown-menu',
    MENURIGHT: 'dropdown-menu-right',
    MENULEFT: 'dropdown-menu-left',
    // to-do: replace with more advanced template/customization options
    BUTTONCLASS: 'btn-default',
    POPOVERHEADER: 'popover-title',
    ICONBASE: 'glyphicon',
    TICKICON: 'glyphicon-ok'
  }

  var Selector = {
    MENU: '.' + classNames.MENU
  }

  var elementTemplates = {
    span: document.createElement('span'),
    i: document.createElement('i'),
    subtext: document.createElement('small'),
    a: document.createElement('a'),
    li: document.createElement('li'),
    whitespace: document.createTextNode('\u00A0'),
    fragment: document.createDocumentFragment()
  }

  elementTemplates.a.setAttribute('role', 'option');
  elementTemplates.subtext.className = 'text-muted';

  elementTemplates.text = elementTemplates.span.cloneNode(false);
  elementTemplates.text.className = 'text';

  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);

  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);

  var generateOption = {
    li: function (content, classes, optgroup) {
      var li = elementTemplates.li.cloneNode(false);

      if (content) {
        if (content.nodeType === 1 || content.nodeType === 11) {
          li.appendChild(content);
        } else {
          li.innerHTML = content;
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);

      return li;
    },

    a: function (text, classes, inline) {
      var a = elementTemplates.a.cloneNode(true);

      if (text) {
        if (text.nodeType === 11) {
          a.appendChild(text);
        } else {
          a.insertAdjacentHTML('beforeend', text);
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') a.className = classes;
      if (version.major === '4') a.classList.add('dropdown-item');
      if (inline) a.setAttribute('style', inline);

      return a;
    },

    text: function (options, useFragment) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      if (options.content) {
        textElement.innerHTML = options.content;
      } else {
        textElement.textContent = options.text;

        if (options.icon) {
          var whitespace = elementTemplates.whitespace.cloneNode(false);

          // need to use <i> for icons in the button to prevent a breaking change
          // note: switch to span in next major release
          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
          iconElement.className = options.iconBase + ' ' + options.icon;

          elementTemplates.fragment.appendChild(iconElement);
          elementTemplates.fragment.appendChild(whitespace);
        }

        if (options.subtext) {
          subtextElement = elementTemplates.subtext.cloneNode(false);
          subtextElement.textContent = options.subtext;
          textElement.appendChild(subtextElement);
        }
      }

      if (useFragment === true) {
        while (textElement.childNodes.length > 0) {
          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
        }
      } else {
        elementTemplates.fragment.appendChild(textElement);
      }

      return elementTemplates.fragment;
    },

    label: function (options) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      textElement.innerHTML = options.label;

      if (options.icon) {
        var whitespace = elementTemplates.whitespace.cloneNode(false);

        iconElement = elementTemplates.span.cloneNode(false);
        iconElement.className = options.iconBase + ' ' + options.icon;

        elementTemplates.fragment.appendChild(iconElement);
        elementTemplates.fragment.appendChild(whitespace);
      }

      if (options.subtext) {
        subtextElement = elementTemplates.subtext.cloneNode(false);
        subtextElement.textContent = options.subtext;
        textElement.appendChild(subtextElement);
      }

      elementTemplates.fragment.appendChild(textElement);

      return elementTemplates.fragment;
    }
  }

  var Selectpicker = function (element, options) {
    var that = this;

    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
    if (!valHooks.useDefault) {
      $.valHooks.select.set = valHooks._set;
      valHooks.useDefault = true;
    }

    this.$element = $(element);
    this.$newElement = null;
    this.$button = null;
    this.$menu = null;
    this.options = options;
    this.selectpicker = {
      main: {},
      search: {},
      current: {}, // current changes if a search is in progress
      view: {},
      keydown: {
        keyHistory: '',
        resetKeyHistory: {
          start: function () {
            return setTimeout(function () {
              that.selectpicker.keydown.keyHistory = '';
            }, 800);
          }
        }
      }
    };
    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
    // data-attribute)
    if (this.options.title === null) {
      this.options.title = this.$element.attr('title');
    }

    // Format window padding
    var winPad = this.options.windowPadding;
    if (typeof winPad === 'number') {
      this.options.windowPadding = [winPad, winPad, winPad, winPad];
    }

    // Expose public methods
    this.val = Selectpicker.prototype.val;
    this.render = Selectpicker.prototype.render;
    this.refresh = Selectpicker.prototype.refresh;
    this.setStyle = Selectpicker.prototype.setStyle;
    this.selectAll = Selectpicker.prototype.selectAll;
    this.deselectAll = Selectpicker.prototype.deselectAll;
    this.destroy = Selectpicker.prototype.destroy;
    this.remove = Selectpicker.prototype.remove;
    this.show = Selectpicker.prototype.show;
    this.hide = Selectpicker.prototype.hide;

    this.init();
  };

  Selectpicker.VERSION = '1.13.10';

  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
  Selectpicker.DEFAULTS = {
    noneSelectedText: 'Nothing selected',
    noneResultsText: 'No results matched {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? '{0} item selected' : '{0} items selected';
    },
    maxOptionsText: function (numAll, numGroup) {
      return [
        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
      ];
    },
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    doneButton: false,
    doneButtonText: 'Close',
    multipleSeparator: ', ',
    styleBase: 'btn',
    style: classNames.BUTTONCLASS,
    size: 'auto',
    title: null,
    selectedTextFormat: 'values',
    width: false,
    container: false,
    hideDisabled: false,
    showSubtext: false,
    showIcon: true,
    showContent: true,
    dropupAuto: true,
    header: false,
    liveSearch: false,
    liveSearchPlaceholder: null,
    liveSearchNormalize: false,
    liveSearchStyle: 'contains',
    actionsBox: false,
    iconBase: classNames.ICONBASE,
    tickIcon: classNames.TICKICON,
    showTick: false,
    template: {
      caret: '<span class="caret"></span>'
    },
    maxOptions: false,
    mobile: false,
    selectOnTab: false,
    dropdownAlignRight: false,
    windowPadding: 0,
    virtualScroll: 600,
    display: false,
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
  };

  Selectpicker.prototype = {

    constructor: Selectpicker,

    init: function () {
      var that = this,
          id = this.$element.attr('id');

      selectId++;
      this.selectId = 'bs-select-' + selectId;

      this.$element[0].classList.add('bs-select-hidden');

      this.multiple = this.$element.prop('multiple');
      this.autofocus = this.$element.prop('autofocus');

      if (this.$element[0].classList.contains('show-tick')) {
        this.options.showTick = true;
      }

      this.$newElement = this.createDropdown();
      this.$element
        .after(this.$newElement)
        .prependTo(this.$newElement);

      this.$button = this.$newElement.children('button');
      this.$menu = this.$newElement.children(Selector.MENU);
      this.$menuInner = this.$menu.children('.inner');
      this.$searchbox = this.$menu.find('input');

      this.$element[0].classList.remove('bs-select-hidden');

      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);

      if (typeof id !== 'undefined') {
        this.$button.attr('data-id', id);
      }

      this.checkDisabled();
      this.clickListener();

      if (this.options.liveSearch) {
        this.liveSearchListener();
        this.focusedParent = this.$searchbox[0];
      } else {
        this.focusedParent = this.$menuInner[0];
      }

      this.setStyle();
      this.render();
      this.setWidth();
      if (this.options.container) {
        this.selectPosition();
      } else {
        this.$element.on('hide' + EVENT_KEY, function () {
          if (that.isVirtual()) {
            // empty menu on close
            var menuInner = that.$menuInner[0],
                emptyMenu = menuInner.firstChild.cloneNode(false);

            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
            menuInner.scrollTop = 0;
          }
        });
      }
      this.$menu.data('this', this);
      this.$newElement.data('this', this);
      if (this.options.mobile) this.mobile();

      this.$newElement.on({
        'hide.bs.dropdown': function (e) {
          that.$element.trigger('hide' + EVENT_KEY, e);
        },
        'hidden.bs.dropdown': function (e) {
          that.$element.trigger('hidden' + EVENT_KEY, e);
        },
        'show.bs.dropdown': function (e) {
          that.$element.trigger('show' + EVENT_KEY, e);
        },
        'shown.bs.dropdown': function (e) {
          that.$element.trigger('shown' + EVENT_KEY, e);
        }
      });

      if (that.$element[0].hasAttribute('required')) {
        this.$element.on('invalid' + EVENT_KEY, function () {
          that.$button[0].classList.add('bs-invalid');

          that.$element
            .on('shown' + EVENT_KEY + '.invalid', function () {
              that.$element
                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                .off('shown' + EVENT_KEY + '.invalid');
            })
            .on('rendered' + EVENT_KEY, function () {
              // if select is no longer invalid, remove the bs-invalid class
              if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
              that.$element.off('rendered' + EVENT_KEY);
            });

          that.$button.on('blur' + EVENT_KEY, function () {
            that.$element.trigger('focus').trigger('blur');
            that.$button.off('blur' + EVENT_KEY);
          });
        });
      }

      setTimeout(function () {
        that.createLi();
        that.$element.trigger('loaded' + EVENT_KEY);
      });
    },

    createDropdown: function () {
      // Options
      // If we are multiple or showTick option is set, then add the show-tick class
      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
          multiselectable = this.multiple ? ' aria-multiselectable="true"' : '',
          inputGroup = '',
          autofocus = this.autofocus ? ' autofocus' : '';

      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
        inputGroup = ' input-group-btn';
      }

      // Elements
      var drop,
          header = '',
          searchbox = '',
          actionsbox = '',
          donebutton = '';

      if (this.options.header) {
        header =
          '<div class="' + classNames.POPOVERHEADER + '">' +
            '<button type="button" class="close" aria-hidden="true">&times;</button>' +
              this.options.header +
          '</div>';
      }

      if (this.options.liveSearch) {
        searchbox =
          '<div class="bs-searchbox">' +
            '<input type="text" class="form-control" autocomplete="off"' +
              (
                this.options.liveSearchPlaceholder === null ? ''
                :
                ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"'
              ) +
              ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' +
          '</div>';
      }

      if (this.multiple && this.options.actionsBox) {
        actionsbox =
          '<div class="bs-actionsbox">' +
            '<div class="btn-group btn-group-sm btn-block">' +
              '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.selectAllText +
              '</button>' +
              '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.deselectAllText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      if (this.multiple && this.options.doneButton) {
        donebutton =
          '<div class="bs-donebutton">' +
            '<div class="btn-group btn-block">' +
              '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' +
                this.options.doneButtonText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      drop =
        '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' +
          '<button type="button" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' +
            '<div class="filter-option">' +
              '<div class="filter-option-inner">' +
                '<div class="filter-option-inner-inner"></div>' +
              '</div> ' +
            '</div>' +
            (
              version.major === '4' ? ''
              :
              '<span class="bs-caret">' +
                this.options.template.caret +
              '</span>'
            ) +
          '</button>' +
          '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '">' +
            header +
            searchbox +
            actionsbox +
            '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + '>' +
                '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '" role="presentation">' +
                '</ul>' +
            '</div>' +
            donebutton +
          '</div>' +
        '</div>';

      return $(drop);
    },

    setPositionData: function () {
      this.selectpicker.view.canHighlight = [];
      this.selectpicker.view.size = 0;

      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
        var li = this.selectpicker.current.data[i],
            canHighlight = true;

        if (li.type === 'divider') {
          canHighlight = false;
          li.height = this.sizeInfo.dividerHeight;
        } else if (li.type === 'optgroup-label') {
          canHighlight = false;
          li.height = this.sizeInfo.dropdownHeaderHeight;
        } else {
          li.height = this.sizeInfo.liHeight;
        }

        if (li.disabled) canHighlight = false;

        this.selectpicker.view.canHighlight.push(canHighlight);

        if (canHighlight) {
          this.selectpicker.view.size++;
          li.posinset = this.selectpicker.view.size;
        }

        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
      }
    },

    isVirtual: function () {
      return (this.options.virtualScroll !== false) && (this.selectpicker.main.elements.length >= this.options.virtualScroll) || this.options.virtualScroll === true;
    },

    createView: function (isSearching, setSize, refresh) {
      var that = this,
          scrollTop = 0,
          active = [],
          selected,
          prevActive;

      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;

      this.setPositionData();

      if (setSize) {
        if (refresh) {
          scrollTop = this.$menuInner[0].scrollTop;
        } else if (!that.multiple) {
          var element = that.$element[0],
              selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

          if (typeof selectedIndex === 'number' && that.options.size !== false) {
            var selectedData = that.selectpicker.main.data[selectedIndex],
                position = selectedData && selectedData.position;

            if (position) {
              scrollTop = position - ((that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2);
            }
          }
        }
      }

      scroll(scrollTop, true);

      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
        if (!that.noScroll) scroll(this.scrollTop, updateValue);
        that.noScroll = false;
      });

      function scroll (scrollTop, init) {
        var size = that.selectpicker.current.elements.length,
            chunks = [],
            chunkSize,
            chunkCount,
            firstChunk,
            lastChunk,
            currentChunk,
            prevPositions,
            positionIsDifferent,
            previousElements,
            menuIsDifferent = true,
            isVirtual = that.isVirtual();

        that.selectpicker.view.scrollTop = scrollTop;

        if (isVirtual === true) {
          // if an option that is encountered that is wider than the current menu width, update the menu width accordingly
          if (that.sizeInfo.hasScrollBar && that.$menu[0].offsetWidth > that.sizeInfo.totalMenuWidth) {
            that.sizeInfo.menuWidth = that.$menu[0].offsetWidth;
            that.sizeInfo.totalMenuWidth = that.sizeInfo.menuWidth + that.sizeInfo.scrollBarWidth;
            that.$menu.css('min-width', that.sizeInfo.menuWidth);
          }
        }

        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks

        for (var i = 0; i < chunkCount; i++) {
          var endOfChunk = (i + 1) * chunkSize;

          if (i === chunkCount - 1) {
            endOfChunk = size;
          }

          chunks[i] = [
            (i) * chunkSize + (!i ? 0 : 1),
            endOfChunk
          ];

          if (!size) break;

          if (currentChunk === undefined && scrollTop <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
            currentChunk = i;
          }
        }

        if (currentChunk === undefined) currentChunk = 0;

        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];

        // always display previous, current, and next chunks
        firstChunk = Math.max(0, currentChunk - 1);
        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);

        that.selectpicker.view.position0 = isVirtual === false ? 0 : (Math.max(0, chunks[firstChunk][0]) || 0);
        that.selectpicker.view.position1 = isVirtual === false ? size : (Math.min(size, chunks[lastChunk][1]) || 0);

        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;

        if (that.activeIndex !== undefined) {
          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
          active = that.selectpicker.main.elements[that.activeIndex];
          selected = that.selectpicker.main.elements[that.selectedIndex];

          if (init) {
            if (that.activeIndex !== that.selectedIndex) {
              that.defocusItem(active);
            }
            that.activeIndex = undefined;
          }

          if (that.activeIndex && that.activeIndex !== that.selectedIndex) {
            that.defocusItem(selected);
          }
        }

        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) {
          that.defocusItem(prevActive);
        }

        if (init || positionIsDifferent) {
          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];

          if (isVirtual === false) {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
          } else {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
          }

          that.setOptionStatus();

          // if searching, check to make sure the list has actually been updated before updating DOM
          // this prevents unnecessary repaints
          if (isSearching || (isVirtual === false && init)) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);

          // if virtual scroll is disabled and not searching,
          // menu should never need to be updated more than once
          if ((init || isVirtual === true) && menuIsDifferent) {
            var menuInner = that.$menuInner[0],
                menuFragment = document.createDocumentFragment(),
                emptyMenu = menuInner.firstChild.cloneNode(false),
                marginTop,
                marginBottom,
                elements = that.selectpicker.view.visibleElements,
                toSanitize = [];

            // replace the existing UL with an empty one - this is faster than $.empty()
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);

            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
              var element = elements[i],
                  elText,
                  elementData;

              if (that.options.sanitize) {
                elText = element.lastChild;

                if (elText) {
                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];

                  if (elementData && elementData.content && !elementData.sanitized) {
                    toSanitize.push(elText);
                    elementData.sanitized = true;
                  }
                }
              }

              menuFragment.appendChild(element);
            }

            if (that.options.sanitize && toSanitize.length) {
              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
            }

            if (isVirtual === true) {
              marginTop = (that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position);
              marginBottom = (that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position);

              menuInner.firstChild.style.marginTop = marginTop + 'px';
              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
            } else {
              menuInner.firstChild.style.marginTop = 0;
              menuInner.firstChild.style.marginBottom = 0;
            }

            menuInner.firstChild.appendChild(menuFragment);
          }
        }

        that.prevActiveIndex = that.activeIndex;

        if (!that.options.liveSearch) {
          that.$menuInner.trigger('focus');
        } else if (isSearching && init) {
          var index = 0,
              newActive;

          if (!that.selectpicker.view.canHighlight[index]) {
            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
          }

          newActive = that.selectpicker.view.visibleElements[index];

          that.defocusItem(that.selectpicker.view.currentActive);

          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;

          that.focusItem(newActive);
        }
      }

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + '.createView')
        .on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) scroll(that.$menuInner[0].scrollTop);
        });
    },

    focusItem: function (li, liData, noStyle) {
      if (li) {
        liData = liData || this.selectpicker.main.data[this.activeIndex];
        var a = li.firstChild;

        if (a) {
          a.setAttribute('aria-setsize', this.selectpicker.view.size);
          a.setAttribute('aria-posinset', liData.posinset);

          if (noStyle !== true) {
            this.focusedParent.setAttribute('aria-activedescendant', a.id);
            li.classList.add('active');
            a.classList.add('active');
          }
        }
      }
    },

    defocusItem: function (li) {
      if (li) {
        li.classList.remove('active');
        if (li.firstChild) li.firstChild.classList.remove('active');
      }
    },

    setPlaceholder: function () {
      var updateIndex = false;

      if (this.options.title && !this.multiple) {
        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');

        // this option doesn't create a new <li> element, but does add a new option at the start,
        // so startIndex should increase to prevent having to check every option for the bs-title-option class
        updateIndex = true;

        var element = this.$element[0],
            isSelected = false,
            titleNotAppended = !this.selectpicker.view.titleOption.parentNode;

        if (titleNotAppended) {
          // Use native JS to prepend option (faster)
          this.selectpicker.view.titleOption.className = 'bs-title-option';
          this.selectpicker.view.titleOption.value = '';

          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
          // if so, the select will have the data-selected attribute
          var $opt = $(element.options[element.selectedIndex]);
          isSelected = $opt.attr('selected') === undefined && this.$element.data('selected') === undefined;
        }

        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
        }

        // Set selected *after* appending to select,
        // otherwise the option doesn't get selected in IE
        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
        if (isSelected) element.selectedIndex = 0;
      }

      return updateIndex;
    },

    createLi: function () {
      var that = this,
          iconBase = this.options.iconBase,
          optionSelector = ':not([hidden]):not([data-hidden="true"])',
          mainElements = [],
          mainData = [],
          widestOptionLength = 0,
          optID = 0,
          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop

      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
        elementTemplates.checkMark.className = iconBase + ' ' + that.options.tickIcon + ' check-mark';
        elementTemplates.a.appendChild(elementTemplates.checkMark);
      }

      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);

      function addDivider (config) {
        var previousData = mainData[mainData.length - 1];

        // ensure optgroup doesn't create back-to-back dividers
        if (
          previousData &&
          previousData.type === 'divider' &&
          (previousData.optID || config.optID)
        ) {
          return;
        }

        config = config || {};
        config.type = 'divider';

        mainElements.push(
          generateOption.li(
            false,
            classNames.DIVIDER,
            (config.optID ? config.optID + 'div' : undefined)
          )
        );

        mainData.push(config);
      }

      function addOption (option, config) {
        config = config || {};

        config.divider = option.getAttribute('data-divider') === 'true';

        if (config.divider) {
          addDivider({
            optID: config.optID
          });
        } else {
          var liIndex = mainData.length,
              cssText = option.style.cssText,
              inlineStyle = cssText ? htmlEscape(cssText) : '',
              optionClass = (option.className || '') + (config.optgroupClass || '');

          if (config.optID) optionClass = 'opt ' + optionClass;

          config.text = option.textContent;

          config.content = option.getAttribute('data-content');
          config.tokens = option.getAttribute('data-tokens');
          config.subtext = option.getAttribute('data-subtext');
          config.icon = option.getAttribute('data-icon');
          config.iconBase = iconBase;

          var textElement = generateOption.text(config);
          var liElement = generateOption.li(
            generateOption.a(
              textElement,
              optionClass,
              inlineStyle
            ),
            '',
            config.optID
          );

          if (liElement.firstChild) {
            liElement.firstChild.id = that.selectId + '-' + liIndex;
          }

          mainElements.push(liElement);

          option.liIndex = liIndex;

          config.display = config.content || config.text;
          config.type = 'option';
          config.index = liIndex;
          config.option = option;
          config.disabled = config.disabled || option.disabled;

          mainData.push(config);

          var combinedLength = 0;

          // count the number of characters in the option - not perfect, but should work in most cases
          if (config.display) combinedLength += config.display.length;
          if (config.subtext) combinedLength += config.subtext.length;
          // if there is an icon, ensure this option's width is checked
          if (config.icon) combinedLength += 1;

          if (combinedLength > widestOptionLength) {
            widestOptionLength = combinedLength;

            // guess which option is the widest
            // use this when calculating menu width
            // not perfect, but it's fast, and the width will be updating accordingly when scrolling
            that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
          }
        }
      }

      function addOptgroup (index, selectOptions) {
        var optgroup = selectOptions[index],
            previous = selectOptions[index - 1],
            next = selectOptions[index + 1],
            options = optgroup.querySelectorAll('option' + optionSelector);

        if (!options.length) return;

        var config = {
              label: htmlEscape(optgroup.label),
              subtext: optgroup.getAttribute('data-subtext'),
              icon: optgroup.getAttribute('data-icon'),
              iconBase: iconBase
            },
            optgroupClass = ' ' + (optgroup.className || ''),
            headerIndex,
            lastIndex;

        optID++;

        if (previous) {
          addDivider({ optID: optID });
        }

        var labelElement = generateOption.label(config);

        mainElements.push(
          generateOption.li(labelElement, 'dropdown-header' + optgroupClass, optID)
        );

        mainData.push({
          display: config.label,
          subtext: config.subtext,
          type: 'optgroup-label',
          optID: optID
        });

        for (var j = 0, len = options.length; j < len; j++) {
          var option = options[j];

          if (j === 0) {
            headerIndex = mainData.length - 1;
            lastIndex = headerIndex + len;
          }

          addOption(option, {
            headerIndex: headerIndex,
            lastIndex: lastIndex,
            optID: optID,
            optgroupClass: optgroupClass,
            disabled: optgroup.disabled
          });
        }

        if (next) {
          addDivider({ optID: optID });
        }
      }

      for (var len = selectOptions.length; startIndex < len; startIndex++) {
        var item = selectOptions[startIndex];

        if (item.tagName !== 'OPTGROUP') {
          addOption(item, {});
        } else {
          addOptgroup(startIndex, selectOptions);
        }
      }

      this.selectpicker.main.elements = mainElements;
      this.selectpicker.main.data = mainData;

      this.selectpicker.current = this.selectpicker.main;
    },

    findLis: function () {
      return this.$menuInner.find('.inner > li');
    },

    render: function () {
      // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
      this.setPlaceholder();

      var that = this,
          element = this.$element[0],
          selectedOptions = getSelectedOptions(element, this.options.hideDisabled),
          selectedCount = selectedOptions.length,
          button = this.$button[0],
          buttonInner = button.querySelector('.filter-option-inner-inner'),
          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
          titleFragment = elementTemplates.fragment.cloneNode(false),
          showCount,
          countMax,
          hasContent = false;

      button.classList.toggle('bs-placeholder', that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));

      this.tabIndex();

      if (this.options.selectedTextFormat === 'static') {
        titleFragment = generateOption.text({ text: this.options.title }, true);
      } else {
        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;

        // determine if the number of selected options will be shown (showCount === true)
        if (showCount) {
          countMax = this.options.selectedTextFormat.split('>');
          showCount = (countMax.length > 1 && selectedCount > countMax[1]) || (countMax.length === 1 && selectedCount >= 2);
        }

        // only loop through all selected options if the count won't be shown
        if (showCount === false) {
          for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
            if (selectedIndex < 50) {
              var option = selectedOptions[selectedIndex],
                  titleOptions = {},
                  thisData = {
                    content: option.getAttribute('data-content'),
                    subtext: option.getAttribute('data-subtext'),
                    icon: option.getAttribute('data-icon')
                  };

              if (this.multiple && selectedIndex > 0) {
                titleFragment.appendChild(multipleSeparator.cloneNode(false));
              }

              if (option.title) {
                titleOptions.text = option.title;
              } else if (thisData.content && that.options.showContent) {
                titleOptions.content = thisData.content.toString();
                hasContent = true;
              } else {
                if (that.options.showIcon) {
                  titleOptions.icon = thisData.icon;
                  titleOptions.iconBase = this.options.iconBase;
                }
                if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
                titleOptions.text = option.textContent.trim();
              }

              titleFragment.appendChild(generateOption.text(titleOptions, true));
            } else {
              break;
            }
          }

          // add ellipsis
          if (selectedCount > 49) {
            titleFragment.appendChild(document.createTextNode('...'));
          }
        } else {
          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;

          titleFragment = generateOption.text({
            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
          }, true);
        }
      }

      if (this.options.title == undefined) {
        // use .attr to ensure undefined is returned if title attribute is not set
        this.options.title = this.$element.attr('title');
      }

      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
      if (!titleFragment.childNodes.length) {
        titleFragment = generateOption.text({
          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
        }, true);
      }

      // strip all HTML tags and trim the result, then unescape any escaped tags
      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();

      if (this.options.sanitize && hasContent) {
        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
      }

      buttonInner.innerHTML = '';
      buttonInner.appendChild(titleFragment);

      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
        var filterExpand = button.querySelector('.filter-expand'),
            clone = buttonInner.cloneNode(true);

        clone.className = 'filter-expand';

        if (filterExpand) {
          button.replaceChild(clone, filterExpand);
        } else {
          button.appendChild(clone);
        }
      }

      this.$element.trigger('rendered' + EVENT_KEY);
    },

    /**
     * @param [style]
     * @param [status]
     */
    setStyle: function (newStyle, status) {
      var button = this.$button[0],
          newElement = this.$newElement[0],
          style = this.options.style.trim(),
          buttonClass;

      if (this.$element.attr('class')) {
        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
      }

      if (version.major < 4) {
        newElement.classList.add('bs3');

        if (newElement.parentNode.classList.contains('input-group') &&
            (newElement.previousElementSibling || newElement.nextElementSibling) &&
            (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')
        ) {
          newElement.classList.add('bs3-has-addon');
        }
      }

      if (newStyle) {
        buttonClass = newStyle.trim();
      } else {
        buttonClass = style;
      }

      if (status == 'add') {
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      } else if (status == 'remove') {
        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
      } else {
        if (style) button.classList.remove.apply(button.classList, style.split(' '));
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      }
    },

    liHeight: function (refresh) {
      if (!refresh && (this.options.size === false || this.sizeInfo)) return;

      if (!this.sizeInfo) this.sizeInfo = {};

      var newElement = document.createElement('div'),
          menu = document.createElement('div'),
          menuInner = document.createElement('div'),
          menuInnerInner = document.createElement('ul'),
          divider = document.createElement('li'),
          dropdownHeader = document.createElement('li'),
          li = document.createElement('li'),
          a = document.createElement('a'),
          text = document.createElement('span'),
          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
          search = this.options.liveSearch ? document.createElement('div') : null,
          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
          firstOption = this.$element.find('option')[0];

      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;

      text.className = 'text';
      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
      newElement.style.width = this.sizeInfo.selectWidth + 'px';
      if (this.options.width === 'auto') menu.style.minWidth = 0;
      menu.className = classNames.MENU + ' ' + classNames.SHOW;
      menuInner.className = 'inner ' + classNames.SHOW;
      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
      divider.className = classNames.DIVIDER;
      dropdownHeader.className = 'dropdown-header';

      text.appendChild(document.createTextNode('\u200b'));
      a.appendChild(text);
      li.appendChild(a);
      dropdownHeader.appendChild(text.cloneNode(true));

      if (this.selectpicker.view.widestOption) {
        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
      }

      menuInnerInner.appendChild(li);
      menuInnerInner.appendChild(divider);
      menuInnerInner.appendChild(dropdownHeader);
      if (header) menu.appendChild(header);
      if (search) {
        var input = document.createElement('input');
        search.className = 'bs-searchbox';
        input.className = 'form-control';
        search.appendChild(input);
        menu.appendChild(search);
      }
      if (actions) menu.appendChild(actions);
      menuInner.appendChild(menuInnerInner);
      menu.appendChild(menuInner);
      if (doneButton) menu.appendChild(doneButton);
      newElement.appendChild(menu);

      document.body.appendChild(newElement);

      var liHeight = li.offsetHeight,
          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
          headerHeight = header ? header.offsetHeight : 0,
          searchHeight = search ? search.offsetHeight : 0,
          actionsHeight = actions ? actions.offsetHeight : 0,
          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
          dividerHeight = $(divider).outerHeight(true),
          // fall back to jQuery if getComputedStyle is not supported
          menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
          menuWidth = menu.offsetWidth,
          $menu = menuStyle ? null : $(menu),
          menuPadding = {
            vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
                  toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
                  toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
                  toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
            horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
                  toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
                  toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
                  toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
          },
          menuExtras = {
            vert: menuPadding.vert +
                  toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
                  toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
            horiz: menuPadding.horiz +
                  toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
                  toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
          },
          scrollBarWidth;

      menuInner.style.overflowY = 'scroll';

      scrollBarWidth = menu.offsetWidth - menuWidth;

      document.body.removeChild(newElement);

      this.sizeInfo.liHeight = liHeight;
      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
      this.sizeInfo.headerHeight = headerHeight;
      this.sizeInfo.searchHeight = searchHeight;
      this.sizeInfo.actionsHeight = actionsHeight;
      this.sizeInfo.doneButtonHeight = doneButtonHeight;
      this.sizeInfo.dividerHeight = dividerHeight;
      this.sizeInfo.menuPadding = menuPadding;
      this.sizeInfo.menuExtras = menuExtras;
      this.sizeInfo.menuWidth = menuWidth;
      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
      this.sizeInfo.scrollBarWidth = scrollBarWidth;
      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;

      this.setPositionData();
    },

    getSelectPosition: function () {
      var that = this,
          $window = $(window),
          pos = that.$newElement.offset(),
          $container = $(that.options.container),
          containerPos;

      if (that.options.container && $container.length && !$container.is('body')) {
        containerPos = $container.offset();
        containerPos.top += parseInt($container.css('borderTopWidth'));
        containerPos.left += parseInt($container.css('borderLeftWidth'));
      } else {
        containerPos = { top: 0, left: 0 };
      }

      var winPad = that.options.windowPadding;

      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
      this.sizeInfo.selectOffsetTop -= winPad[0];
      this.sizeInfo.selectOffsetLeft -= winPad[3];
    },

    setMenuSize: function (isAuto) {
      this.getSelectPosition();

      var selectWidth = this.sizeInfo.selectWidth,
          liHeight = this.sizeInfo.liHeight,
          headerHeight = this.sizeInfo.headerHeight,
          searchHeight = this.sizeInfo.searchHeight,
          actionsHeight = this.sizeInfo.actionsHeight,
          doneButtonHeight = this.sizeInfo.doneButtonHeight,
          divHeight = this.sizeInfo.dividerHeight,
          menuPadding = this.sizeInfo.menuPadding,
          menuInnerHeight,
          menuHeight,
          divLength = 0,
          minHeight,
          _minHeight,
          maxHeight,
          menuInnerMinHeight,
          estimate;

      if (this.options.dropupAuto) {
        // Get the estimated height of the menu without scrollbars.
        // This is useful for smaller menus, where there might be plenty of room
        // below the button without setting dropup, but we can't know
        // the exact height of the menu until createView is called later
        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
        this.$newElement.toggleClass(classNames.DROPUP, this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot);
      }

      if (this.options.size === 'auto') {
        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);

        if (this.$newElement.hasClass(classNames.DROPUP)) {
          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
        }

        maxHeight = menuHeight;
        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
        for (var i = 0; i < this.options.size; i++) {
          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
        }

        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
        menuInnerHeight = menuHeight - menuPadding.vert;
        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        minHeight = menuInnerMinHeight = '';
      }

      if (this.options.dropdownAlignRight === 'auto') {
        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < (this.sizeInfo.totalMenuWidth - selectWidth));
      }

      this.$menu.css({
        'max-height': maxHeight + 'px',
        'overflow': 'hidden',
        'min-height': minHeight + 'px'
      });

      this.$menuInner.css({
        'max-height': menuInnerHeight + 'px',
        'overflow-y': 'auto',
        'min-height': menuInnerMinHeight + 'px'
      });

      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);

      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
        this.sizeInfo.hasScrollBar = true;
        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;

        this.$menu.css('min-width', this.sizeInfo.totalMenuWidth);
      }

      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
    },

    setSize: function (refresh) {
      this.liHeight(refresh);

      if (this.options.header) this.$menu.css('padding-top', 0);
      if (this.options.size === false) return;

      var that = this,
          $window = $(window);

      this.setMenuSize();

      if (this.options.liveSearch) {
        this.$searchbox
          .off('input.setMenuSize propertychange.setMenuSize')
          .on('input.setMenuSize propertychange.setMenuSize', function () {
            return that.setMenuSize();
          });
      }

      if (this.options.size === 'auto') {
        $window
          .off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize')
          .on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
            return that.setMenuSize();
          });
      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
        $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
      }

      that.createView(false, true, refresh);
    },

    setWidth: function () {
      var that = this;

      if (this.options.width === 'auto') {
        requestAnimationFrame(function () {
          that.$menu.css('min-width', '0');

          that.$element.on('loaded' + EVENT_KEY, function () {
            that.liHeight();
            that.setMenuSize();

            // Get correct width if element is hidden
            var $selectClone = that.$newElement.clone().appendTo('body'),
                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();

            $selectClone.remove();

            // Set width to whatever's larger, button title or longest option
            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
          });
        });
      } else if (this.options.width === 'fit') {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '').addClass('fit-width');
      } else if (this.options.width) {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', this.options.width);
      } else {
        // Remove inline min-width/width so width can be changed
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '');
      }
      // Remove fit-width class if width is changed programmatically
      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
        this.$newElement[0].classList.remove('fit-width');
      }
    },

    selectPosition: function () {
      this.$bsContainer = $('<div class="bs-container" />');

      var that = this,
          $container = $(this.options.container),
          pos,
          containerPos,
          actualHeight,
          getPlacement = function ($element) {
            var containerPosition = {},
                // fall back to dropdown's default display setting if display is not manually set
                display = that.options.display || (
                  // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                  $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display
                  : false
                );

            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
            pos = $element.offset();

            if (!$container.is('body')) {
              containerPos = $container.offset();
              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
            } else {
              containerPos = { top: 0, left: 0 };
            }

            actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;

            // Bootstrap 4+ uses Popper for menu positioning
            if (version.major < 4 || display === 'static') {
              containerPosition.top = pos.top - containerPos.top + actualHeight;
              containerPosition.left = pos.left - containerPos.left;
            }

            containerPosition.width = $element[0].offsetWidth;

            that.$bsContainer.css(containerPosition);
          };

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (that.isDisabled()) {
          return;
        }

        getPlacement(that.$newElement);

        that.$bsContainer
          .appendTo(that.options.container)
          .toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW))
          .append(that.$menu);
      });

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId)
        .on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) getPlacement(that.$newElement);
        });

      this.$element.on('hide' + EVENT_KEY, function () {
        that.$menu.data('height', that.$menu.height());
        that.$bsContainer.detach();
      });
    },

    setOptionStatus: function (selectedOnly) {
      var that = this;

      that.noScroll = false;

      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
              option = liData.option;

          if (option) {
            if (selectedOnly !== true) {
              that.setDisabled(
                liData.index,
                liData.disabled
              );
            }

            that.setSelected(
              liData.index,
              option.selected
            );
          }
        }
      }
    },

    /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */
    setSelected: function (index, selected) {
      var li = this.selectpicker.main.elements[index],
          liData = this.selectpicker.main.data[index],
          activeIndexIsSet = this.activeIndex !== undefined,
          thisIsActive = this.activeIndex === index,
          prevActive,
          a,
          // if current option is already active
          // OR
          // if the current option is being selected, it's NOT multiple, and
          // activeIndex is undefined:
          //  - when the menu is first being opened, OR
          //  - after a search has been performed, OR
          //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
          keepActive = thisIsActive || (selected && !this.multiple && !activeIndexIsSet);

      liData.selected = selected;

      a = li.firstChild;

      if (selected) {
        this.selectedIndex = index;
      }

      li.classList.toggle('selected', selected);

      if (keepActive) {
        this.focusItem(li, liData);
        this.selectpicker.view.currentActive = li;
        this.activeIndex = index;
      } else {
        this.defocusItem(li);
      }

      if (a) {
        a.classList.toggle('selected', selected);

        if (selected) {
          a.setAttribute('aria-selected', true);
        } else {
          if (this.multiple) {
            a.setAttribute('aria-selected', false);
          } else {
            a.removeAttribute('aria-selected');
          }
        }
      }

      if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
        prevActive = this.selectpicker.main.elements[this.prevActiveIndex];

        this.defocusItem(prevActive);
      }
    },

    /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */
    setDisabled: function (index, disabled) {
      var li = this.selectpicker.main.elements[index],
          a;

      this.selectpicker.main.data[index].disabled = disabled;

      a = li.firstChild;

      li.classList.toggle(classNames.DISABLED, disabled);

      if (a) {
        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);

        if (disabled) {
          a.setAttribute('aria-disabled', disabled);
          a.setAttribute('tabindex', -1);
        } else {
          a.removeAttribute('aria-disabled');
          a.setAttribute('tabindex', 0);
        }
      }
    },

    isDisabled: function () {
      return this.$element[0].disabled;
    },

    checkDisabled: function () {
      var that = this;

      if (this.isDisabled()) {
        this.$newElement[0].classList.add(classNames.DISABLED);
        this.$button.addClass(classNames.DISABLED).attr('tabindex', -1).attr('aria-disabled', true);
      } else {
        if (this.$button[0].classList.contains(classNames.DISABLED)) {
          this.$newElement[0].classList.remove(classNames.DISABLED);
          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
        }

        if (this.$button.attr('tabindex') == -1 && !this.$element.data('tabindex')) {
          this.$button.removeAttr('tabindex');
        }
      }

      this.$button.on('click', function () {
        return !that.isDisabled();
      });
    },

    tabIndex: function () {
      if (this.$element.data('tabindex') !== this.$element.attr('tabindex') &&
        (this.$element.attr('tabindex') !== -98 && this.$element.attr('tabindex') !== '-98')) {
        this.$element.data('tabindex', this.$element.attr('tabindex'));
        this.$button.attr('tabindex', this.$element.data('tabindex'));
      }

      this.$element.attr('tabindex', -98);
    },

    clickListener: function () {
      var that = this,
          $document = $(document);

      $document.data('spaceSelect', false);

      this.$button.on('keyup', function (e) {
        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
          e.preventDefault();
          $document.data('spaceSelect', false);
        }
      });

      this.$newElement.on('show.bs.dropdown', function () {
        if (version.major > 3 && !that.dropdown) {
          that.dropdown = that.$button.data('bs.dropdown');
          that.dropdown._menu = that.$menu[0];
        }
      });

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!that.$newElement.hasClass(classNames.SHOW)) {
          that.setSize();
        }
      });

      function setFocus () {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$menuInner.trigger('focus');
        }
      }

      function checkPopperExists () {
        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
          setFocus();
        } else {
          requestAnimationFrame(checkPopperExists);
        }
      }

      this.$element.on('shown' + EVENT_KEY, function () {
        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
        }

        if (version.major > 3) {
          requestAnimationFrame(checkPopperExists);
        } else {
          setFocus();
        }
      });

      // ensure posinset and setsize are correct before selecting an option via a click
      this.$menuInner.on('mouseenter', 'li a', function (e) {
        var hoverLi = this.parentElement,
            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
            index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi),
            hoverData = that.selectpicker.current.data[index + position0];

        that.focusItem(hoverLi, hoverData, true);
      });

      this.$menuInner.on('click', 'li a', function (e, retainActive) {
        var $this = $(this),
            element = that.$element[0],
            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
            clickedIndex = clickedData.index,
            prevValue = getSelectValues(element),
            prevIndex = element.selectedIndex,
            prevOption = element.options[prevIndex],
            triggerChange = true;

        // Don't close on multi choice menu
        if (that.multiple && that.options.maxOptions !== 1) {
          e.stopPropagation();
        }

        e.preventDefault();

        // Don't run if the select is disabled
        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
          var $options = that.$element.find('option'),
              option = clickedData.option,
              $option = $(option),
              state = option.selected,
              $optgroup = $option.parent('optgroup'),
              $optgroupOptions = $optgroup.find('option'),
              maxOptions = that.options.maxOptions,
              maxOptionsGrp = $optgroup.data('maxOptions') || false;

          if (clickedIndex === that.activeIndex) retainActive = true;

          if (!retainActive) {
            that.prevActiveIndex = that.activeIndex;
            that.activeIndex = undefined;
          }

          if (!that.multiple) { // Deselect all others if not multi select box
            prevOption.selected = false;
            option.selected = true;
            that.setSelected(clickedIndex, true);
          } else { // Toggle the one we have chosen if we are multi select.
            option.selected = !state;

            that.setSelected(clickedIndex, !state);
            $this.trigger('blur');

            if (maxOptions !== false || maxOptionsGrp !== false) {
              var maxReached = maxOptions < $options.filter(':selected').length,
                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
                if (maxOptions && maxOptions == 1) {
                  $options.prop('selected', false);
                  $option.prop('selected', true);

                  for (var i = 0; i < $options.length; i++) {
                    that.setSelected(i, false);
                  }

                  that.setSelected(clickedIndex, true);
                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                  $optgroup.find('option:selected').prop('selected', false);
                  $option.prop('selected', true);

                  for (var i = 0; i < $optgroupOptions.length; i++) {
                    var option = $optgroupOptions[i];
                    that.setSelected($options.index(option), false);
                  }

                  that.setSelected(clickedIndex, true);
                } else {
                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
                      $notify = $('<div class="notify"></div>');
                  // If {var} is set in array, replace it
                  /** @deprecated */
                  if (maxOptionsArr[2]) {
                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                  }

                  $option.prop('selected', false);

                  that.$menu.append($notify);

                  if (maxOptions && maxReached) {
                    $notify.append($('<div>' + maxTxt + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReached' + EVENT_KEY);
                  }

                  if (maxOptionsGrp && maxReachedGrp) {
                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
                  }

                  setTimeout(function () {
                    that.setSelected(clickedIndex, false);
                  }, 10);

                  $notify.delay(750).fadeOut(300, function () {
                    $(this).remove();
                  });
                }
              }
            }
          }

          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
            that.$button.trigger('focus');
          } else if (that.options.liveSearch) {
            that.$searchbox.trigger('focus');
          }

          // Trigger select 'change'
          if (triggerChange) {
            if (that.multiple || prevIndex !== element.selectedIndex) {
              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
              changedArguments = [option.index, $option.prop('selected'), prevValue];
              that.$element
                .triggerNative('change');
            }
          }
        }
      });

      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
        if (e.currentTarget == this) {
          e.preventDefault();
          e.stopPropagation();
          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
            that.$searchbox.trigger('focus');
          } else {
            that.$button.trigger('focus');
          }
        }
      });

      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }
      });

      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
        that.$button.trigger('click');
      });

      this.$searchbox.on('click', function (e) {
        e.stopPropagation();
      });

      this.$menu.on('click', '.actions-btn', function (e) {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('bs-select-all')) {
          that.selectAll();
        } else {
          that.deselectAll();
        }
      });

      this.$element
        .on('change' + EVENT_KEY, function () {
          that.render();
          that.$element.trigger('changed' + EVENT_KEY, changedArguments);
          changedArguments = null;
        })
        .on('focus' + EVENT_KEY, function () {
          if (!that.options.mobile) that.$button.trigger('focus');
        });
    },

    liveSearchListener: function () {
      var that = this,
          noResults = document.createElement('li');

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!!that.$searchbox.val()) {
          that.$searchbox.val('');
        }
      });

      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
        e.stopPropagation();
      });

      this.$searchbox.on('input propertychange', function () {
        var searchValue = that.$searchbox.val();

        that.selectpicker.search.elements = [];
        that.selectpicker.search.data = [];

        if (searchValue) {
          var i,
              searchMatch = [],
              q = searchValue.toUpperCase(),
              cache = {},
              cacheArr = [],
              searchStyle = that._searchStyle(),
              normalizeSearch = that.options.liveSearchNormalize;

          if (normalizeSearch) q = normalizeToBase(q);

          that._$lisSelected = that.$menuInner.find('.selected');

          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
            var li = that.selectpicker.main.data[i];

            if (!cache[i]) {
              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
            }

            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
              if (li.headerIndex > 0) {
                cache[li.headerIndex - 1] = true;
                cacheArr.push(li.headerIndex - 1);
              }

              cache[li.headerIndex] = true;
              cacheArr.push(li.headerIndex);

              cache[li.lastIndex + 1] = true;
            }

            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
          }

          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
            var index = cacheArr[i],
                prevIndex = cacheArr[i - 1],
                li = that.selectpicker.main.data[index],
                liPrev = that.selectpicker.main.data[prevIndex];

            if (li.type !== 'divider' || (li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i)) {
              that.selectpicker.search.data.push(li);
              searchMatch.push(that.selectpicker.main.elements[index]);
            }
          }

          that.activeIndex = undefined;
          that.noScroll = true;
          that.$menuInner.scrollTop(0);
          that.selectpicker.search.elements = searchMatch;
          that.createView(true);

          if (!searchMatch.length) {
            noResults.className = 'no-results';
            noResults.innerHTML = that.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
            that.$menuInner[0].firstChild.appendChild(noResults);
          }
        } else {
          that.$menuInner.scrollTop(0);
          that.createView(false);
        }
      });
    },

    _searchStyle: function () {
      return this.options.liveSearchStyle || 'contains';
    },

    val: function (value) {
      var element = this.$element[0];

      if (typeof value !== 'undefined') {
        var prevValue = getSelectValues(element);

        changedArguments = [null, null, prevValue];

        this.$element
          .val(value)
          .trigger('changed' + EVENT_KEY, changedArguments);

        if (this.$newElement.hasClass(classNames.SHOW)) {
          if (this.multiple) {
            this.setOptionStatus(true);
          } else {
            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

            if (typeof liSelectedIndex === 'number') {
              this.setSelected(this.selectedIndex, false);
              this.setSelected(liSelectedIndex, true);
            }
          }
        }

        this.render();

        changedArguments = null;

        return this.$element;
      } else {
        return this.$element.val();
      }
    },

    changeAll: function (status) {
      if (!this.multiple) return;
      if (typeof status === 'undefined') status = true;

      var element = this.$element[0],
          previousSelected = 0,
          currentSelected = 0,
          prevValue = getSelectValues(element);

      element.classList.add('bs-select-hidden');

      for (var i = 0, len = this.selectpicker.current.elements.length; i < len; i++) {
        var liData = this.selectpicker.current.data[i],
            option = liData.option;

        if (option && !liData.disabled && liData.type !== 'divider') {
          if (liData.selected) previousSelected++;
          option.selected = status;
          if (status) currentSelected++;
        }
      }

      element.classList.remove('bs-select-hidden');

      if (previousSelected === currentSelected) return;

      this.setOptionStatus();

      changedArguments = [null, null, prevValue];

      this.$element
        .triggerNative('change');
    },

    selectAll: function () {
      return this.changeAll(true);
    },

    deselectAll: function () {
      return this.changeAll(false);
    },

    toggle: function (e) {
      e = e || window.event;

      if (e) e.stopPropagation();

      this.$button.trigger('click.bs.dropdown.data-api');
    },

    keydown: function (e) {
      var $this = $(this),
          isToggle = $this.hasClass('dropdown-toggle'),
          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
          that = $parent.data('this'),
          $items = that.findLis(),
          index,
          isActive,
          liActive,
          activeLi,
          offset,
          updateScroll = false,
          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
          scrollTop = that.$menuInner[0].scrollTop,
          isVirtual = that.isVirtual(),
          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;

      isActive = that.$newElement.hasClass(classNames.SHOW);

      if (
        !isActive &&
        (
          isArrowKey ||
          (e.which >= 48 && e.which <= 57) ||
          (e.which >= 96 && e.which <= 105) ||
          (e.which >= 65 && e.which <= 90)
        )
      ) {
        that.$button.trigger('click.bs.dropdown.data-api');

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
          return;
        }
      }

      if (e.which === keyCodes.ESCAPE && isActive) {
        e.preventDefault();
        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
      }

      if (isArrowKey) { // if up or down
        if (!$items.length) return;

        liActive = that.selectpicker.main.elements[that.activeIndex];
        index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;

        if (index !== -1) {
          that.defocusItem(liActive);
        }

        if (e.which === keyCodes.ARROW_UP) { // up
          if (index !== -1) index--;
          if (index + position0 < 0) index += $items.length;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
            if (index === -1) index = $items.length - 1;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          index++;
          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = 0;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
          }
        }

        e.preventDefault();

        var liActiveIndex = position0 + index;

        if (e.which === keyCodes.ARROW_UP) { // up
          // scroll to bottom and highlight last option
          if (position0 === 0 && index === $items.length - 1) {
            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;

            liActiveIndex = that.selectpicker.current.elements.length - 1;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - activeLi.height;

            updateScroll = offset < scrollTop;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          // scroll to top and highlight first option
          if (index === 0) {
            that.$menuInner[0].scrollTop = 0;

            liActiveIndex = 0;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;

            updateScroll = offset > scrollTop;
          }
        }

        liActive = that.selectpicker.current.elements[liActiveIndex];

        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;

        that.focusItem(liActive);

        that.selectpicker.view.currentActive = liActive;

        if (updateScroll) that.$menuInner[0].scrollTop = offset;

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          $this.trigger('focus');
        }
      } else if (
        (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which)) ||
        (e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory)
      ) {
        var searchMatch,
            matches = [],
            keyHistory;

        e.preventDefault();

        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];

        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();

        keyHistory = that.selectpicker.keydown.keyHistory;

        // if all letters are the same, set keyHistory to just the first character when searching
        if (/^(.)\1+$/.test(keyHistory)) {
          keyHistory = keyHistory.charAt(0);
        }

        // find matches
        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
          var li = that.selectpicker.current.data[i],
              hasMatch;

          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);

          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
            matches.push(li.index);
          }
        }

        if (matches.length) {
          var matchIndex = 0;

          $items.removeClass('active').find('a').removeClass('active');

          // either only one key has been pressed or they are all the same key
          if (keyHistory.length === 1) {
            matchIndex = matches.indexOf(that.activeIndex);

            if (matchIndex === -1 || matchIndex === matches.length - 1) {
              matchIndex = 0;
            } else {
              matchIndex++;
            }
          }

          searchMatch = matches[matchIndex];

          activeLi = that.selectpicker.main.data[searchMatch];

          if (scrollTop - activeLi.position > 0) {
            offset = activeLi.position - activeLi.height;
            updateScroll = true;
          } else {
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
            // if the option is already visible at the current scroll position, just keep it the same
            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
          }

          liActive = that.selectpicker.main.elements[searchMatch];

          that.activeIndex = matches[matchIndex];

          that.focusItem(liActive);

          if (liActive) liActive.firstChild.focus();

          if (updateScroll) that.$menuInner[0].scrollTop = offset;

          $this.trigger('focus');
        }
      }

      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
      if (
        isActive &&
        (
          (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory) ||
          e.which === keyCodes.ENTER ||
          (e.which === keyCodes.TAB && that.options.selectOnTab)
        )
      ) {
        if (e.which !== keyCodes.SPACE) e.preventDefault();

        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
          that.$menuInner.find('.active a').trigger('click', true); // retain active class
          $this.trigger('focus');

          if (!that.options.liveSearch) {
            // Prevent screen from scrolling if the user hits the spacebar
            e.preventDefault();
            // Fixes spacebar selection of dropdown items in FF & IE
            $(document).data('spaceSelect', true);
          }
        }
      }
    },

    mobile: function () {
      this.$element[0].classList.add('mobile-device');
    },

    refresh: function () {
      // update options if data attributes have been changed
      var config = $.extend({}, this.options, this.$element.data());
      this.options = config;

      this.checkDisabled();
      this.setStyle();
      this.render();
      this.createLi();
      this.setWidth();

      this.setSize(true);

      this.$element.trigger('refreshed' + EVENT_KEY);
    },

    hide: function () {
      this.$newElement.hide();
    },

    show: function () {
      this.$newElement.show();
    },

    remove: function () {
      this.$newElement.remove();
      this.$element.remove();
    },

    destroy: function () {
      this.$newElement.before(this.$element).remove();

      if (this.$bsContainer) {
        this.$bsContainer.remove();
      } else {
        this.$menu.remove();
      }

      this.$element
        .off(EVENT_KEY)
        .removeData('selectpicker')
        .removeClass('bs-select-hidden selectpicker');

      $(window).off(EVENT_KEY + '.' + this.selectId);
    }
  };

  // SELECTPICKER PLUGIN DEFINITION
  // ==============================
  function Plugin (option) {
    // get the args of the outer function..
    var args = arguments;
    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
    // to get lost/corrupted in android 2.3 and IE9 #715 #775
    var _option = option;

    [].shift.apply(args);

    // if the version was not set successfully
    if (!version.success) {
      // try to retreive it again
      try {
        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
      } catch (err) {
        // fall back to use BootstrapVersion if set
        if (Selectpicker.BootstrapVersion) {
          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
        } else {
          version.full = [version.major, '0', '0'];

          console.warn(
            'There was an issue retrieving Bootstrap\'s version. ' +
            'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' +
            'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.',
            err
          );
        }
      }

      version.major = version.full[0];
      version.success = true;
    }

    if (version.major === '4') {
      // some defaults need to be changed if using Bootstrap 4
      // check to see if they have already been manually changed before forcing them to update
      var toUpdate = [];

      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });

      classNames.DIVIDER = 'dropdown-divider';
      classNames.SHOW = 'show';
      classNames.BUTTONCLASS = 'btn-light';
      classNames.POPOVERHEADER = 'popover-header';
      classNames.ICONBASE = '';
      classNames.TICKICON = 'bs-ok-default';

      for (var i = 0; i < toUpdate.length; i++) {
        var option = toUpdate[i];
        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
      }
    }

    var value;
    var chain = this.each(function () {
      var $this = $(this);
      if ($this.is('select')) {
        var data = $this.data('selectpicker'),
            options = typeof _option == 'object' && _option;

        if (!data) {
          var dataAttributes = $this.data();

          for (var dataAttr in dataAttributes) {
            if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
              delete dataAttributes[dataAttr];
            }
          }

          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), dataAttributes.template, options.template);
          $this.data('selectpicker', (data = new Selectpicker(this, config)));
        } else if (options) {
          for (var i in options) {
            if (options.hasOwnProperty(i)) {
              data.options[i] = options[i];
            }
          }
        }

        if (typeof _option == 'string') {
          if (data[_option] instanceof Function) {
            value = data[_option].apply(data, args);
          } else {
            value = data.options[_option];
          }
        }
      }
    });

    if (typeof value !== 'undefined') {
      // noinspection JSUnusedAssignment
      return value;
    } else {
      return chain;
    }
  }

  var old = $.fn.selectpicker;
  $.fn.selectpicker = Plugin;
  $.fn.selectpicker.Constructor = Selectpicker;

  // SELECTPICKER NO CONFLICT
  // ========================
  $.fn.selectpicker.noConflict = function () {
    $.fn.selectpicker = old;
    return this;
  };

  $(document)
    .off('keydown.bs.dropdown.data-api')
    .on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown)
    .on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
      e.stopPropagation();
    });

  // SELECTPICKER DATA-API
  // =====================
  $(window).on('load' + EVENT_KEY + '.data-api', function () {
    $('.selectpicker').each(function () {
      var $selectpicker = $(this);
      Plugin.call($selectpicker, $selectpicker.data());
    })
  });
})(jQuery);

/*
 * Translated default messages for bootstrap-select.
 * Locale: IT (Italian; italiano)
 * Region: IT (Italy; Italia)
 * Author: Michele Beltrame <mb@cattlegrid.info>
 */
(function ($) {
  $.fn.selectpicker.defaults = {
    noneSelectedText: 'Nessuna selezione',
    noneResultsText: 'Nessun risultato per {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? 'Selezionato {0} di {1}' : 'Selezionati {0} di {1}';
    },
    maxOptionsText: ['Limite raggiunto ({n} {var} max)', 'Limite del gruppo raggiunto ({n} {var} max)', ['elementi', 'elemento']],
    multipleSeparator: ', ',
    selectAllText: 'Seleziona Tutto',
    deselectAllText: 'Deseleziona Tutto'
  };
})(jQuery);

/*!
 * @copyright Copyright (c) 2017 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.2.6
 */
/*jslint browser: true */
/*global XDomainRequest, MutationObserver, window */
(function () {
    "use strict";
    if (typeof window !== "undefined" && window.addEventListener) {
        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
        var checkUseElems;
        var tid; // timeout id
        var debouncedCheck = function () {
            clearTimeout(tid);
            tid = setTimeout(checkUseElems, 100);
        };
        var unobserveChanges = function () {
            return;
        };
        var observeChanges = function () {
            var observer;
            window.addEventListener("resize", debouncedCheck, false);
            window.addEventListener("orientationchange", debouncedCheck, false);
            if (window.MutationObserver) {
                observer = new MutationObserver(debouncedCheck);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                unobserveChanges = function () {
                    try {
                        observer.disconnect();
                        window.removeEventListener("resize", debouncedCheck, false);
                        window.removeEventListener("orientationchange", debouncedCheck, false);
                    } catch (ignore) {}
                };
            } else {
                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
                unobserveChanges = function () {
                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
                    window.removeEventListener("resize", debouncedCheck, false);
                    window.removeEventListener("orientationchange", debouncedCheck, false);
                };
            }
        };
        var createRequest = function (url) {
            // In IE 9, cross origin requests can only be sent using XDomainRequest.
            // XDomainRequest would fail if CORS headers are not set.
            // Therefore, XDomainRequest should only be used with cross origin requests.
            function getOrigin(loc) {
                var a;
                if (loc.protocol !== undefined) {
                    a = loc;
                } else {
                    a = document.createElement("a");
                    a.href = loc;
                }
                return a.protocol.replace(/:/g, "") + a.host;
            }
            var Request;
            var origin;
            var origin2;
            if (window.XMLHttpRequest) {
                Request = new XMLHttpRequest();
                origin = getOrigin(location);
                origin2 = getOrigin(url);
                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
                    Request = XDomainRequest || undefined;
                } else {
                    Request = XMLHttpRequest;
                }
            }
            return Request;
        };
        var xlinkNS = "http://www.w3.org/1999/xlink";
        checkUseElems = function () {
            var base;
            var bcr;
            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
            var hash;
            var href;
            var i;
            var inProgressCount = 0;
            var isHidden;
            var Request;
            var url;
            var uses;
            var xhr;
            function observeIfDone() {
                // If done with making changes, start watching for chagnes in DOM again
                inProgressCount -= 1;
                if (inProgressCount === 0) { // if all xhrs were resolved
                    unobserveChanges(); // make sure to remove old handlers
                    observeChanges(); // watch for changes to DOM
                }
            }
            function attrUpdateFunc(spec) {
                return function () {
                    if (cache[spec.base] !== true) {
                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
                        if (spec.useEl.hasAttribute("href")) {
                            spec.useEl.setAttribute("href", "#" + spec.hash);
                        }
                    }
                };
            }
            function onloadFunc(xhr) {
                return function () {
                    var body = document.body;
                    var x = document.createElement("x");
                    var svg;
                    xhr.onload = null;
                    x.innerHTML = xhr.responseText;
                    svg = x.getElementsByTagName("svg")[0];
                    if (svg) {
                        svg.setAttribute("aria-hidden", "true");
                        svg.style.position = "absolute";
                        svg.style.width = 0;
                        svg.style.height = 0;
                        svg.style.overflow = "hidden";
                        body.insertBefore(svg, body.firstChild);
                    }
                    observeIfDone();
                };
            }
            function onErrorTimeout(xhr) {
                return function () {
                    xhr.onerror = null;
                    xhr.ontimeout = null;
                    observeIfDone();
                };
            }
            unobserveChanges(); // stop watching for changes to DOM
            // find all use elements
            uses = document.getElementsByTagName("use");
            for (i = 0; i < uses.length; i += 1) {
                try {
                    bcr = uses[i].getBoundingClientRect();
                } catch (ignore) {
                    // failed to get bounding rectangle of the use element
                    bcr = false;
                }
                href = uses[i].getAttribute("href")
                        || uses[i].getAttributeNS(xlinkNS, "href")
                        || uses[i].getAttribute("xlink:href");
                if (href && href.split) {
                    url = href.split("#");
                } else {
                    url = ["", ""];
                }
                base = url[0];
                hash = url[1];
                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
                    // the use element is empty
                    // if there is a reference to an external SVG, try to fetch it
                    // use the optional fallback URL if there is no reference to an external SVG
                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
                        base = fallback;
                    }
                    if (uses[i].hasAttribute("href")) {
                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
                    }
                    if (base.length) {
                        // schedule updating xlink:href
                        xhr = cache[base];
                        if (xhr !== true) {
                            // true signifies that prepending the SVG was not required
                            setTimeout(attrUpdateFunc({
                                useEl: uses[i],
                                base: base,
                                hash: hash
                            }), 0);
                        }
                        if (xhr === undefined) {
                            Request = createRequest(base);
                            if (Request !== undefined) {
                                xhr = new Request();
                                cache[base] = xhr;
                                xhr.onload = onloadFunc(xhr);
                                xhr.onerror = onErrorTimeout(xhr);
                                xhr.ontimeout = onErrorTimeout(xhr);
                                xhr.open("GET", base);
                                xhr.send();
                                inProgressCount += 1;
                            }
                        }
                    }
                } else {
                    if (!isHidden) {
                        if (cache[base] === undefined) {
                            // remember this URL if the use element was not empty and no request was sent
                            cache[base] = true;
                        } else if (cache[base].onload) {
                            // if it turns out that prepending the SVG is not necessary,
                            // abort the in-progress xhr.
                            cache[base].abort();
                            delete cache[base].onload;
                            cache[base] = true;
                        }
                    } else if (base.length && cache[base]) {
                        setTimeout(attrUpdateFunc({
                            useEl: uses[i],
                            base: base,
                            hash: hash
                        }), 0);
                    }
                }
            }
            uses = "";
            inProgressCount += 1;
            observeIfDone();
        };
        var winLoad;
        winLoad = function () {
            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
            tid = setTimeout(checkUseElems, 0);
        };
        if (document.readyState !== "complete") {
            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
            window.addEventListener("load", winLoad, false);
        } else {
            // No need to add a listener if the document is already loaded, initialize immediately.
            winLoad();
        }
    }
}());

if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

/*
CircularLoader-v1.3.js
Developed by http://technoplugin.com
For support or web development drop a mail at developer@technoplugin.com
*/
!(function(r) {
  function t(r) {
    return (r * Math.PI) / 180
  }
  function e(e, a, s) {
    var o = r('#' + s + 'canvas')[0],
      n = r('#' + s + 'canvas'),
      i = o.getContext('2d'),
      l = o.width / 2,
      d = o.height / 2
    i.beginPath(),
      i.arc(l, d, r(n).attr('data-radius'), 0, 2 * Math.PI, !1),
      (i.fillStyle = 'transparent'),
      i.fill(),
      (i.lineWidth = r(n).attr('data-width')),
      (i.strokeStyle = r(n).attr('data-progressBarBackground')),
      i.stroke(),
      i.closePath(),
      i.beginPath(),
      i.arc(
        l,
        d,
        r(n).attr('data-radius'),
        -t(90),
        -t(90) + t((e / 100) * 360),
        !1
      ),
      (i.fillStyle = 'transparent'),
      i.fill(),
      (i.lineWidth = r(n).attr('data-width')),
      (i.strokeStyle = r(n).attr('data-stroke')),
      i.stroke(),
      i.closePath(),
      'true' ==
        r(n)
          .attr('data-text')
          .toLocaleLowerCase() &&
        r('#' + s + ' .clProg').val(
          a +
            ('true' ==
            r(n)
              .attr('data-percent')
              .toLocaleLowerCase()
              ? '%'
              : '')
        )
  }
  r.fn.circularloader = function(t) {
    function a() {
      h.beginPath(),
        h.arc(u, f, i, 0, 2 * Math.PI, !1),
        (h.fillStyle = n.backgroundColor),
        h.fill(),
        (h.lineWidth = l),
        (h.strokeStyle = n.progressBarBackground),
        h.stroke(),
        h.closePath(),
        c > 0 && e(c, d, o)
    }
    var s = this[0],
      o = s.id
    if (0 == r('#' + o + 'canvas').length) {
      var n = r.extend(
          {
            backgroundColor: '#ffffff',
            fontColor: '#000000',
            fontSize: '40px',
            radius: 70,
            progressBarBackground: '#cdcdcd',
            progressBarColor: '#aaaaaa',
            progressBarWidth: 25,
            progressPercent: 0,
            progressValue: 0,
            showText: !0,
            title: '',
          },
          t
        ),
        i = parseInt(n.radius),
        l = parseInt(n.progressBarWidth),
        d = parseInt(
          parseInt(n.progressValue) > 0 ? n.progressValue : n.progressPercent
        ),
        c = parseInt(n.progressPercent),
        p =
          'color:' +
          n.fontColor +
          ';font-size:' +
          parseInt(n.fontSize) +
          'px;width:' +
          2 * (i + l) +
          'px;vertical-align:middle;position:relative;background-color:transparent;border:0 none;transform:translateY(-48%);-webkit-transform: translateY(-48%);-ms-transform: translateY(-48%);height:' +
          2 * (i + l) +
          'px;margin-left:-' +
          2 * (i + l) +
          'px;text-align:center;padding:0;' +
          (n.showText ? '' : 'display:none;')
      r(
        '<canvas data-width="' +
          l +
          '" data-radius="' +
          i +
          '" data-stroke="' +
          n.progressBarColor +
          '" data-progressBarBackground="' +
          n.progressBarBackground +
          '" data-backgroundColor="' +
          n.backgroundColor +
          '" data-text=' +
          n.showText +
          ' data-percent=' +
          (void 0 == t.progressValue ? !0 : !1) +
          ' id="' +
          o +
          'canvas" width=' +
          2 * (i + l) +
          ' height=' +
          2 * (i + l) +
          '></canvas>'
      ).appendTo(s),
        r(
          '<input class="clProg" style="' +
            p +
            '" value="' +
            d +
            (void 0 == t.progressValue ? '%' : '') +
            '" aria-hidden="true"></input>'
        ).appendTo(s),
        '' == n.title
          ? r('#' + o).css('height', 2 * (i + l))
          : (r('#' + o).css('height', 2 * (i + l) + 20),
            r('#' + o + 'canvas').before(
              "<div class='titleCircularLoader' style='height:19px;text-align:center;'>" +
                n.title +
                '</div>'
            ),
            r('.titleCircularLoader').css('width', 2 * (i + l)))
      {
        var g = r('#' + o + 'canvas')[0],
          h = g.getContext('2d'),
          u = g.width / 2,
          f = g.height / 2
        r('#' + o + 'canvas').offset().left, r('#' + o + 'canvas').offset().top
      }
      a()
    } else if (void 0 != t.progressPercent || void 0 != t.progressValue) {
      var c = 0,
        d = 0
      ;(c =
        void 0 == t.progressPercent
          ? parseInt(t.progressValue) > 100
            ? 100
            : parseInt(t.progressValue)
          : parseInt(t.progressPercent) > 100
          ? 100
          : parseInt(t.progressPercent)),
        (d =
          void 0 == t.progressValue
            ? parseInt(t.progressPercent) > 100
              ? 100
              : parseInt(t.progressPercent)
            : parseInt(t.progressValue)),
        e(c, d, o)
    }
    return this
  }
})(jQuery)

/**
 * Original code by Òscar Casajuana a.k.a. elboletaire <elboletaire at underave dot net>
 * @link https://github.com/elboletaire/password-strength-meter
 */
;(function($) {
  'use strict'

  var Password = function($object, options) {
    var defaults = {
      shortPass: 'Password molto debole',
      badPass: 'Password debole',
      goodPass: 'Password sicura',
      strongPass: 'Password molto sicura',
      enterPass: 'Inserisci almeno 8 caratteri e una lettera maiuscola',
      showText: true,
      minimumLength: 4,
    }

    options = $.extend({}, defaults, options)

    /**
     * Returns strings based on the score given.
     *
     * @param int score Score base.
     * @return string
     */
    function scoreText(score) {
      if (score === -1) {
        return options.shortPass
      }

      score = score < 0 ? 0 : score

      if (score < 26) {
        return options.shortPass
      }
      if (score < 51) {
        return options.badPass
      }
      if (score < 76) {
        return options.goodPass
      }

      return options.strongPass
    }

    function scoreColor(score) {
      if (score === -1) {
        return 'danger'
      }
      if (score === -2) {
        return 'muted'
      }

      score = score < 0 ? 0 : score

      if (score < 26) {
        return 'danger'
      }
      if (score < 51) {
        return 'warning'
      }
      if (score < 76) {
        return 'success'
      }

      return 'success'
    }

    /**
     * Returns a value between -1 and 100 to score
     * the user's password.
     *
     * @param  string password The password to be checked.
     * @return int
     */
    function calculateScore(password) {
      var score = 0

      // password < options.minimumLength
      if (password.length < options.minimumLength) {
        return -1
      }

      // password length
      score += password.length * 4
      score += checkRepetition(1, password).length - password.length
      score += checkRepetition(2, password).length - password.length
      score += checkRepetition(3, password).length - password.length
      score += checkRepetition(4, password).length - password.length

      // password has 3 numbers
      if (password.match(/(.*[0-9].*[0-9].*[0-9])/)) {
        score += 5
      }

      // password has at least 2 sybols
      var symbols = '.*[!,@,#,$,%,^,&,*,?,_,~]'
      symbols = new RegExp('(' + symbols + symbols + ')')
      if (password.match(symbols)) {
        score += 5
      }

      // password has Upper and Lower chars
      if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
        score += 10
      }

      // password has number and chars
      if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) {
        score += 15
      }

      // password has number and symbol
      if (
        password.match(/([!,@,#,$,%,^,&,*,?,_,~])/) &&
        password.match(/([0-9])/)
      ) {
        score += 15
      }

      // password has char and symbol
      if (
        password.match(/([!,@,#,$,%,^,&,*,?,_,~])/) &&
        password.match(/([a-zA-Z])/)
      ) {
        score += 15
      }

      // password is just numbers or chars
      if (password.match(/^\w+$/) || password.match(/^\d+$/)) {
        score -= 10
      }

      if (score > 100) {
        score = 100
      }

      if (score < 0) {
        score = 0
      }

      return score
    }

    /**
     * Checks for repetition of characters in
     * a string
     *
     * @param int rLen Repetition length.
     * @param string str The string to be checked.
     * @return string
     */
    function checkRepetition(rLen, str) {
      var res = '',
        repeated = false
      for (var i = 0; i < str.length; i++) {
        repeated = true
        for (var j = 0; j < rLen && j + i + rLen < str.length; j++) {
          repeated = repeated && str.charAt(j + i) === str.charAt(j + i + rLen)
        }
        if (j < rLen) {
          repeated = false
        }
        if (repeated) {
          i += rLen - 1
          repeated = false
        } else {
          res += str.charAt(i)
        }
      }
      return res
    }

    /**
     * Initializes the plugin creating and binding the
     * required layers and events.
     *
     * @return void
     */
    function init() {
      var shown = true
      var $text = options.showText

      var $graybar = $('<div>').addClass(
        'password-meter progress rounded-0 position-absolute'
      )
      $graybar.append(`<div class="row position-absolute w-100 m-0">
        <div class="col-3 border-left border-right border-white"></div>
        <div class="col-3 border-left border-right border-white"></div>
        <div class="col-3 border-left border-right border-white"></div>
        <div class="col-3 border-left border-right border-white"></div>
      </div>`)
      var $colorbar = $('<div>').attr({
        class: 'progress-bar',
        role: 'progressbar',
        'aria-valuenow': '0',
        'aria-valuemin': '0',
        'aria-valuemax': '100',
      })
      var $insert = $('<div>').attr({
        class: 'password-strength-meter',
      }).append($graybar.append($colorbar))

      if (options.showText) {
        $text = $('<small>')
          .addClass('form-text text-muted')
          .html(options.enterPass)
        $insert.prepend($text)
      }

      $object.after($insert)

      $object.keyup(function() {
        var score = calculateScore($object.val())
        $object.trigger('password.score', [score])
        var perc = score < 0 ? 0 : score
        $colorbar.removeClass(function(index, className) {
          return (className.match(/(^|\s)bg-\S+/g) || []).join(' ')
        })
        $colorbar.addClass('bg-' + scoreColor(score))
        $colorbar.css({
          width: perc + '%',
        })
        $colorbar.attr('aria-valuenow', perc)

        if (options.showText) {
          var text = scoreText(score)
          if (!$object.val().length && score <= 0) {
            text = options.enterPass
          }

          if (
            $text.html() !==
            $('<div>')
              .html(text)
              .html()
          ) {
            $text.html(text)
            $text.removeClass(function(index, className) {
              return (className.match(/(^|\s)text-\S+/g) || []).join(' ')
            })
            $text.addClass('text-' + scoreColor(score))
            $object.trigger('password.text', [text, score])
          }
        }
      })

      return this
    }

    return init.call(this)
  }

  // Bind to jquery
  $.fn.password = function(options) {
    return this.each(function() {
      new Password($(this), options)
    })
  }
})(jQuery)

// Gestione Password Caps Lock
function showCapsLockMsg($input) {
  $('.password-caps').remove()
  $input
    .parents('.form-group')
    .append(
      '<small class="password-caps form-text text-warning position-absolute bg-white w-100">CAPS LOCK inserito</small>'
    )
}

$(function() {
  var isShiftPressed = false
  var isCapsOn = null

  $('.input-password')
    .on('keydown', function(e) {
      var keyCode = e.keyCode ? e.keyCode : e.which
      if (keyCode == 16) {
        isShiftPressed = true
      }
    })
    .on('keyup', function(e) {
      var keyCode = e.keyCode ? e.keyCode : e.which
      if (keyCode == 16) {
        isShiftPressed = false
      }
      if (keyCode == 20) {
        if (isCapsOn) {
          isCapsOn = false
          $('.password-caps').remove()
        } else {
          isCapsOn = true
          $('input:focus').each(function(e) {
            showCapsLockMsg($(this))
          })
        }
      }
    })
    .on('keypress', function(e) {
      var keyCode = e.keyCode ? e.keyCode : e.which
      // i keyCode dal 65 al 90 identificano i caratteri alfabetici maiuscoli da "A" a "Z"
      if (keyCode >= 65 && keyCode <= 90 && !isShiftPressed) {
        isCapsOn = true
        showCapsLockMsg($(this))
      }
    })

  $('.input-password-strength-meter').password()

  $('.password-icon').on('click', function(e) {
    $(this)
      .find('[class^="password-icon"]')
      .toggleClass('d-none')
    var input = $(this).siblings('.input-password')
    var inputType = input.attr('type') === 'password' ? 'text' : 'password'
    input.attr('type', inputType)
  })
})

;(function() {
  'use strict'

  if (typeof Date.dp_locales === 'undefined') {
    Date.dp_locales = {
      texts: {
        buttonTitle: 'Scegli la data ...',
        buttonLabel:
          'Fare clic o premere il tasto Invio o la barra spaziatrice per aprire il calendario',
        prevButtonLabel: 'Vai al mese precedente',
        nextButtonLabel: 'Vai al mese successivo',
        closeButtonTitle: 'Chiudere',
        closeButtonLabel: 'Chiudere il calendario',
        prevMonthButtonLabel: "Vai all'anno precedente",
        prevYearButtonLabel: "Vai a vent'anni precedenti",
        nextMonthButtonLabel: 'Vai al prossimo anno',
        nextYearButtonLabel: 'Vai ai prossimi 20 anni',
        changeMonthButtonLabel:
          'Fare clic o premere il tasto Invio o la barra spaziatrice per cambiare il mese',
        changeYearButtonLabel:
          "Fare clic o premere il tasto Invio o la barra spaziatrice per cambiare l'anno",
        changeRangeButtonLabel:
          'Fare clic o premere il tasto Invio o la barra spaziatrice per andare ai prossimi 20 anni',
        calendarHelp:
          "- Freccia e Freccia giù - va allo stesso giorno della settimana in settimana precedente o successiva, rispettivamente. Se viene raggiunta la fine del mese, continua nel mese precedente o successivo a seconda dei casi.\r\n- Freccia Sinistra e Freccia destra - avanza un giorno all'altro, anche in un continuum. Visivamente fuoco viene spostato da un giorno all'altro e avvolge da riga a riga nella griglia di giorni.\r\n- Control + Pagina Su - Passa alla stessa data dell'anno precedente.\r\n- Control + Pagina giù - Passa alla stessa data nel prossimo anno.\r\n- Home - Passa al primo giorno del mese in corso.\r\n- End - Passa l'ultimo giorno del mese corrente.\r\n- Pagina Su - Passa alla stessa data del mese precedente.\r\n- Pagina giù - Passa alla stessa data del mese successivo.\r\n- Invio o Espace - chiude il calendario e la data selezionata viene visualizzata nella casella di testo associato.\r\n- Escape - chiude il calendario senza alcuna azione.",
      },
      directionality: 'LTR',
      month_names: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre',
      ],
      month_names_abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic',
      ],
      month_names_narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D',
      ],
      day_names: [
        'domenica',
        'lunedì',
        'martedì',
        'mercoledì',
        'giovedì',
        'venerdì',
        'sabato',
      ],
      day_names_abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
      day_names_short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
      day_names_narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
      day_periods: {
        am: 'AM',
        noon: 'mezzogiorno',
        pm: 'PM',
      },
      day_periods_abbreviated: {
        am: 'AM',
        noon: 'mezzogiorno',
        pm: 'PM',
      },
      day_periods_narrow: {
        am: 'm.',
        noon: 'n',
        pm: 'p.',
      },
      quarter_names: [
        '1º trimestre',
        '2º trimestre',
        '3º trimestre',
        '4º trimestre',
      ],
      quarter_names_abbreviated: ['T1', 'T2', 'T3', 'T4'],
      quarter_names_narrow: ['1', '2', '3', '4'],
      era_names: ['a.C.', 'd.C.'],
      era_names_abbreviated: ['aC', 'dC'],
      era_names_narrow: ['aC', 'dC'],
      full_format: 'EEEE d MMMM y',
      long_format: 'd MMMM y',
      medium_format: 'dd MMM y',
      short_format: 'dd/MM/yy',
      firstday_of_week: 1,
    }
  }
})()

/*!
 * Accessible Datepicker v2.1.10
 * Copyright 2015-2017 Eureka2, Jacques Archimède.
 * Based on the example of the Open AJAX Alliance Accessibility Tools Task Force : http://www.oaa-accessibility.org/examplep/datepicker1/
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * Inspired by :
 * http://wet-boew.github.io/wet-boew/demos/datepicker/datepicker-fr.html
 * http://eternicode.github.io/bootstrap-datepicker
 */

/**
 *	Description:
 *	===========
 *	This DatePicker widget allows the user to select a date.
 *	The DatePicker shows one month at least.
 *
 *	The calendar portion of the date picker follows a table structure
 *	where days of the week and calendar day numbers are layed out in HTML table cells where WAI-ARIA semantics for a grid are applied.
 *	This provides context so an assistive technology can render the day of the week;
 *	its corresponding numeric calendar day, and week number if necessary.
 *
 *	The calendar portion can be displayed in a numbers of ways, including as a popup associated with another widget,
 *	or as a static region of a page.
 *
 * 	This component complies with the recommendations of the guide http://www.w3.org/TR/wai-aria-practices/#datepicker of W3C, namely :
 *
 *	Keyboard Interaction:
 *	=====================
 *
 *	Keyboard navigation on days that are not included the currently displayed month should move to the month automatically and lead to the day in the next or previous month.
 *
 *		- Tab - Like other widgets, the date picker widget receives focus by tabbing into it. Once focus is received, focus is repositioned on today's date in a grid of days and weeks. A second tab will take the user out of the date picker widget. Focus initially is placed on today's date.
 *		- Shift+Tab - reverses the direction of the tab order. Once in the widget, a Shift+Tab will take the user to the previous focusable element in the tab order.
 *		- Up Arrow and Down Arrow - goes to the same day of the week in the previous or next week respectively. If the user advances past the end of the month they continue into the next or previous month as appropriate.
 *		- Left Arrow and Right Arrow - advances one day to the next, also in a continuum. Visually focus is moved from day to day and wraps from row to row in a grid of days and weeks.
 *		- Alt+Page Up - Moves to the same date in the previous year.
 *		- Alt+Page Down - Moves to the same date in the next year.
 *		- Space -
 *			Singleton Mode: acts as a toggle either selecting or deselecting the date.
 *			Contiguous Mode: Similar to selecting a range of text. Space selects the first date. Shift+Arrows add to the selection. Pressing Space again deselects the previous selections and selects the current focused date.
 *		- Home - Moves to the first day of the current month.
 *		- End - Moves to the last day of the current month.
 *		- Page Up - Moves to the same date in the previous month.
 *		- Page Down - Moves to the same date in the next month.
 *		- Enter -
 *			If the the calendar is a popup attached to some other widget (e.g., a text field), then Enter dismisses the popup, and the selected date(s) are shown in the associated widget.
 *			If the calendar is a static region on the page, then Enter confirms the selected date(s).
 *		- Escape - in the case of a popup date picker, closes the widget without any action.
 *
 *
 *	WAI-ARIA Roles, States, and Properties:
 *	======================================
 *
 *		The current month has a label representing the month and year. It is advisable to use a role heading but is not essential. This "label" should have a unique ID.
 *		If the author would like to ensure that a label is announced by a screen reader, as the label changes, include live region properties with the label element: aria-live="assertive" and aria-atomic="true".
 *		The container for the day of week headers and numeric days of the week has a role of grid.
 *		The grid has an aria-labelledby property with a value equivalent to the id of the label for the grid.
 *		Each name for the day of the week has a role columnheader and is not navigable via the keyboard.
 *		Each numeric day of the week has the role gridcell.
 *		When a day is selected its aria-selected is set to true, otherwise it is set to false or removed.
 *		Changes in aria states, identified here, as well as focus, are clearly styled to show the user where their point of regard is and what days are selected.
 *
 *	When the datepicker is active a calender day of the week always has focus.
 *	This can be achieved by setting the tabindex on that day as appropriate and then using script to give it focus.
 *	The grid container set aria-activedescendant to the id of the currently focused gridcell.
 *
 */

;(function() {
  'use strict'
  if (typeof Date.dp_locales === 'undefined') {
    Date.dp_locales = {
      texts: {
        buttonTitle: 'Select date ...',
        buttonLabel:
          'Click or press the Enter key or the spacebar to open the calendar',
        prevButtonLabel: 'Go to previous month',
        prevMonthButtonLabel: 'Go to the previous year',
        prevYearButtonLabel: 'Go to the previous twenty years',
        nextButtonLabel: 'Go to next month',
        nextMonthButtonLabel: 'Go to the next year',
        nextYearButtonLabel: 'Go to the next twenty years',
        changeMonthButtonLabel:
          'Click or press the Enter key or the spacebar to change the month',
        changeYearButtonLabel:
          'Click or press the Enter key or the spacebar to change the year',
        changeRangeButtonLabel:
          'Click or press the Enter key or the spacebar to go to the next twenty years',
        closeButtonTitle: 'Close',
        closeButtonLabel: 'Close the calendar',
        calendarHelp:
          '- Up Arrow and Down Arrow - goes to the same day of the week in the previous or next week respectively. If the end of the month is reached, continues into the next or previous month as appropriate.\r\n- Left Arrow and Right Arrow - advances one day to the next, also in a continuum. Visually focus is moved from day to day and wraps from row to row in the grid of days.\r\n- Control+Page Up - Moves to the same date in the previous year.\r\n- Control+Page Down - Moves to the same date in the next year.\r\n- Home - Moves to the first day of the current month.\r\n- End - Moves to the last day of the current month.\r\n- Page Up - Moves to the same date in the previous month.\r\n- Page Down - Moves to the same date in the next month.\r\n- Enter or Espace - closes the calendar, and the selected date is shown in the associated text box.\r\n- Escape - closes the calendar without any action.',
      },
      directionality: 'LTR',
      month_names: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      month_names_abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      month_names_narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D',
      ],
      day_names: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      day_names_abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      day_names_short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      day_names_narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      day_periods: {
        am: 'AM',
        noon: 'noon',
        pm: 'PM',
      },
      day_periods_abbreviated: {
        am: 'AM',
        noon: 'noon',
        pm: 'PM',
      },
      day_periods_narrow: {
        am: 'a',
        noon: 'n',
        pm: 'p',
      },
      quarter_names: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter',
      ],
      quarter_names_abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
      quarter_names_narrow: ['1', '2', '3', '4'],
      era_names: ['Before Christ', 'Anno Domini'],
      era_names_abbreviated: ['BC', 'AD'],
      era_names_narrow: ['B', 'A'],
      full_format: 'EEEE, MMMM d, y',
      long_format: 'MMMM d, y',
      medium_format: 'MMM d, y',
      short_format: 'M/d/yy',
      firstday_of_week: 0,
    }
  }
})()
;(function(factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory)
  } else if (typeof exports === 'object') {
    factory(require('jquery'))
  } else {
    if (typeof jQuery === 'undefined') {
      throw new Error("Datepicker's JavaScript requires jQuery")
    }
    factory(jQuery)
  }
})(function($, undefined) {
  'use strict'

  var datepickerButton = [
    '<a class="datepicker-button input-group-addon btn" role="button" aria-haspopup="true" tabindex="0" aria-labelledby="datepicker-bn-open-label-CALENDARID">',
    '	<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>it-calendar</title><g><path d="M21,9V8a3,3,0,0,0-3-3h-.55V4a1,1,0,0,0-2,0V5h-7V4a1,1,0,1,0-2,0V5H6A3,3,0,0,0,3,8V18a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V9ZM15.46,5h2V6a1,1,0,1,1-2,0Zm-9,0h2V6a1,1,0,1,1-2,0ZM20,18a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V10H20Z"/></g></svg>',
    '</a>',
  ]
  var datepickerCalendar = [
    '<div class="datepicker-calendar" id="datepicker-calendar-CALENDARID" aria-hidden="false">',
    '	<div class="datepicker-month-wrap">',
    '		<div class="datepicker-month-fast-next pull-right" role="button" aria-labelledby="datepicker-bn-fast-next-label-CALENDARID" tabindex="0"><span class="icon-right"></span><span class="icon-right"></span></div>',
    '		<div class="datepicker-month-next pull-right" role="button" aria-labelledby="datepicker-bn-next-label-CALENDARID" tabindex="0"><span class="icon-right"></span></div>',
    '		<div class="datepicker-month-fast-prev pull-left" role="button" aria-labelledby="datepicker-bn-fast-prev-label-CALENDARID" tabindex="0"><span class="icon-left"></span><span class="icon-left"></span></div>',
    '		<div class="datepicker-month-prev pull-left" role="button" aria-labelledby="datepicker-bn-prev-label-CALENDARID" tabindex="0"><span class="icon-left"></span></div>',
    '		<div id="datepicker-month-CALENDARID" class="datepicker-month" tabindex="0" role="heading" aria-live="assertive" aria-atomic="true" title="Click or press the Enter key or the spacebar to change the month">July 2015</div>',
    '	</div>',
    '	<table class="datepicker-grid" role="grid" aria-readonly="true" aria-activedescendant="datepicker-err-msg-CALENDARID" aria-labelledby="datepicker-month-CALENDARID" tabindex="0">',
    '		<thead>',
    '			<tr class="datepicker-weekdays" role="row">',
    '				<th scope="col" id="day0-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Sunday"><abbr title="Sunday">Su</abbr></th>',
    '				<th scope="col" id="day1-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Monday"><abbr title="Monday">Mo</abbr></th>',
    '				<th scope="col" id="day2-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Tuesday"><abbr title="Tuesday">Tu</abbr></th>',
    '				<th scope="col" id="day3-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Wednesday"><abbr title="Wednesday">We</abbr></th>',
    '				<th scope="col" id="day4-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Thursday"><abbr title="Thursday">Th</abbr></th>',
    '				<th scope="col" id="day5-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Friday"><abbr title="Friday">Fr</abbr></th>',
    '				<th scope="col" id="day6-header-CALENDARID" class="datepicker-day" role="columnheader" aria-label="Saturday"><abbr title="Saturday">Sa</abbr></th>',
    '			</tr>',
    '		</thead>',
    '		<tbody>',
    '			<tr>',
    '				<td id="datepicker-err-msg-CALENDARID" colspan="7"><span>Javascript must be enabled</span></td>',
    '			</tr>',
    '		</tbody>',
    '	</table>',
    '	<div class="datepicker-close-wrap">',
    '		<button class="datepicker-close" id="datepicker-close-CALENDARID" aria-labelledby="datepicker-bn-close-label-CALENDARID">Close</button>',
    '	</div>',
    '	<div id="datepicker-bn-open-label-CALENDARID" class="datepicker-bn-open-label offscreen">Click or press the Enter key or the spacebar to open the calendar</div>',
    '	<div id="datepicker-bn-prev-label-CALENDARID" class="datepicker-bn-prev-label offscreen">Go to previous month</div>',
    '	<div id="datepicker-bn-next-label-CALENDARID" class="datepicker-bn-next-label offscreen">Go to next month</div>',
    '	<div id="datepicker-bn-fast-prev-label-CALENDARID" class="datepicker-bn-fast-prev-label offscreen">Go to previous year</div>',
    '	<div id="datepicker-bn-fast-next-label-CALENDARID" class="datepicker-bn-fast-next-label offscreen">Go to next year</div>',
    '	<div id="datepicker-bn-close-label-CALENDARID" class="datepicker-bn-close-label offscreen">Close the date picker</div>',
    '</div>',
  ]

  var Datepicker = function(target, options) {
    var self = this
    this.$target = $(target) // textbox that will receive the selected date string and focus (if modal)
    this.options = $.extend({}, Datepicker.DEFAULTS, options)
    this.locales = Date.dp_locales
    this.startview(this.options.startView)
    if (typeof this.options.inputFormat === 'string') {
      this.options.inputFormat = [this.options.inputFormat]
    }
    if (!$.isArray(this.options.datesDisabled)) {
      this.options.datesDisabled = [this.options.datesDisabled]
    }
    $.each(this.options.datesDisabled, function(i, v) {
      if (typeof v === 'string') {
        var date = self.parseDate(v)
        if (date === null) {
          self.options.datesDisabled[i] = null
        } else {
          self.options.datesDisabled[i] = self.format(date)
        }
      } else if (v instanceof Date && !isNaN(v.valueOf())) {
        self.options.datesDisabled[i] = self.format(v)
      } else {
        self.options.datesDisabled[i] = null
      }
    })
    if (this.options.min != null) {
      this.options.min = this.parseDate(this.options.min)
    } else if (this.$target.attr('min')) {
      this.options.min = this.parseDate(this.$target.attr('min'))
    }
    if (this.options.max != null) {
      this.options.max = this.parseDate(this.options.max)
    } else if (this.$target.attr('max')) {
      this.options.max = this.parseDate(this.$target.attr('max'))
    }
    if (typeof this.options.previous === 'string') {
      this.options.previous = $(this.options.previous)
    } else if (!(this.options.previous instanceof jQuery)) {
      this.options.previous = null
    }
    if (typeof this.options.next === 'string') {
      this.options.next = $(this.options.next)
    } else if (!(this.options.next instanceof jQuery)) {
      this.options.next = null
    }
    this.id =
      this.$target.attr('id') ||
      'datepicker-' + Math.floor(Math.random() * 100000)
    var calendar = datepickerCalendar.join('')
    calendar = calendar.replace(/CALENDARID/g, this.id + '')

    // complete the target textbox if any
    if (this.$target.parent('.input-group').length == 0) {
      this.$target.wrap('<div class="input-group"></div>')
    }
    this.$label = this.$target.parents().find('label[for=' + this.id + ']')
    this.$group = this.$target.parent('.input-group')
    this.$target.attr('aria-autocomplete', 'none')
    this.$target.css('min-width', '7em')
    this.$target.addClass('form-control')

    if (!this.$target.attr('placeholder')) {
      this.$target.attr('placeholder', this.options.inputFormat[0])
    }

    var button = datepickerButton.join('')
    button = button.replace(/CALENDARID/g, this.id + '')
    this.$button = $(button)
    this.$button.addClass(this.options.theme)
    this.$calendar = $(calendar)
    this.$calendar.addClass(this.options.theme)
    this.$target.after(this.$button)

    // be sure parent of the calendar is positionned  to calculate the position of the calendar
    if (this.$calendar.parent().css('position') === 'static') {
      this.$calendar.parent().css('position', 'relative')
    }
    this.$calendar
      .find('.datepicker-bn-open-label')
      .html(this.options.buttonLabel)
    if (this.$target.attr('id')) {
      this.$calendar.attr('aria-controls', this.$target.attr('id'))
    }
    this.$button.find('span').attr('title', this.options.buttonTitle)
    this.$calendar.css('left', this.$target.parent().position().left + 'px')
    this.$monthObj = this.$calendar.find('.datepicker-month')
    this.$prev = this.$calendar.find('.datepicker-month-prev')
    this.$next = this.$calendar.find('.datepicker-month-next')
    this.$fastprev = this.$calendar.find('.datepicker-month-fast-prev')
    this.$fastnext = this.$calendar.find('.datepicker-month-fast-next')
    this.$grid = this.$calendar.find('.datepicker-grid')
    if (this.locales.directionality === 'RTL') {
      this.$grid.addClass('rtl')
    }
    var $days = this.$grid.find('th.datepicker-day abbr')
    this.drawCalendarHeader()
    if (this.options.inline == false && this.options.modal == true) {
      this.$close = this.$calendar.find('.datepicker-close')
      this.$close
        .html(this.options.closeButtonTitle)
        .attr('title', this.options.closeButtonLabel)
      this.$calendar
        .find('.datepicker-bn-close-label')
        .html(this.options.closeButtonLabel)
    } else {
      this.hideObject(this.$calendar.find('.datepicker-close-wrap'))
      this.hideObject(this.$calendar.find('.datepicker-bn-close-label'))
    }

    if (this.options.inline != false) {
      this.hideObject(this.$button)
      var $container =
        typeof this.options.inline === 'string'
          ? $('#' + this.options.inline)
          : this.options.inline
      $container.append(this.$calendar)
      this.$calendar.css({ position: 'relative', left: '0px' })
      this.initializeDate()
    } else {
      this.$calendar.css({ display: 'none' })
      this.$target.parent().after(this.$calendar)
      this.hide(!this.options.gainFocusOnConstruction)
    }

    this.keys = {
      tab: 9,
      enter: 13,
      esc: 27,
      space: 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
    }

    this.bindHandlers()
    this.$button.click(function(e) {
      if (!$(this).hasClass('disabled')) {
        if (self.$calendar.attr('aria-hidden') === 'true') {
          self.initializeDate()
          self.show()
        } else {
          self.hide()
        }
        self.selectGridCell(self.$grid.attr('aria-activedescendant'))
      }
      e.stopPropagation()
      return false
    })
    this.$button.keydown(function(e) {
      var ev = e || event
      if (ev.keyCode == self.keys.enter || ev.keyCode == self.keys.space) {
        $(this).trigger('click')
        return false
      }
    })
    this.$calendar.on('blur', function(e) {
      if (self.$calendar.attr('aria-hidden') === 'false') {
        self.hide()
      }
    })
  }

  Datepicker.VERSION = '2.1.10'

  Datepicker.DEFAULTS = {
    firstDayOfWeek: Date.dp_locales.firstday_of_week, // Determines the first column of the calendar grid
    weekDayFormat: 'short', // Display format of the weekday names - values are 'short' or 'narrow'
    startView: 0, // Initial calendar - values are 0 or 'days', 1 or 'months', 2 or 'years'
    daysOfWeekDisabled: [],
    datesDisabled: [],
    isDateDisabled: null,
    isMonthDisabled: null,
    isYearDisabled: null,
    inputFormat: [Date.dp_locales.short_format],
    outputFormat: Date.dp_locales.short_format,
    titleFormat: Date.dp_locales.full_format,
    buttonTitle: Date.dp_locales.texts.buttonTitle,
    buttonLabel: Date.dp_locales.texts.buttonLabel,
    prevButtonLabel: Date.dp_locales.texts.prevButtonLabel,
    prevMonthButtonLabel: Date.dp_locales.texts.prevMonthButtonLabel,
    prevYearButtonLabel: Date.dp_locales.texts.prevYearButtonLabel,
    nextButtonLabel: Date.dp_locales.texts.nextButtonLabel,
    nextMonthButtonLabel: Date.dp_locales.texts.nextMonthButtonLabel,
    nextYearButtonLabel: Date.dp_locales.texts.nextYearButtonLabel,
    changeMonthButtonLabel: Date.dp_locales.texts.changeMonthButtonLabel,
    changeYearButtonLabel: Date.dp_locales.texts.changeYearButtonLabel,
    changeRangeButtonLabel: Date.dp_locales.texts.changeRangeButtonLabel,
    closeButtonTitle: Date.dp_locales.texts.closeButtonTitle,
    closeButtonLabel: Date.dp_locales.texts.closeButtonLabel,
    onUpdate: function(value) {},
    previous: null,
    next: null,
    theme: 'default',
    modal: false,
    inline: false,
    gainFocusOnConstruction: false,
    min: null,
    max: null,
  }

  /**
   *	initializeDate() is a member function to initialize the Datepicker date with the content of the target textbox
   *
   *	@return N/A
   *
   */
  Datepicker.prototype.initializeDate = function() {
    var val = this.$target.val()
    var date = val === '' ? new Date() : this.parseDate(val)
    this.setDate(date, true)
  } // end initializeDate()

  /**
   * getDate() is a member function to retrieve the current Datepicker date.
   * @return the Date object
   */
  Datepicker.prototype.getDate = function() {
    var val = this.$target.val()
    var date = val === '' ? new Date() : this.parseDate(val)
    return date
  } // end getDate()

  /**
   *	setDate() is a member function to set the Datepicker date with the content of newDate
   *
   *	@param	(newDate Date) the new value of the Datepicker date.
   *	@return N/A
   *
   */
  Datepicker.prototype.setDate = function(newDate, init) {
    this.dateObj = newDate
    init = typeof init === 'undefined' ? false : init
    if (this.dateObj == null) {
      this.$target.attr('aria-invalid', true)
      this.$target.parents('.form-group').addClass('has-error')
      this.dateObj = new Date()
      this.dateObj.setHours(0, 0, 0, 0)
    }
    if (this.options.min != null && this.dateObj < this.options.min) {
      this.$target.attr('aria-invalid', true)
      this.$target.parents('.form-group').addClass('has-error')
      this.dateObj = this.options.min
    } else if (this.options.max != null && this.dateObj > this.options.max) {
      this.$target.attr('aria-invalid', true)
      this.$target.parents('.form-group').addClass('has-error')
      this.dateObj = this.options.max
    }
    if (!init || this.$target.val() != '') {
      this.$target.val(this.format(this.dateObj))
    }
    this.curYear = this.dateObj.getFullYear()
    this.year = this.curYear
    this.curMonth = this.dateObj.getMonth()
    this.month = this.curMonth
    this.date = this.dateObj.getDate()
    // populate the calendar grid
    switch (this.options.startView) {
      case 1: // months
        this.populateMonthsCalendar()
        // update the table's activedescdendant to point to the current month
        this.$grid.attr(
          'aria-activedescendant',
          this.$grid.find('.curMonth').attr('id')
        )
        break
      case 2: // years
        this.populateYearsCalendar()
        // update the table's activedescdendant to point to the current year
        this.$grid.attr(
          'aria-activedescendant',
          this.$grid.find('.curYear').attr('id')
        )
        break
      default:
        this.populateDaysCalendar()
        // update the table's activedescdendant to point to the current day
        this.$grid.attr(
          'aria-activedescendant',
          this.$grid.find('.curDay').attr('id')
        )
    }
  } // end setDate()

  /**
   *	drawCalendarHeader() is a member function to populate the calendar header with the days name.
   *
   *	@return N/A
   */
  Datepicker.prototype.drawCalendarHeader = function() {
    var $days = this.$grid.find('th.datepicker-day')
    var weekday = this.options.firstDayOfWeek
    for (var i = 0; i < 7; i++) {
      $days.eq(i).attr('aria-label', this.locales.day_names[weekday])
      $days
        .children('abbr')
        .eq(i)
        .attr('title', this.locales.day_names[weekday])
        .text(
          this.options.weekDayFormat === 'short'
            ? this.locales.day_names_short[weekday]
            : this.locales.day_names_narrow[weekday]
        )
      weekday = (weekday + 1) % 7
    }
  } // end drawCalendarHeader()

  /**
   *	populateDaysCalendar() is a member function to populate the datepicker grid with calendar days
   *	representing the current month
   *
   *	@return N/A
   *
   */
  Datepicker.prototype.populateDaysCalendar = function() {
    this.$calendar
      .find('.datepicker-bn-prev-label')
      .html(this.options.prevButtonLabel)
    this.$calendar
      .find('.datepicker-bn-next-label')
      .html(this.options.nextButtonLabel)
    this.$calendar
      .find('.datepicker-bn-fast-prev-label')
      .html(this.options.prevMonthButtonLabel)
    this.$calendar
      .find('.datepicker-bn-fast-next-label')
      .html(this.options.nextMonthButtonLabel)
    if (
      this.options.min != null &&
      (this.year - 1 < this.options.min.getFullYear() ||
        (this.year - 1 == this.options.min.getFullYear() &&
          this.month < this.options.min.getMonth()))
    ) {
      this.$fastprev.attr('title', '')
      this.$fastprev.addClass('disabled')
      this.$fastprev.removeClass('enabled')
    } else {
      this.$fastprev.attr('title', this.options.prevMonthButtonLabel)
      this.$fastprev.addClass('enabled')
      this.$fastprev.removeClass('disabled')
    }
    var previousMonth = this.previousMonth(this.year, this.month)
    if (
      this.options.min != null &&
      (previousMonth.year < this.options.min.getFullYear() ||
        (previousMonth.year == this.options.min.getFullYear() &&
          previousMonth.month < this.options.min.getMonth()))
    ) {
      this.$prev.attr('title', '')
      this.$prev.addClass('disabled')
      this.$prev.removeClass('enabled')
    } else {
      this.$prev.attr('title', this.options.prevButtonLabel)
      this.$prev.addClass('enabled')
      this.$prev.removeClass('disabled')
    }
    this.$monthObj.attr('title', this.options.changeMonthButtonLabel)
    var nextMonth = this.nextMonth(this.year, this.month)
    if (
      this.options.max != null &&
      (nextMonth.year > this.options.max.getFullYear() ||
        (nextMonth.year == this.options.max.getFullYear() &&
          nextMonth.month > this.options.max.getMonth()))
    ) {
      this.$next.attr('title', '')
      this.$next.addClass('disabled')
      this.$next.removeClass('enabled')
    } else {
      this.$next.attr('title', this.options.nextButtonLabel)
      this.$next.addClass('enabled')
      this.$next.removeClass('disabled')
    }
    if (
      this.options.max != null &&
      (this.year + 1 > this.options.max.getFullYear() ||
        (this.year + 1 == this.options.max.getFullYear() &&
          this.month > this.options.max.getMonth()))
    ) {
      this.$fastnext.attr('title', '')
      this.$fastnext.addClass('disabled')
      this.$fastnext.removeClass('enabled')
    } else {
      this.$fastnext.attr('title', this.options.nextMonthButtonLabel)
      this.$fastnext.addClass('enabled')
      this.$fastnext.removeClass('disabled')
    }
    this.showObject(this.$fastprev)
    this.showObject(this.$fastnext)
    var numDays = this.getDaysInMonth(this.year, this.month)
    var numPrevDays = this.getDaysInMonth(
      previousMonth.year,
      previousMonth.month
    )
    var startWeekday = new Date(this.year, this.month, 1).getDay()
    var lastDayOfWeek = (this.options.firstDayOfWeek + 6) % 7
    var curDay = 1
    var rowCount = 1
    this.$monthObj.html(this.locales.month_names[this.month] + ' ' + this.year)
    this.showObject(this.$grid.find('thead'))
    // clear the grid
    var gridCells = '\t<tr id="row0-' + this.id + '" role="row">\n'
    // Insert the leading empty cells
    var numEmpties = 0
    var weekday = this.options.firstDayOfWeek
    while (weekday != startWeekday) {
      numEmpties++
      weekday = (weekday + 1) % 7
    }
    for (; numEmpties > 0; numEmpties--) {
      gridCells +=
        '\t\t<td class="empty">' + (numPrevDays - numEmpties + 1) + '</td>\n'
    }
    var isYearDisabled =
      this.options.isYearDisabled && this.options.isYearDisabled(this.year)
    var isMonthDisabled =
      this.options.isMonthDisabled &&
      this.options.isMonthDisabled(this.year, this.month + 1)
    // insert the days of the month.
    for (curDay = 1; curDay <= numDays; curDay++) {
      var date = new Date(this.year, this.month, curDay, 0, 0, 0, 0)
      var longdate = this.formatDate(date, this.options.titleFormat)
      var curDayClass =
        curDay == this.date &&
        this.month == this.curMonth &&
        this.year == this.curYear
          ? ' curDay'
          : ''
      if (isYearDisabled || isMonthDisabled) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else if ($.inArray(weekday, this.options.daysOfWeekDisabled) > -1) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else if (this.options.min != null && date < this.options.min) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else if (this.options.max != null && date > this.options.max) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else if (
        $.inArray(this.format(date), this.options.datesDisabled) > -1
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else if (
        this.options.isDateDisabled &&
        this.options.isDateDisabled(date)
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day unselectable' +
          curDayClass +
          '"'
      } else {
        gridCells +=
          '\t\t<td id="cell' +
          curDay +
          '-' +
          this.id +
          '" class="day selectable' +
          curDayClass +
          '"'
      }
      gridCells += ' data-value="' + curDay + '"'
      gridCells += ' title="' + longdate + '"'
      gridCells += ' aria-label="' + longdate + '"'
      gridCells +=
        ' headers="day' +
        weekday +
        '-header-' +
        this.id +
        '" role="gridcell" tabindex="-1" aria-selected="false"><span>' +
        curDay +
        '</span>'
      gridCells += '</td>'
      if (weekday == lastDayOfWeek && curDay < numDays) {
        // This was the last day of the week, close it out
        // and begin a new one
        gridCells +=
          '\t</tr>\n\t<tr id="row' +
          rowCount +
          '-' +
          this.id +
          '" role="row">\n'
        rowCount++
      }
      if (curDay < numDays) {
        weekday = (weekday + 1) % 7
      }
    }
    // Insert any trailing empty cells
    while (weekday != lastDayOfWeek) {
      gridCells += '\t\t<td class="empty">' + ++numEmpties + '</td>\n'
      weekday = (weekday + 1) % 7
    }
    gridCells += '\t</tr>'
    var $tbody = this.$grid.find('tbody')
    $tbody.empty()
    $tbody.append(gridCells)
    this.gridType = 0 // 0 = days grid, 1 = months grid, 2 = years Grid
  } // end populateDaysCalendar()

  /**
   *	populateMonthsCalendar() is a member function to populate the datepicker grid with calendar months
   *	representing the current year
   *
   *	@return N/A
   *
   */
  Datepicker.prototype.populateMonthsCalendar = function() {
    this.$calendar
      .find('.datepicker-bn-prev-label')
      .html(this.options.prevMonthButtonLabel)
    this.$calendar
      .find('.datepicker-bn-next-label')
      .html(this.options.nextMonthButtonLabel)
    this.hideObject(this.$fastprev)
    this.hideObject(this.$fastnext)
    if (
      this.options.min != null &&
      this.year - 1 < this.options.min.getFullYear()
    ) {
      this.$prev.attr('title', '')
      this.$prev.addClass('disabled')
      this.$prev.removeClass('enabled')
    } else {
      this.$prev.attr('title', this.options.prevMonthButtonLabel)
      this.$prev.addClass('enabled')
      this.$prev.removeClass('disabled')
    }
    this.$monthObj.attr('title', this.options.changeYearButtonLabel)
    if (
      this.options.max != null &&
      this.year + 1 > this.options.max.getFullYear()
    ) {
      this.$next.attr('title', '')
      this.$next.addClass('disabled')
      this.$next.removeClass('enabled')
    } else {
      this.$next.attr('title', this.options.nextMonthButtonLabel)
      this.$next.addClass('enabled')
      this.$next.removeClass('disabled')
    }
    var curMonth = 0
    var rowCount = 1
    var $tbody = this.$grid.find('tbody')
    this.$monthObj.html(this.year)
    // clear the grid
    this.hideObject(this.$grid.find('thead'))
    $tbody.empty()
    $('#datepicker-err-msg-' + this.id).empty()
    var gridCells = '\t<tr id="row0-' + this.id + '" role="row">\n'
    var isYearDisabled =
      this.options.isYearDisabled && this.options.isYearDisabled(this.year)
    // insert the months of the year.
    for (curMonth = 0; curMonth < 12; curMonth++) {
      if (isYearDisabled) {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month unselectable"'
      } else if (curMonth == this.month && this.year == this.curYear) {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month curMonth selectable"'
      } else if (
        this.options.min != null &&
        (this.year < this.options.min.getFullYear() ||
          (this.year == this.options.min.getFullYear() &&
            curMonth < this.options.min.getMonth()))
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month unselectable"'
      } else if (
        this.options.max != null &&
        (this.year > this.options.max.getFullYear() ||
          (this.year == this.options.max.getFullYear() &&
            curMonth > this.options.max.getMonth()))
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month unselectable"'
      } else if (
        this.options.isMonthDisabled &&
        this.options.isMonthDisabled(this.year, curMonth + 1)
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month unselectable"'
      } else {
        gridCells +=
          '\t\t<td id="cell' +
          (curMonth + 1) +
          '-' +
          this.id +
          '" class="month selectable"'
      }
      gridCells += ' data-value="' + curMonth + '"'
      gridCells +=
        ' title="' + this.locales.month_names[curMonth] + ' ' + this.year + '"'
      gridCells +=
        ' aria-label="' +
        this.locales.month_names[curMonth] +
        ' ' +
        this.year +
        '"'
      gridCells +=
        ' role="gridcell" tabindex="-1" aria-selected="false">' +
        this.locales.month_names_abbreviated[curMonth]
      gridCells += '</td>'
      if (curMonth == 3 || curMonth == 7) {
        gridCells +=
          '\t</tr>\n\t<tr id="row' +
          rowCount +
          '-' +
          this.id +
          '" role="row">\n'
        rowCount++
      }
    }
    gridCells += '\t</tr>'
    $tbody.append(gridCells)
    this.gridType = 1 // 0 = days grid, 1 = months grid, 2 = years Grid
  } // end populateMonthsCalendar()

  /**
   *	populateYearsCalendar() is a member function to populate the datepicker grid with 20 calendar years
   *	around the current year
   *
   *	@return N/A
   *
   */
  Datepicker.prototype.populateYearsCalendar = function() {
    this.$calendar
      .find('.datepicker-bn-prev-label')
      .html(this.options.prevYearButtonLabel)
    this.$calendar
      .find('.datepicker-bn-next-label')
      .html(this.options.nextYearButtonLabel)
    this.hideObject(this.$fastprev)
    this.hideObject(this.$fastnext)
    if (
      this.options.min != null &&
      this.year - 20 < this.options.min.getFullYear()
    ) {
      this.$prev.attr('title', '')
      this.$prev.addClass('disabled')
      this.$prev.removeClass('enabled')
    } else {
      this.$prev.attr('title', this.options.prevYearButtonLabel)
      this.$prev.addClass('enabled')
      this.$prev.removeClass('disabled')
    }
    this.$monthObj.attr('title', this.options.changeRangeButtonLabel)
    if (
      this.options.max != null &&
      this.year + 20 > this.options.max.getFullYear()
    ) {
      this.$next.attr('title', '')
      this.$next.addClass('disabled')
      this.$next.removeClass('enabled')
    } else {
      this.$next.attr('title', this.options.nextYearButtonLabel)
      this.$next.addClass('enabled')
      this.$next.removeClass('disabled')
    }
    var startYear = Math.floor(this.year / 10) * 10
    var endYear = startYear + 19
    var rowCount = 1
    var $tbody = this.$grid.find('tbody')
    this.$monthObj.html(startYear + '-' + endYear)
    // clear the grid
    this.hideObject(this.$grid.find('thead'))
    $tbody.empty()
    $('#datepicker-err-msg-' + this.id).empty()
    var gridCells = '\t<tr id="row0-' + this.id + '" role="row">\n'
    // insert the months of the year.
    for (var curYear = startYear; curYear <= endYear; curYear++) {
      if (curYear == this.year) {
        gridCells +=
          '\t\t<td id="cell' +
          (curYear - startYear + 1) +
          '-' +
          this.id +
          '" class="year curYear selectable"'
      } else if (
        this.options.min != null &&
        curYear < this.options.min.getFullYear()
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curYear - startYear + 1) +
          '-' +
          this.id +
          '" class="year unselectable"'
      } else if (
        this.options.max != null &&
        curYear > this.options.max.getFullYear()
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curYear - startYear + 1) +
          '-' +
          this.id +
          '" class="year unselectable"'
      } else if (
        this.options.isYearDisabled &&
        this.options.isYearDisabled(curYear)
      ) {
        gridCells +=
          '\t\t<td id="cell' +
          (curYear - startYear + 1) +
          '-' +
          this.id +
          '" class="year unselectable"'
      } else {
        gridCells +=
          '\t\t<td id="cell' +
          (curYear - startYear + 1) +
          '-' +
          this.id +
          '" class="year selectable"'
      }
      gridCells += ' data-value="' + curYear + '"'
      gridCells += ' title="' + curYear + '"'
      gridCells +=
        ' role="gridcell" tabindex="-1" aria-selected="false">' + curYear
      gridCells += '</td>'
      var curPos = curYear - startYear
      if (curPos == 4 || curPos == 9 || curPos == 14) {
        gridCells +=
          '\t</tr>\n\t<tr id="row' +
          rowCount +
          '-' +
          this.id +
          '" role="row">\n'
        rowCount++
      }
    }
    gridCells += '\t</tr>'
    $tbody.append(gridCells)
    this.gridType = 2 // 0 = days grid, 1 = months grid, 2 = years Grid
  } // end populateYearsCalendar()

  /**
   *	showDaysOfPrevMonth() is a member function to show the days of the previous month
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a day the specified number of days from the end of the month.
   *	@return true if the previous month is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showDaysOfPrevMonth = function(offset) {
    // show the previous month
    var previousMonth = this.previousMonth(this.year, this.month)
    if (
      this.options.min != null &&
      (previousMonth.year < this.options.min.getFullYear() ||
        (previousMonth.year == this.options.min.getFullYear() &&
          previousMonth.month < this.options.min.getMonth()))
    ) {
      return false
    }
    this.month = previousMonth.month
    this.year = previousMonth.year
    // populate the calendar grid
    this.populateDaysCalendar()

    // if offset was specified, set focus on the last day - specified offset
    if (offset != null) {
      var numDays = this.getDaysInMonth(this.year, this.month)
      var day = 'cell' + (numDays - offset) + '-' + this.id
      this.$grid.attr('aria-activedescendant', day)
      this.selectGridCell(day)
    }
    return true
  } // end showDaysOfPrevMonth()

  /**
   *	showDaysOfMonth() is a member function to show the days of the specified month
   *
   *	@param	(month int) the month to show.
   *	@return true if the  month is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showDaysOfMonth = function(month) {
    if (
      this.options.min != null &&
      (this.year < this.options.min.getFullYear() ||
        (this.year == this.options.min.getFullYear() &&
          month < this.options.min.getMonth()))
    ) {
      return false
    }
    if (
      this.options.max != null &&
      (this.year > this.options.max.getFullYear() ||
        (this.year == this.options.max.getFullYear() &&
          month > this.options.max.getMonth()))
    ) {
      return false
    }
    this.month = month
    this.date = Math.min(this.date, this.getDaysInMonth(this.year, this.month))
    this.populateDaysCalendar()
    // update the table's activedescendant to point to the active day
    var $active = this.$grid.find("tbody td[data-value='" + this.date + "']")
    this.selectGridCell($active.attr('id'))
    return true
  } // end showDaysOfMonth()

  /**
   *	showMonthsOfPrevYear() is a member function to show the months of the previous year
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a month the specified number of months from the end of the year.
   *	@return true if the previous year is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showMonthsOfPrevYear = function(offset) {
    if (
      this.options.min != null &&
      this.year - 1 < this.options.min.getFullYear()
    ) {
      return false
    }
    // show the previous year
    this.year--
    // populate the calendar grid
    this.populateMonthsCalendar()

    // if offset was specified, set focus on the last month - specified offset
    if (offset != null) {
      var month = 'cell' + (12 - offset) + '-' + this.id
      this.$grid.attr('aria-activedescendant', month)
      this.selectGridCell(month)
    }
    return true
  } // end showMonthsOfPrevYear()

  /**
   *	showMonthsOfYear() is a member function to show the months of the specified year
   *
   *	@param	(year int) the year to show.
   *	@return true if the year is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showMonthsOfYear = function(year) {
    if (this.options.min != null && year < this.options.min.getFullYear()) {
      return false
    }
    if (this.options.max != null && year > this.options.max.getFullYear()) {
      return false
    }
    this.year = year
    this.populateMonthsCalendar()
    // update the table's activedescendant to point to the active month
    var $active = this.$grid.find("tbody td[data-value='" + this.month + "']")
    this.$grid.attr('aria-activedescendant', $active.attr('id'))
    this.selectGridCell($active.attr('id'))
    return true
  } // end showMonthsOfYear()

  /**
   *	showYearsOfPrevRange() is a member function to show the years of the previous range of twenty years
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a year the specified number of years from the end of the range.
   *	@return true if the year - 20 is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showYearsOfPrevRange = function(offset) {
    if (
      this.options.min != null &&
      this.year - 20 < this.options.min.getFullYear()
    ) {
      return false
    }
    // show the previous range
    this.year -= 20
    // populate the calendar grid
    this.populateYearsCalendar()

    // if offset was specified, set focus on the last month - specified offset
    if (offset != null) {
      var year = 'cell' + (20 - offset) + '-' + this.id
      this.$grid.attr('aria-activedescendant', year)
      this.selectGridCell(year)
    }
    return true
  } // end showYearsOfPrevRange()

  /**
   * showDaysOfNextMonth() is a member function to show the next month
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a day the specified number of days from
   *			the beginning of the month.
   *	@return true if the nextmMonth is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showDaysOfNextMonth = function(offset) {
    // show the next month
    var nextMonth = this.nextMonth(this.year, this.month)
    if (
      this.options.max != null &&
      (nextMonth.year > this.options.max.getFullYear() ||
        (nextMonth.year == this.options.max.getFullYear() &&
          nextMonth.month > this.options.max.getMonth()))
    ) {
      return false
    }
    this.month = nextMonth.month
    this.year = nextMonth.year
    // populate the calendar grid
    this.populateDaysCalendar()

    // if offset was specified, set focus on the first day + specified offset
    if (offset != null) {
      var day = 'cell' + offset + '-' + this.id
      this.$grid.attr('aria-activedescendant', day)
      this.selectGridCell(day)
    }
    return true
  } // end showDaysOfNextMonth()

  /**
   * showMonthsOfNextYear() is a member function to show the months of next year
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a month the specified number of month from
   *			the beginning of the year.
   *	@return true if the next year is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showMonthsOfNextYear = function(offset) {
    if (
      this.options.max != null &&
      this.year + 1 > this.options.max.getFullYear()
    ) {
      return false
    }
    // show the next year
    this.year++
    // populate the calendar grid
    this.populateMonthsCalendar()

    // if offset was specified, set focus on the first day + specified offset
    if (offset != null) {
      var month = 'cell' + offset + '-' + this.id
      this.$grid.attr('aria-activedescendant', month)
      this.selectGridCell(month)
    }
    return true
  } // end showMonthsOfNextYear()

  /**
   * showYearsOfNextRange() is a member function to show the years of next range of years
   *
   *	@param	(offset int) offset may be used to specify an offset for setting
   *			focus on a year the specified number of years from
   *			the beginning of the range.
   *	@return true if the year + 20 is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showYearsOfNextRange = function(offset) {
    if (
      this.options.max != null &&
      this.year + 20 > this.options.max.getFullYear()
    ) {
      return false
    }
    // show the next year
    this.year += 20
    // populate the calendar grid
    this.populateYearsCalendar()

    // if offset was specified, set focus on the first day + specified offset
    if (offset != null) {
      var year = 'cell' + offset + '-' + this.id
      this.$grid.attr('aria-activedescendant', year)
      this.selectGridCell(year)
    }
    return true
  } // end showYearsOfNextRange()

  /**
   *	showDaysOfPrevYear() is a member function to show the previous year
   *
   *	@return true if the previous year is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showDaysOfPrevYear = function() {
    if (
      this.options.min != null &&
      (this.year - 1 < this.options.min.getFullYear() ||
        (this.year - 1 == this.options.min.getFullYear() &&
          this.month < this.options.min.getMonth()))
    ) {
      return false
    }
    // decrement the year
    this.year--

    // populate the calendar grid
    this.populateDaysCalendar()
    return true
  } // end showDaysOfPrevYear()

  /**
   *	showDaysOfNextYear() is a member function to show the next year
   *
   *	@return true if the next year is between the minimum and the maximum date otherwise return false
   */
  Datepicker.prototype.showDaysOfNextYear = function() {
    if (
      this.options.max != null &&
      (this.year + 1 > this.options.max.getFullYear() ||
        (this.year + 1 == this.options.max.getFullYear() &&
          this.month > this.options.max.getMonth()))
    ) {
      return false
    }
    // increment the year
    this.year++

    // populate the calendar grid
    this.populateDaysCalendar()
    return true
  } // end showDaysOfNextYear()

  /**
   *	bindHandlers() is a member function to bind event handlers for the widget
   *
   *	@return N/A
   */
  Datepicker.prototype.bindHandlers = function() {
    var self = this

    // bind button handlers
    this.$fastprev.click(function(e) {
      return self.handleFastPrevClick(e)
    })
    this.$prev.click(function(e) {
      return self.handlePrevClick(e)
    })
    this.$next.click(function(e) {
      return self.handleNextClick(e)
    })
    this.$fastnext.click(function(e) {
      return self.handleFastNextClick(e)
    })
    this.$monthObj.click(function(e) {
      return self.handleMonthClick(e)
    })
    this.$monthObj.keydown(function(e) {
      return self.handleMonthKeyDown(e)
    })
    this.$fastprev.keydown(function(e) {
      return self.handleFastPrevKeyDown(e)
    })
    this.$prev.keydown(function(e) {
      return self.handlePrevKeyDown(e)
    })
    this.$next.keydown(function(e) {
      return self.handleNextKeyDown(e)
    })
    this.$fastnext.keydown(function(e) {
      return self.handleFastNextKeyDown(e)
    })
    if (this.options.modal == true) {
      this.$close.click(function(e) {
        return self.handleCloseClick(e)
      })
      this.$close.keydown(function(e) {
        return self.handleCloseKeyDown(e)
      })
    }

    // bind grid handlers
    this.$grid.keydown(function(e) {
      return self.handleGridKeyDown(e)
    })
    this.$grid.keypress(function(e) {
      return self.handleGridKeyPress(e)
    })
    this.$grid.focus(function(e) {
      return self.handleGridFocus(e)
    })
    this.$grid.blur(function(e) {
      return self.handleGridBlur(e)
    })
    this.$grid.delegate('td', 'click', function(e) {
      return self.handleGridClick(this, e)
    })

    // bind target handlers
    this.$target.change(function(e) {
      var date = self.parseDate($(this).val())
      self.updateLinked(date)
    })
  } // end bindHandlers();

  /**
   *	handleFastPrevClick() is a member function to process click events for the fast prev month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleFastPrevClick = function(e) {
    if (this.showDaysOfPrevYear()) {
      var active = this.$grid.attr('aria-activedescendant')
      if (this.month != this.curMonth || this.year != this.curYear) {
        this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
        this.selectGridCell('cell1' + '-' + this.id)
      } else {
        this.$grid.attr('aria-activedescendant', active)
        this.selectGridCell(active)
      }
    }
    e.stopPropagation()
    return false
  } // end handleFastPrevClick()

  /**
   *	handlePrevClick() is a member function to process click events for the prev month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handlePrevClick = function(e) {
    var active = this.$grid.attr('aria-activedescendant')
    switch (this.gridType) {
      case 0: // days grid
        var ok
        if (e.ctrlKey) {
          ok = this.showDaysOfPrevYear()
        } else {
          ok = this.showDaysOfPrevMonth()
        }
        if (ok) {
          if (this.month != this.curMonth || this.year != this.curYear) {
            this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
            this.selectGridCell('cell1' + '-' + this.id)
          } else {
            this.$grid.attr('aria-activedescendant', active)
            this.selectGridCell(active)
          }
        }
        break
      case 1: // months grid
        if (this.showMonthsOfPrevYear()) {
          if (this.year != this.curYear) {
            this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
            this.selectGridCell('cell1' + '-' + this.id)
          } else {
            this.$grid.attr('aria-activedescendant', active)
            this.selectGridCell(active)
          }
        }
        break
      case 2: // years grid
        if (this.showYearsOfPrevRange()) {
          this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
          this.selectGridCell('cell1' + '-' + this.id)
        }
        break
    }
    e.stopPropagation()
    return false
  } // end handlePrevClick()

  /**
   *	handleMonthClick() is a member function to process click events for the month header
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleMonthClick = function(e) {
    this.changeGrid(e)
    e.stopPropagation()
    return false
  } // end handleMonthClick()

  /**
   *	handleNextClick() is a member function to process click events for the next month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleNextClick = function(e) {
    var active = this.$grid.attr('aria-activedescendant')
    switch (this.gridType) {
      case 0: // days grid
        var ok
        if (e.ctrlKey) {
          ok = this.showDaysOfNextYear()
        } else {
          ok = this.showDaysOfNextMonth()
        }
        if (ok) {
          if (this.month != this.curMonth || this.year != this.curYear) {
            this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
            this.selectGridCell('cell1' + '-' + this.id)
          } else {
            this.$grid.attr('aria-activedescendant', active)
            this.selectGridCell(active)
          }
        }
        break
      case 1: // months grid
        if (this.showMonthsOfNextYear()) {
          if (this.year != this.curYear) {
            this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
            this.selectGridCell('cell1' + '-' + this.id)
          } else {
            this.$grid.attr('aria-activedescendant', active)
            this.selectGridCell(active)
          }
        }
        break
      case 2: // years grid
        if (this.showYearsOfNextRange()) {
          this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
          this.selectGridCell('cell1' + '-' + this.id)
        }
        break
    }
    e.stopPropagation()
    return false
  } // end handleNextClick()

  /**
   *	handleFastNextClick() is a member function to process click events for the fast next month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleFastNextClick = function(e) {
    if (this.showDaysOfNextYear()) {
      var active = this.$grid.attr('aria-activedescendant')
      if (this.month != this.curMonth || this.year != this.curYear) {
        this.$grid.attr('aria-activedescendant', 'cell1' + '-' + this.id)
        this.selectGridCell('cell1' + '-' + this.id)
      } else {
        this.$grid.attr('aria-activedescendant', active)
        this.selectGridCell(active)
      }
    }
    e.stopPropagation()
    return false
  } // end handleFastNextClick()

  /**
   *	handleCloseClick() is a member function to process click events for the close button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleCloseClick = function(e) {
    // dismiss the dialog box
    this.hide()
    e.stopPropagation()
    return false
  } // end handleCloseClick()

  /**
   *	handleFastPrevKeyDown() is a member function to process keydown events for the fast prev month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleFastPrevKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == false || e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          this.$close.focus()
        } else {
          this.$prev.focus()
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.space: {
        if (e.shiftKey || e.ctrlKey) {
          return true
        }
        this.showDaysOfPrevYear()
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleFastPrevKeyDown()

  /**
   *	handlePrevKeyDown() is a member function to process keydown events for the prev month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handlePrevKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == false || e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          if (this.gridType == 0) {
            this.$fastprev.focus()
          } else {
            this.$close.focus()
          }
        } else {
          this.$monthObj.focus()
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.space: {
        if (e.shiftKey) {
          return true
        }
        switch (this.gridType) {
          case 0: // days grid
            if (e.ctrlKey) {
              this.showDaysOfPrevYear()
            } else {
              this.showDaysOfPrevMonth()
            }
            break
          case 1: // months grid
            this.showMonthsOfPrevYear()
            break
          case 2: // years grid
            this.showYearsOfPrevRange()
            break
        }
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handlePrevKeyDown()

  /**
   *	handleMonthKeyDown() is a member function to process keydown events for the month title
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleMonthKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == false || e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          this.$prev.focus()
        } else {
          this.$next.focus()
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.space: {
        this.changeGrid(e)
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleMonthKeyDown()

  /**
   *	handleNextKeyDown() is a member function to process keydown events for the next month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleNextKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == false || e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          this.$monthObj.focus()
        } else {
          if (this.gridType == 0) {
            this.$fastnext.focus()
          } else {
            this.$grid.focus()
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.space: {
        switch (this.gridType) {
          case 0: // days grid
            if (e.ctrlKey) {
              this.showDaysOfNextYear()
            } else {
              this.showDaysOfNextMonth()
            }
            break
          case 1: // months grid
            this.showMonthsOfNextYear()
            break
          case 2: // years grid
            this.showYearsOfNextRange()
            break
        }
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleNextKeyDown()

  /**
   *	handleFastNextKeyDown() is a member function to process keydown events for the fast next month button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleFastNextKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == false || e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          this.$next.focus()
        } else {
          this.$grid.focus()
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.space: {
        this.showDaysOfNextYear()
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleFastNextKeyDown()

  /**
   *	handleCloseKeyDown() is a member function to process keydown events for the close button
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleCloseKeyDown = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (e.ctrlKey) {
          return true
        }
        if (e.shiftKey) {
          this.$grid.focus()
        } else {
          if (this.gridType == 0) {
            this.$fastprev.focus()
          } else {
            this.$prev.focus()
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.enter:
      case this.keys.esc:
      case this.keys.space: {
        if (e.shiftKey || e.ctrlKey) {
          return true
        }
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handlePrevKeyDown()

  /**
   *	handleGridKeyDown() is a member function to process keydown events for the Datepicker grid
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleGridKeyDown = function(e) {
    var $curCell = $('#' + this.$grid.attr('aria-activedescendant'))
    var $cells = this.$grid.find('td.selectable')
    var colCount = this.$grid
      .find('tbody tr')
      .eq(0)
      .find('td').length
    if (
      e.altKey &&
      e.keyCode != this.keys.pageup &&
      e.keyCode != this.keys.pagedown
    ) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab: {
        if (this.options.modal == true) {
          if (e.shiftKey) {
            if (this.gridType == 0) {
              this.$fastnext.focus()
            } else {
              this.$next.focus()
            }
          } else {
            this.$close.focus()
          }
          e.stopPropagation()
          return false
        } else {
          // dismiss the dialog box
          this.hide()
          this.handleTabOut(e)
          e.stopPropagation()
          return false
        }
        break
      }
      case this.keys.enter:
      case this.keys.space: {
        if (e.ctrlKey) {
          return true
        }
        switch (this.gridType) {
          case 0: // days grid
            // update the target box
            this.update()
            // dismiss the dialog box
            this.hide()
            break
          case 1: // months grid
            this.showDaysOfMonth(parseInt($curCell.attr('data-value'), 10))
            break
          case 2: // years grid
            this.showMonthsOfYear(parseInt($curCell.attr('data-value'), 10))
            break
        }
        e.stopPropagation()
        return false
      }
      case this.keys.esc: {
        // dismiss the dialog box
        this.hide()
        e.stopPropagation()
        return false
      }
      case this.keys.left:
      case this.keys.right: {
        if (
          (e.keyCode == this.keys.left &&
            this.locales.directionality === 'LTR') ||
          (e.keyCode == this.keys.right &&
            this.locales.directionality === 'RTL')
        ) {
          if (e.ctrlKey || e.shiftKey) {
            return true
          }
          var cellIndex = $cells.index($curCell) - 1
          var $prevCell = null
          if (cellIndex >= 0) {
            $prevCell = $cells.eq(cellIndex)
            this.unSelectGridCell($curCell.attr('id'))
            this.$grid.attr('aria-activedescendant', $prevCell.attr('id'))
            this.selectGridCell($prevCell.attr('id'))
          } else {
            switch (this.gridType) {
              case 0: // days grid
                this.showDaysOfPrevMonth(0)
                break
              case 1: // months grid
                this.showMonthsOfPrevYear(0)
                break
              case 2: // years grid
                this.showYearsOfPrevRange(0)
                break
            }
          }
          e.stopPropagation()
          return false
        } else {
          if (e.ctrlKey || e.shiftKey) {
            return true
          }
          var cellIndex = $cells.index($curCell) + 1
          var $nextCell = null
          if (cellIndex < $cells.length) {
            $nextCell = $cells.eq(cellIndex)
            this.unSelectGridCell($curCell.attr('id'))
            this.$grid.attr('aria-activedescendant', $nextCell.attr('id'))
            this.selectGridCell($nextCell.attr('id'))
          } else {
            switch (this.gridType) {
              case 0: // days grid
                // move to the next month
                this.showDaysOfNextMonth(1)
                break
              case 1: // months grid
                this.showMonthsOfNextYear(1)
                break
              case 2: // years grid
                this.showYearsOfNextRange(1)
                break
            }
          }
          e.stopPropagation()
          return false
        }
      }
      case this.keys.up: {
        if (e.ctrlKey || e.shiftKey) {
          return true
        }
        var cellIndex = $cells.index($curCell) - colCount
        var $prevCell = null
        if (cellIndex >= 0) {
          $prevCell = $cells.eq(cellIndex)
          this.unSelectGridCell($curCell.attr('id'))
          this.$grid.attr('aria-activedescendant', $prevCell.attr('id'))
          this.selectGridCell($prevCell.attr('id'))
        } else {
          // move to appropriate day in previous month
          cellIndex = colCount - 1 - $cells.index($curCell)
          switch (this.gridType) {
            case 0: // days grid
              this.showDaysOfPrevMonth(cellIndex)
              break
            case 1: // months grid
              this.showMonthsOfPrevYear(cellIndex)
              break
            case 2: // years grid
              this.showYearsOfPrevRange(cellIndex)
              break
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.down: {
        if (e.ctrlKey || e.shiftKey) {
          return true
        }
        var cellIndex = $cells.index($curCell) + colCount
        var $nextCell = null
        if (cellIndex < $cells.length) {
          $nextCell = $cells.eq(cellIndex)
          this.unSelectGridCell($curCell.attr('id'))
          this.$grid.attr('aria-activedescendant', $nextCell.attr('id'))
          this.selectGridCell($nextCell.attr('id'))
        } else {
          // move to appropriate day in next month
          cellIndex = colCount + 1 - ($cells.length - $cells.index($curCell))
          switch (this.gridType) {
            case 0: // days grid
              this.showDaysOfNextMonth(cellIndex)
              break
            case 1: // months grid
              this.showMonthsOfNextYear(cellIndex)
              break
            case 2: // years grid
              this.showYearsOfNextRange(cellIndex)
              break
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.pageup: {
        var active = this.$grid.attr('aria-activedescendant')
        if (e.shiftKey || e.ctrlKey) {
          return true
        }
        e.preventDefault()
        var ok = false
        switch (this.gridType) {
          case 0: // days grid
            if (e.altKey) {
              e.stopImmediatePropagation()
              ok = this.showDaysOfPrevYear()
            } else {
              ok = this.showDaysOfPrevMonth()
            }
            break
          case 1: // months grid
            ok = this.showMonthsOfPrevYear()
            break
          case 2: // years grid
            ok = this.showYearsOfPrevRange()
            break
        }
        if (ok) {
          if ($('#' + active).attr('id') == undefined) {
            $cells = this.$grid.find('td.selectable')
            var $lastCell = $cells.eq($cells.length - 1)
            this.$grid.attr('aria-activedescendant', $lastCell.attr('id'))
            this.selectGridCell($lastCell.attr('id'))
          } else {
            this.selectGridCell(active)
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.pagedown: {
        var active = this.$grid.attr('aria-activedescendant')
        if (e.shiftKey || e.ctrlKey) {
          return true
        }
        e.preventDefault()
        var ok = false
        switch (this.gridType) {
          case 0: // days grid
            if (e.altKey) {
              e.stopImmediatePropagation()
              ok = this.showDaysOfNextYear()
            } else {
              ok = this.showDaysOfNextMonth()
            }
            break
          case 1: // months grid
            ok = this.showMonthsOfNextYear()
            break
          case 2: // years grid
            ok = this.showYearsOfNextRange()
            break
        }
        if (ok) {
          if ($('#' + active).attr('id') == undefined) {
            $cells = this.$grid.find('td.selectable')
            var $lastCell = $cells.eq($cells.length - 1)
            this.$grid.attr('aria-activedescendant', $lastCell.attr('id'))
            this.selectGridCell($lastCell.attr('id'))
          } else {
            this.selectGridCell(active)
          }
        }
        e.stopPropagation()
        return false
      }
      case this.keys.home: {
        if (e.ctrlKey || e.shiftKey) {
          return true
        }
        var $firstCell = $cells.eq(0)
        this.unSelectGridCell($curCell.attr('id'))
        this.$grid.attr('aria-activedescendant', $firstCell.attr('id'))
        this.selectGridCell($firstCell.attr('id'))
        e.stopPropagation()
        return false
      }
      case this.keys.end: {
        if (e.ctrlKey || e.shiftKey) {
          return true
        }
        var $lastCell = $cells.eq($cells.length - 1)
        this.unSelectGridCell($curCell.attr('id'))
        this.$grid.attr('aria-activedescendant', $lastCell.attr('id'))
        this.selectGridCell($lastCell.attr('id'))
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleGridKeyDown()

  /**
   *	handleGridKeyPress() is a member function to consume keypress events for browsers that
   *	use keypress to scroll the screen and manipulate tabs
   *
   *	@param (e obj) e is the event object associated with the event
   *
   * 	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleGridKeyPress = function(e) {
    if (e.altKey) {
      return true
    }
    switch (e.keyCode) {
      case this.keys.tab:
      case this.keys.enter:
      case this.keys.space:
      case this.keys.esc:
      case this.keys.left:
      case this.keys.right:
      case this.keys.up:
      case this.keys.down:
      case this.keys.pageup:
      case this.keys.pagedown:
      case this.keys.home:
      case this.keys.end: {
        e.stopPropagation()
        return false
      }
    }
    return true
  } // end handleGridKeyPress()

  /**
   *	handleGridClick() is a member function to process mouse click events for the Datepicker grid
   *
   *	@param (id string) id is the id of the object triggering the event
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleGridClick = function(id, e) {
    var $cell = $(id)
    if ($cell.is('.empty') || $cell.is('.unselectable')) {
      return true
    }
    this.$grid
      .find('.focus')
      .removeClass('focus')
      .attr('aria-selected', 'false')
      .attr('tabindex', -1)
    switch (this.gridType) {
      case 0: // days grid
        this.$grid.attr('aria-activedescendant', $cell.attr('id'))
        this.selectGridCell($cell.attr('id'))
        // update the target box
        this.update()
        // dismiss the dialog box
        this.hide()
        break
      case 1: // months grid
        this.showDaysOfMonth(parseInt($cell.attr('data-value'), 10))
        break
      case 2: // years grid
        this.showMonthsOfYear(parseInt($cell.attr('data-value'), 10))
        break
    }
    e.stopPropagation()
    return false
  } // end handleGridClick()

  /**
   *	handleGridFocus() is a member function to process focus events for the Datepicker grid
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) true
   */
  Datepicker.prototype.handleGridFocus = function(e) {
    var active = this.$grid.attr('aria-activedescendant')
    if ($('#' + active).attr('id') == undefined) {
      var $cells = this.$grid.find('td.selectable')
      var $lastCell = $cells.eq($cells.length - 1)
      this.$grid.attr('aria-activedescendant', $lastCell.attr('id'))
      this.selectGridCell($lastCell.attr('id'))
    } else {
      this.selectGridCell(active)
    }
    return true
  } // end handleGridFocus()

  /**
   *	handleGridBlur() is a member function to process blur events for the Datepicker grid
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) true
   */
  Datepicker.prototype.handleGridBlur = function(e) {
    this.unSelectGridCell(this.$grid.attr('aria-activedescendant'))
    return true
  } // end handleGridBlur()

  /**
   *	handleTabOut() is a member function to process tab key in Datepicker grid
   *
   * @param (e obj) e is the event object associated with the event
   * @return (boolean) true
   */
  Datepicker.prototype.handleTabOut = function(e) {
    var fields = $('body').find('input:visible,textarea:visible,select:visible')
    var index = fields.index(this.$target)
    if (index > -1 && index < fields.length) {
      if (e.shiftKey) {
        if (index > 0) {
          index--
        }
      } else {
        if (index + 1 < fields.length) {
          index++
        }
      }
      fields.eq(index).focus()
    }
    return true
  } // end handleTabOut()

  /**
   *	changeGrid() is a member function to change the calendar after click or enter into the calendar title
   *
   *	@param (e obj) e is the event object associated with the event
   *	@return true
   */
  Datepicker.prototype.changeGrid = function(e) {
    switch (this.gridType) {
      case 0: // days grid
        this.populateMonthsCalendar()
        if (this.year != this.curYear) {
          var $cells = this.$grid.find('td.selectable')
          this.$grid.attr('aria-activedescendant', $cells.eq(0).attr('id'))
        } else {
          this.$grid.attr(
            'aria-activedescendant',
            this.$grid.find('.curMonth').attr('id')
          )
        }
        this.selectGridCell(this.$grid.attr('aria-activedescendant'))
        break
      case 2: // years grid
        if (e.shiftKey) {
          // goto previous twenty years
          this.year -= 20
        } else {
          // goto next twenty years
          this.year += 20
        }
      case 1: // months grid
        this.populateYearsCalendar()
        if (this.year != this.curYear) {
          var $cells = this.$grid.find('td.selectable')
          this.$grid.attr('aria-activedescendant', $cells.eq(0).attr('id'))
        } else {
          this.$grid.attr(
            'aria-activedescendant',
            this.$grid.find('.curYear').attr('id')
          )
        }
        this.selectGridCell(this.$grid.attr('aria-activedescendant'))
        break
    }
    return true
  } // end changeGrid()

  /**
   *	selectGridCell() is a member function to put focus on the current cell of the grid.
   *
   *	@return N/A
   */
  Datepicker.prototype.selectGridCell = function(cellId) {
    $('#' + cellId)
      .addClass('focus')
      .attr('aria-selected', 'true')
      .attr('tabindex', 0)
      .focus()
  } // end selectGridCell()

  /**
   *	unSelectGridCell() is a member function to put focus on the current cell of the grid.
   *
   *	@return N/A
   */
  Datepicker.prototype.unSelectGridCell = function(cellId) {
    $('#' + cellId)
      .removeClass('focus')
      .attr('aria-selected', 'false')
      .attr('tabindex', -1)
  } // end unSelectGridCell()

  /**
   *	update() is a member function to update the target textbox.
   *
   *	@return N/A
   */
  Datepicker.prototype.update = function() {
    var $curDay = $('#' + this.$grid.attr('aria-activedescendant'))
    var date = new Date(
      this.year,
      this.month,
      parseInt($curDay.attr('data-value'), 10)
    )
    var val = this.formatDate(date, this.options.outputFormat)
    this.$target.val(val)
    this.$target.removeAttr('aria-invalid')
    this.$target.parents('.form-group').removeClass('has-error')
    this.$target.trigger('change')
    if (this.options.onUpdate) {
      this.options.onUpdate(val)
    }
  } // end update()

  /**
   *	updateLinked() is a member function to update the linked textbox.
   *
   *	@param	(date Date) the current value of this Datepicker date.
   *	@return N/A
   */
  Datepicker.prototype.updateLinked = function(date) {
    if (this.options.previous !== null && this.options.previous.val() !== '') {
      var previousDate = this.options.previous.datepicker('getDate')
      if (previousDate > date) {
        var previousVal = this.formatDate(
          date,
          this.options.previous.datepicker('outputFormat')
        )
        this.options.previous.val(previousVal)
      }
    }
    if (this.options.next !== null && this.options.next.val() !== '') {
      var nextDate = this.options.next.datepicker('getDate')
      if (nextDate < date) {
        var nextVal = this.formatDate(
          date,
          this.options.next.datepicker('outputFormat')
        )
        this.options.next.val(nextVal)
      }
    }
  } // end updateLinked()

  /**
   *	hideObject() is a member function to hide an element of the datepicker.
   *
   *	@param ($element jQuery object) the element to hide
   *	@return N/A
   */
  Datepicker.prototype.hideObject = function($element) {
    $element.attr('aria-hidden', true)
    $element.fadeOut(100)
  } // end hideObject()

  /**
   *	showObject() is a member function to show an element of the datepicker.
   *
   *	@param ($element jQuery object) the element to show
   *	@return N/A
   */
  Datepicker.prototype.showObject = function($element) {
    $element.attr('aria-hidden', false)
    $element.fadeIn(100)
  } // end showObject()

  /**
   *	show() is a member function to show the Datepicker and give it focus.
   *
   *	@return N/A
   */
  Datepicker.prototype.show = function() {
    var self = this
    $('.datepicker-calendar').trigger('ab.datepicker.opening', [self.id])
    if (this.options.modal == true) {
      if (!this.modalEventHandler) {
        this.modalEventHandler = function(e) {
          //ensure focus remains on the dialog
          self.$grid.focus()
          // Consume all mouse events and do nothing
          e.stopPropagation
          return false
        }
      }
      // Bind an event listener to the document to capture all mouse events to make dialog modal
      $(document).on('click mousedown mouseup', this.modalEventHandler)
      this.greyOut(true)
      var zIndex = parseInt($('#datepicker-overlay').css('z-index'), 10) || 40
      this.$calendar.css('z-index', zIndex + 1)
    } else {
      // Bind an event listener to the document to capture only the mouse click event
      $(document).on('click', $.proxy(this.handleDocumentClick, this))
      this.$calendar.on('ab.datepicker.opening', function(e, id) {
        if (id != self.id) {
          self.hide()
        } else {
          //ensure focus remains on the dialog
          self.$grid.focus()
        }
      })
    }
    this.$calendar.on('ab.datepicker.opened', function(e, id) {
      if (id == self.id) {
        self.$grid.focus()
      }
    })

    // adjust position of the calendar
    var groupOffsetTop = Math.max(
      0,
      Math.floor(this.$group.offset().top - this.$label.offset().top)
    )
    var groupOffsetLeft = Math.max(
      0,
      Math.floor(this.$group.offset().left - this.$label.offset().left)
    )
    var parentPaddingLeft = parseInt(
      this.$calendar.parent().css('padding-left'),
      10
    )
    var calendarHeight = this.$calendar.outerHeight()
    var groupTop = this.$group.offset().top
    var groupLeft = this.$group.offset().left
    var groupHeight = this.$group.outerHeight(true)
    var roomBefore = Math.floor(groupTop - $(window).scrollTop())
    var roomAfter = Math.floor(
      $(window).height() - (groupTop + groupHeight - $(window).scrollTop())
    )
    if (roomAfter < calendarHeight && roomAfter < roomBefore) {
      // show calendar above group
      this.$calendar.addClass('above')
      this.$calendar.css({
        top: groupOffsetTop - calendarHeight + 'px',
        left: groupOffsetLeft + parentPaddingLeft + 'px',
      })
    } else {
      // show calendar below group
      this.$calendar.addClass('below')
      this.$calendar.css({
        top: groupHeight + groupOffsetTop + 'px',
        left: groupOffsetLeft + parentPaddingLeft + 'px',
      })
    }

    // show the dialog
    this.$calendar.attr('aria-hidden', 'false')
    this.$calendar.fadeIn(100)
    $('.datepicker-calendar').trigger('ab.datepicker.opened', [self.id])
  } // end show()

  /**
   *	refresh() is a member function to refesh the datepicker content when an option change.
   *
   *	@return N/A
   */
  Datepicker.prototype.refresh = function() {
    this.drawCalendarHeader()
    switch (this.gridType) {
      case 0:
        this.populateDaysCalendar()
        break
      case 1:
        this.populateMonthsCalendar()
        break
      case 2:
        this.populateYearsCalendar()
        break
    }
  } // end refresh()

  /**
   *	handleDocumentClick() is a member function to handle click on document.
   *
   *	@param (e obj) e is the event object associated with the event
   *
   *	@return (boolean) false if consuming event, true if propagating
   */
  Datepicker.prototype.handleDocumentClick = function(e) {
    if ($(e.target).parents('#datepicker-calendar-' + this.id).length == 0) {
      this.hide()
      return true
    } else {
      //ensure focus remains on the dialog
      this.$grid.focus()
      // Consume all mouse events and do nothing
      e.stopPropagation
      return false
    }
  } // end handleDocumentClick()

  /**
   *	hide() is a member function to hide the Datepicker and remove focus.
   *
   *	@return N/A
   */
  Datepicker.prototype.hide = function(omitSettingFocus) {
    if (this.options.inline == false) {
      var self = this
      // unbind the modal event sinks
      if (this.options.modal == true) {
        if (this.modalEventHandler) {
          $(document).off('click mousedown mouseup', this.modalEventHandler)
        }
        this.greyOut(false)
      } else {
        $(document).off('click', self.handleDocumentClick)
        this.$calendar.off('ab.datepicker.opening')
      }
      // hide the dialog
      this.$calendar.removeClass('above below')
      this.$calendar.attr('aria-hidden', 'true')
      this.$calendar.fadeOut(100)
      $('.datepicker-calendar').trigger('ab.datepicker.closed', [self.id])
      // set focus on the focus target
      if (!omitSettingFocus) {
        this.$target.focus()
      }
    }
  } // end hide()

  /**
   *	greyOut() is a member function to grey out the document background.
   *
   *	@return N/A
   */
  Datepicker.prototype.greyOut = function(on) {
    var $overlay = $('#datepicker-overlay')
    if ($overlay.length == 0 && on) {
      $('body').append(
        '<div id="datepicker-overlay" class="datepicker-overlay"></div>'
      )
      $overlay = $('#datepicker-overlay')
    }
    if (on) {
      $overlay.fadeIn(100)
    } else {
      $overlay.fadeOut(100)
    }
  } // end greyOut()

  /**
   *	absolutePosition() is a member function that compute the absolute position
   *	of some element within document.
   *
   *	@param (element obj) the element of the document
   *	@return an object containing the properties top and left.
   */
  Datepicker.prototype.absolutePosition = function(element) {
    var top = 0,
      left = 0
    if (element.getBoundingClientRect) {
      var box = element.getBoundingClientRect()
      var body = document.body
      var docElem = document.documentElement
      var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
      var scrollLeft =
        window.pageXOffset || docElem.scrollLeft || body.scrollLeft
      var clientTop = docElem.clientTop || body.clientTop || 0
      var clientLeft = docElem.clientLeft || body.clientLeft || 0
      top = Math.round(box.top + scrollTop - clientTop)
      left = Math.round(box.left + scrollLeft - clientLeft)
    } else {
      while (element) {
        top = top + parseInt(element.offsetTop, 10)
        left = left + parseInt(element.offsetLeft, 10)
        element = element.offsetParent
      }
    }
    return { top: top, left: left }
  } // end absolutePosition()

  /**
   *	getDaysInMonth() is a member function to calculate the number of days in a given month
   *
   *	@param (year int) the year
   *	@param (month int) the given month
   *
   *	@return (integer) number of days
   */
  Datepicker.prototype.getDaysInMonth = function(year, month) {
    return 32 - new Date(year, month, 32).getDate()
  } // end getDaysInMonth()

  /**
   *	previousMonth() is a member function that compute the month
   *	preceding a given month.
   *
   *	@param (year int) the given year
   *	@param (month int) the given month
   *	@return an object containing the properties year and month.
   */
  Datepicker.prototype.previousMonth = function(year, month) {
    if (month == 0) {
      month = 11
      year--
    } else {
      month--
    }
    return { year: year, month: month }
  } // end previousMonth()

  /**
   *	nextMonth() is a member function that compute the month
   *	following a given month.
   *
   *	@param (year int) the given year
   *	@param (month int) the given month
   *	@return an object containing the properties year and month.
   */
  Datepicker.prototype.nextMonth = function(year, month) {
    if (month == 11) {
      month = 0
      year++
    } else {
      month++
    }
    return { year: year, month: month }
  } // end nextMonth()

  /**
   *	formatDate (date_object, format)
   *	The format string uses the same abbreviations as in createDateFromFormat()
   *
   *	@param (date date object) the given date
   *	@param (format string) the given output format
   *	@returns a date in the output format specified.
   */
  Datepicker.prototype.formatDate = function(date, format) {
    var zeroPad = function(x) {
      return (x < 0 || x > 9 ? '' : '0') + x
    }
    var getWeekOfMonth = function(date) {
      return Math.ceil((date.getDate() - 1 - date.getDay()) / 7)
    }
    var getWeekOfYear = function(date) {
      var onejan = new Date(date.getFullYear(), 0, 1)
      return Math.ceil(((date - onejan) / 86400000 + onejan.getDay() + 1) / 7)
    }
    var getDayOfYear = function(date) {
      var start = new Date(date.getFullYear(), 0, 0)
      return Math.floor((date - start) / 86400000)
    }
    var getMillisecondsInDay = function(date) {
      var date1 = new Date(date.getTime())
      date1.setHours(0)
      return date - date1
    }
    var y = date.getFullYear() + ''
    var M = date.getMonth() + 1
    var d = date.getDate()
    var D = getDayOfYear(date)
    var E = date.getDay()
    var H = date.getHours()
    var m = date.getMinutes()
    var s = date.getSeconds()
    var w = getWeekOfYear(date)
    var W = getWeekOfMonth(date)
    var F = Math.floor(date.getDate() / 7) + 1
    var Q = Math.ceil((date.getMonth() + 1) / 3)
    var era = date.getFullYear() < 1 ? 0 : 1
    var values = {
      y: '' + y,
      yyyy: y,
      yy: y.substring(2, 4),
      L: M,
      LL: zeroPad(M),
      LLL: this.locales.month_names_abbreviated[M - 1],
      LLLL: this.locales.month_names[M - 1],
      LLLLL: this.locales.month_names_narrow[M - 1],
      M: M,
      MM: zeroPad(M),
      MMM: this.locales.month_names_abbreviated[M - 1],
      MMMM: this.locales.month_names[M - 1],
      MMMMM: this.locales.month_names_narrow[M - 1],
      d: d,
      dd: zeroPad(d),
      D: D,
      DD: D,
      DDD: D,
      A: Math.round(getMillisecondsInDay(date) * Math.pow(10, -2)),
      AA: Math.round(getMillisecondsInDay(date) * Math.pow(10, -1)),
      AAA: Math.round(getMillisecondsInDay(date) * Math.pow(10, 0)),
      AAAA: Math.round(getMillisecondsInDay(date) * Math.pow(10, 1)),
      AAAAA: Math.round(getMillisecondsInDay(date) * Math.pow(10, 2)),
      AAAAAA: Math.round(getMillisecondsInDay(date) * Math.pow(10, 3)),
      E: this.locales.day_names_abbreviated[E],
      EE: this.locales.day_names_abbreviated[E],
      EEE: this.locales.day_names_abbreviated[E],
      EEEE: this.locales.day_names[E],
      EEEEE: this.locales.day_names_narrow[E],
      EEEEEE: this.locales.day_names_short[E],
      e: E,
      ee: E,
      eee: this.locales.day_names_abbreviated[E],
      eeee: this.locales.day_names[E],
      eeeee: this.locales.day_names_narrow[E],
      eeeeee: this.locales.day_names_short[E],
      c: E,
      cc: E,
      ccc: this.locales.day_names_abbreviated[E],
      cccc: this.locales.day_names[E],
      ccccc: this.locales.day_names_narrow[E],
      cccccc: this.locales.day_names_short[E],
      F: F,
      G: this.locales.era_names_abbreviated[era],
      GG: this.locales.era_names_abbreviated[era],
      GGG: this.locales.era_names_abbreviated[era],
      GGGG: this.locales.era_names[era],
      GGGGG: this.locales.era_names_narrow[era],
      Q: Q,
      QQ: zeroPad(Q),
      QQQ: this.locales.quarter_names_abbreviated[Q - 1],
      QQQQ: this.locales.quarter_names[Q - 1],
      QQQQQ: this.locales.quarter_names_narrow[Q - 1],
      q: Q,
      qq: zeroPad(Q),
      qqq: this.locales.quarter_names_abbreviated[Q - 1],
      qqqq: this.locales.quarter_names[Q - 1],
      qqqqq: this.locales.quarter_names_narrow[Q - 1],
      H: H,
      HH: zeroPad(H),
      h: H == 0 ? 12 : H > 12 ? H - 12 : H,
      hh: zeroPad(H == 0 ? 12 : H > 12 ? H - 12 : H),
      K: H > 11 ? H - 12 : H,
      k: H + 1,
      KK: zeroPad(H > 11 ? H - 12 : H),
      kk: zeroPad(H + 1),
      a: H > 11 ? this.locales.day_periods.pm : this.locales.day_periods.am,
      m: m,
      mm: zeroPad(m),
      s: s,
      ss: zeroPad(s),
      w: w,
      ww: zeroPad(w),
      W: W,
    }
    return format.replace(
      /('[^']+'|y{1,4}|L{1,5}|M{1,5}|c{1,6}|d{1,2}|D{1,3}|E{1,6}|e{1,6}|F{1,1}|G{1,5}|Q{1,5}|q{1,5}|H{1,2}|h{1,2}|K{1,2}|k{1,2}|m{1,2}|s{1,2}|w{1,2}|W{1,1}|A{1,6})/g,
      function(mask) {
        return mask.charAt(0) === "'"
          ? mask.substr(1, mask.length - 2)
          : values[mask] || mask
      }
    )
  } // end formatDate()

  /**
   *	createDateFromFormat( format_string, date_string )
   *
   *	This function takes a date string and a format string. It matches
   *	If the date string matches the format string, it returns the
   *	the date object. If it does not match, it returns null.
   */
  Datepicker.prototype.createDateFromFormat = function(format, value) {
    var extractInteger = function(str, pos, minlength, maxlength) {
      for (var x = maxlength; x >= minlength; x--) {
        var integer = str.substring(pos, pos + x)
        if (integer.length < minlength) {
          return null
        }
        if (/^\d+$/.test(integer)) {
          return integer
        }
      }
      return null
    }
    var skipName = function(names, pos) {
      for (var i = 0; i < names.length; i++) {
        var name = names[i]
        if (
          value.substring(pos, pos + name.length).toLowerCase() ==
          name.toLowerCase()
        ) {
          return name.length
        }
      }
      return 0
    }
    var pos = 0
    var now = new Date()
    var year = now.getYear()
    var month = now.getMonth() + 1
    var date = 1
    var hh = 0
    var mm = 0
    var ss = 0
    var ampm = ''
    var self = this

    $.each(format.match(/(.).*?\1*/g), function(k, token) {
      // Extract contents of value based on format token
      switch (token) {
        case 'yyyy':
          year = extractInteger(value, pos, 4, 4)
          if (year != null) {
            pos += year.length
          }
          break
        case 'yy':
          year = extractInteger(value, pos, 2, 2)
          if (year != null) {
            pos += year.length
          }
          break
        case 'y':
          year = extractInteger(value, pos, 2, 4)
          if (year != null) {
            pos += year.length
          }
          break
        case 'MMM':
        case 'LLL':
          month = 0
          for (
            var i = 0;
            i < self.locales.month_names_abbreviated.length;
            i++
          ) {
            var month_name = self.locales.month_names_abbreviated[i]
            if (
              value.substring(pos, pos + month_name.length).toLowerCase() ==
              month_name.toLowerCase()
            ) {
              month = i + 1
              pos += month_name.length
              break
            }
          }
          break
        case 'MMMM':
        case 'LLLL':
          month = 0
          for (var i = 0; i < self.locales.month_names.length; i++) {
            var month_name = self.locales.month_names[i]
            if (
              value.substring(pos, pos + month_name.length).toLowerCase() ==
              month_name.toLowerCase()
            ) {
              month = i + 1
              pos += month_name.length
              break
            }
          }
          break
        case 'EEE':
        case 'EE':
        case 'E':
        case 'eee':
          pos += skipName(self.locales.day_names_abbreviated, pos)
          break
        case 'EEEE':
        case 'eeee':
        case 'cccc':
          pos += skipName(self.locales.day_names, pos)
          break
        case 'EEEEEE':
        case 'eeeeee':
        case 'cccccc':
          pos += skipName(self.locales.day_names_short, pos)
          break
        case 'MM':
        case 'M':
        case 'LL':
        case 'L':
          month = extractInteger(value, pos, token.length, 2)
          if (month == null || month < 1 || month > 12) {
            return null
          }
          pos += month.length
          break
        case 'dd':
        case 'd':
          date = extractInteger(value, pos, token.length, 2)
          if (date == null || date < 1 || date > 31) {
            return null
          }
          pos += date.length
          break
        case 'hh':
        case 'h':
          hh = extractInteger(value, pos, token.length, 2)
          if (hh == null || hh < 1 || hh > 12) {
            return null
          }
          pos += hh.length
          break
        case 'HH':
        case 'H':
          hh = extractInteger(value, pos, token.length, 2)
          if (hh == null || hh < 0 || hh > 23) {
            return null
          }
          pos += hh.length
          break
        case 'KK':
        case 'K':
          hh = extractInteger(value, pos, token.length, 2)
          if (hh == null || hh < 0 || hh > 11) {
            return null
          }
          pos += hh.length
          break
        case 'kk':
        case 'k':
          hh = extractInteger(value, pos, token.length, 2)
          if (hh == null || hh < 1 || hh > 24) {
            return null
          }
          pos += hh.length
          hh--
          break
        case 'mm':
        case 'm':
          mm = extractInteger(value, pos, token.length, 2)
          if (mm == null || mm < 0 || mm > 59) {
            return null
          }
          pos += mm.length
          break
        case 'ss':
        case 's':
          ss = extractInteger(value, pos, token.length, 2)
          if (ss == null || ss < 0 || ss > 59) {
            return null
          }
          pos += ss.length
          break
        case 'a':
          var amlength = self.locales.day_periods.am.length
          var pmlength = self.locales.day_periods.pm.length
          if (
            value.substring(pos, pos + amlength) == self.locales.day_periods.am
          ) {
            ampm = 'AM'
            pos += amlength
          } else if (
            value.substring(pos, pos + pmlength) == self.locales.day_periods.pm
          ) {
            ampm = 'PM'
            pos += pmlength
          } else {
            return null
          }
          break
        default:
          if (value.substring(pos, pos + token.length) != token) {
            return null
          } else {
            pos += token.length
          }
      }
    })
    // If there are any trailing characters left in the value, it doesn't match
    if (pos != value.length) {
      return null
    }
    if (year == null) {
      return null
    }
    if (year.length == 2) {
      if (year > 50) {
        year = 1900 + (year - 0)
      } else {
        year = 2000 + (year - 0)
      }
    }
    // Is date valid for month?
    if (month < 1 || month > 12) {
      return null
    }
    if (month == 2) {
      // Check for leap year
      if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
        // leap year
        if (date > 29) {
          return null
        }
      } else {
        if (date > 28) {
          return null
        }
      }
    }
    if (month == 4 || month == 6 || month == 9 || month == 11) {
      if (date > 30) {
        return null
      }
    }
    // Correct hours value
    if (hh < 12 && ampm == 'PM') {
      hh = hh - 0 + 12
    } else if (hh > 11 && ampm == 'AM') {
      hh -= 12
    }
    return new Date(year, month - 1, date, hh, mm, ss)
  } // end createDateFromFormat()

  /**
   *	parseDate() is a member function which parse a date string.
   *
   *	This function takes a date string and try to parse it with the input formats.
   *	If the date string matches one of the format string, it returns the
   *	the date object. Otherwise, it returns null.
   *
   *	@param (value string) the date string
   *	@return a date objet or null
   */
  Datepicker.prototype.parseDate = function(value) {
    var date = null
    var self = this
    $.each(this.options.inputFormat, function(i, format) {
      date = self.createDateFromFormat(format, value)
      if (date != null) {
        return false
      }
    })
    if (date == null) {
      // last try with the output format
      date = self.createDateFromFormat(this.options.outputFormat, value)
    }
    return date
  } // end parseDate()

  /**
   *	min() is a public member function which allow change the smallest selectable date.
   *
   *	@param (value string) the new date
   *	@return the smallest selectable date
   */
  Datepicker.prototype.min = function(value) {
    if (value != null) {
      this.options.min = value instanceof Date ? value : this.parseDate(value)
      if (this.options.min != null && this.dateObj < this.options.min) {
        this.$target.attr('aria-invalid', true)
        this.$target.parents('.form-group').addClass('has-error')
        this.dateObj = this.options.min
      }
      if (this.options.inline != false) {
        this.refresh()
      }
    }
    return this.options.min
  } // end min()

  /**
   *	max() is a public member function which allow change the biggest selectable date.
   *
   *	@param (value string) the new date
   *	@return the biggest selectable date
   */
  Datepicker.prototype.max = function(value) {
    if (value != null) {
      this.options.max = value instanceof Date ? value : this.parseDate(value)
      if (this.options.max != null && this.dateObj > this.options.max) {
        this.$target.attr('aria-invalid', true)
        this.$target.parents('.form-group').addClass('has-error')
        this.dateObj = this.options.max
      }
      if (this.options.inline != false) {
        this.refresh()
      }
    }
    return this.options.max
  } // end max()

  /**
   *	theme() is a public member function which allow change the datepicker theme.
   *
   *	@param (value string) the new theme
   *	@return the datepicker theme
   */
  Datepicker.prototype.theme = function(value) {
    if (value != null) {
      this.$button.removeClass(this.options.theme)
      this.$calendar.removeClass(this.options.theme)
      this.options.theme = value
      this.$button.addClass(this.options.theme)
      this.$calendar.addClass(this.options.theme)
    }
    return this.options.theme
  } // end theme()

  /**
   *	firstDayOfWeek() is a public member function which allow change the first Day Of Week.
   *
   *	@param (value integer) the new first Day Of Week
   *	@return the first Day Of Week
   */
  Datepicker.prototype.firstDayOfWeek = function(value) {
    if (value != null) {
      this.options.firstDayOfWeek = parseInt(value, 10)
      if (this.options.inline == false) {
        this.drawCalendarHeader()
      } else {
        this.refresh()
      }
    }
    return this.options.firstDayOfWeek
  } // end firstDayOfWeek()

  /**
   *	daysOfWeekDisabled() is a public member function which allow disabling of some weekdays.
   *
   *	@param (value string) the new disabled week days
   *	@return the disabled week days
   */
  Datepicker.prototype.daysOfWeekDisabled = function(value) {
    if (value != null) {
      this.options.daysOfWeekDisabled = []
      if (!$.isArray(value)) {
        value = [value]
      }
      var self = this
      $.each(value, function(i, val) {
        if (typeof val === 'number') {
          self.options.daysOfWeekDisabled.push(val)
        } else if (typeof val === 'string') {
          self.options.daysOfWeekDisabled.push(parseInt(val, 10))
        }
      })
    }
    return this.options.daysOfWeekDisabled
  } // end daysOfWeekDisabled()

  /**
   *	weekDayFormat() is a public member function which allow change the format of weekdays name.
   *
   *	@param (value string) the new format. Allowed : 'short' or 'narrow'
   *	@return the format of weekdays name
   */
  Datepicker.prototype.weekDayFormat = function(value) {
    if (value != null) {
      this.options.weekDayFormat = value
      this.drawCalendarHeader()
    }
    return this.options.weekDayFormat
  } // end weekDayFormat()

  /**
   *	inputFormat() is a public member function which allow change the input format.
   *
   *	@param (value string) the new format
   *	@return the input format
   */
  Datepicker.prototype.inputFormat = function(value) {
    if (value != null) {
      if (!$.isArray(value)) {
        value = [value]
      }
      if (this.$target.attr('placeholder') == this.options.inputFormat[0]) {
        this.$target.attr('placeholder', value[0])
      }
      this.options.inputFormat = value
    }
    return this.options.inputFormat
  } // end inputFormat()

  /**
   *	outputFormat() is a public member function which allow change the output format.
   *
   *	@param (value string) the new format
   *	@return the output format
   */
  Datepicker.prototype.outputFormat = function(value) {
    if (value != null) {
      this.options.outputFormat = value
    }
    return this.options.outputFormat
  } // end outputFormat()

  /**
   *	modal() is a public member function which allow to set or unset the modal mode.
   *
   *	@param (value boolean) the new modal mode
   *	@return the modal mode
   */
  Datepicker.prototype.modal = function(value) {
    if (value != null) {
      this.options.modal = value
      if (this.options.modal == true) {
        if (this.options.inline == false) {
          this.showObject(this.$calendar.find('.datepicker-close-wrap'))
          this.showObject(this.$calendar.find('.datepicker-bn-close-label'))
        }
        this.$close = this.$calendar.find('.datepicker-close')
        this.$close
          .html(this.options.closeButtonTitle)
          .attr('title', this.options.closeButtonLabel)
        this.$calendar
          .find('.datepicker-bn-close-label')
          .html(this.options.closeButtonLabel)
        var self = this
        this.$close.click(function(e) {
          return self.handleCloseClick(e)
        })
        this.$close.keydown(function(e) {
          return self.handleCloseKeyDown(e)
        })
      } else {
        this.hideObject(this.$calendar.find('.datepicker-close-wrap'))
        this.hideObject(this.$calendar.find('.datepicker-bn-close-label'))
      }
    }
    return this.options.modal
  } // end modal()

  /**
   *	inline() is a public member function which allow to set or unset the inline mode.
   *
   *	@param (value string or false) the id or jquery object of the datepicker container, false otherwise (not inline)
   *	@return the given value
   */
  Datepicker.prototype.inline = function(value) {
    if (value != null) {
      if (value != false) {
        this.hideObject(this.$button)
        this.hideObject(this.$calendar.find('.datepicker-close-wrap'))
        this.hideObject(this.$calendar.find('.datepicker-bn-close-label'))
        var $container = typeof value === 'string' ? $('#' + value) : value
        $container.append(this.$calendar)
        this.$calendar.css({ position: 'relative', left: '0px', top: '0px' })
        this.options.inline = value
        this.initializeDate()
        this.showObject(this.$calendar)
      } else {
        this.$target.parent().after(this.$calendar)
        this.showObject(this.$button)
        if (this.options.modal == true) {
          this.showObject(this.$calendar.find('.datepicker-close-wrap'))
          this.showObject(this.$calendar.find('.datepicker-bn-close-label'))
        }
        if (this.$calendar.parent().css('position') === 'static') {
          this.$calendar.parent().css('position', 'relative')
        }
        this.$calendar.css({ position: 'absolute' })
        this.options.inline = value
        this.hide()
      }
    }
    return this.options.inline
  } // end inline()

  /**
   *	format() is a public member function to format a date according the output format.
   *
   *	@param (value date object) the date
   *	@return formatted date string
   */
  Datepicker.prototype.format = function(date) {
    return this.formatDate(date, this.options.outputFormat)
  } // end format()

  /**
   *	enable() is a public member function to enable this datepicker.
   */
  Datepicker.prototype.enable = function() {
    this.$button.removeClass('disabled')
    this.$button.attr('aria-disabled', false)
    this.$button.attr('tabindex', 0)
  } // end enable()

  /**
   *	disable() is a public member function to disable this datepicker.
   */
  Datepicker.prototype.disable = function() {
    this.hide()
    this.$button.addClass('disabled')
    this.$button.attr('aria-disabled', true)
    this.$button.attr('tabindex', -1)
  } // end enable()

  /**
   *	datesDisabled() is a public member function to set dates to be disabled.
   */
  Datepicker.prototype.datesDisabled = function(dates) {
    this.options.datesDisabled = []
    if (!$.isArray(dates)) {
      dates = [dates]
    }
    var self = this
    $.each(dates, function(i, v) {
      if (typeof v === 'string') {
        var date = self.parseDate(v)
        if (date !== null) {
          self.options.datesDisabled.push(self.format(date))
        }
      } else if (v instanceof Date && !isNaN(v.valueOf())) {
        self.options.datesDisabled.push(self.format(v))
      }
    })
  } // end datesDisabled()

  /**
   *	startview() is a public member function to format a date according the output format.
   *
   *	@param (value int|string) the new view
   *	@return  N/A
   */
  Datepicker.prototype.startview = function(view) {
    switch (view) {
      case 1:
      case 'months':
        this.options.startView = 1
        break
      case 2:
      case 'years':
        this.options.startView = 2
        break
      default:
        this.options.startView = 0
    }
  } // end startview()

  /**
   *	setLocales() is a public member function which allow change the locales.
   *
   *	@param (value obj) the new locales
   *	@return N/A
   */
  Datepicker.prototype.setLocales = function(value) {
    this.locales = value
    this.options.inputFormat = [this.locales.short_format]
    this.options.outputFormat = this.locales.short_format
    ;(this.options.titleFormat = this.locales.full_format),
      (this.options.firstDayOfWeek = this.locales.firstday_of_week)
    this.options.buttonTitle = this.locales.texts.buttonTitle
    this.$button.find('span').attr('title', this.options.buttonTitle)
    this.options.buttonLabel = this.locales.texts.buttonLabel
    this.options.prevButtonLabel = this.locales.texts.prevButtonLabel
    this.options.prevMonthButtonLabel = this.locales.texts.prevMonthButtonLabel
    this.options.prevYearButtonLabel = this.locales.texts.prevYearButtonLabel
    this.options.nextButtonLabel = this.locales.texts.nextButtonLabel
    this.options.nextMonthButtonLabel = this.locales.texts.nextMonthButtonLabel
    this.options.nextYearButtonLabel = this.locales.texts.nextYearButtonLabel
    this.options.changeMonthButtonLabel = this.locales.texts.changeMonthButtonLabel
    this.options.changeYearButtonLabel = this.locales.texts.changeYearButtonLabel
    this.options.changeRangeButtonLabel = this.locales.texts.changeRangeButtonLabel
    this.options.closeButtonTitle = this.locales.texts.closeButtonTitle
    this.options.closeButtonLabel = this.locales.texts.closeButtonLabel
    this.options.calendarHelp = this.locales.texts.calendarHelp
    this.drawCalendarHeader()
    if (this.locales.directionality === 'RTL') {
      this.$grid.addClass('rtl')
    } else {
      this.$grid.removeClass('rtl')
    }
  } // end outputFormat()

  // DATEPICKER PLUGIN DEFINITION
  // ==========================

  var old = $.fn.datepicker

  $.fn.datepicker = function(option, value) {
    if (typeof option == 'string' && $(this).length == 1) {
      var data = $(this)
        .eq(0)
        .data('ab.datepicker')
      if (data) return data[option](value)
    } else {
      return this.each(function() {
        var $this = $(this)
        var data = $this.data('ab.datepicker')
        var options = $.extend(
          {},
          Datepicker.DEFAULTS,
          $this.data(),
          typeof option == 'object' && option
        )
        if (!data)
          $this.data('ab.datepicker', (data = new Datepicker(this, options)))
        if (typeof option == 'string') data[option](value)
      })
    }
  }

  $.fn.datepicker.Constructor = Datepicker

  // DATEPICKER NO CONFLICT
  // ====================

  $.fn.datepicker.noConflict = function() {
    $.fn.datepicker = old
    return this
  }
})

/* !
 * "position: sticky" jQuery plugin / polyfill
 * https://github.com/regru/i-sticky
 * License: MIT
 */
;(function($) {
  var prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-'],
    stickyTestElement = document.createElement('div'),
    hasNativeSupport = false,
    areWindowEventsAttached = false,
    isAnimationRequested = false,
    lastKnownScrollTop = 0,
    lastKnownScrollLeft = 0,
    affectedChromeVersions = ['56'],
    // requestAnimationFrame may be prefixed
    requestAnimationFrame =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame,
    idCounter = 0,
    stickies = [],
    methods = {
      unstick: function() {
        var currentId = $(this).data('sticky-id'),
          removeIndex,
          el

        for (var i = stickies.length - 1; i >= 0; i--) {
          if (stickies[i].id == currentId) {
            removeIndex = i
            break
          }
        }

        if (typeof removeIndex !== 'undefined') {
          el = stickies.splice(removeIndex, 1)
        }

        if (typeof el !== 'undefined') {
          $(this)
            .removeAttr('style')
            .next('.' + el[0].options.holderClass)
            .remove()
        }

        return this
      },
    }

  if (!checkIfBrowserAffectedWithBug()) {
    for (var i = 0, l = prefixTestList.length; i < l; i++) {
      stickyTestElement.setAttribute(
        'style',
        'position:' + prefixTestList[i] + 'sticky'
      )

      if (stickyTestElement.style.position !== '') {
        hasNativeSupport = true
        break
      }
    }
  }

  $.fn.iSticky = function(methodOrOptions) {
    if (hasNativeSupport) {
      if (typeof methodOrOptions === 'object' && methodOrOptions.force) {
        attachWindowEvents()
      } else {
        return this
      }
    }

    if (typeof methodOrOptions === 'string' && methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      )
    }

    var options = $.extend(
        {
          holderClass: 'i-sticky__holder',
          holderAutoHeight: true,
          debug: false,
          fixWidth: true,
          stuckClass: '',
        },
        methodOrOptions
      ),
      selector = this.selector

    return this.each(function() {
      var $this = $(this),
        id = 'sticky-' + ++idCounter,
        topCSSstring,
        bottomCSSstring,
        item

      // 'auto' value workaround
      // http://stackoverflow.com/questions/13455931/jquery-css-firefox-dont-return-auto-values
      $this.hide()

      topCSSstring = $this.css('top')
      bottomCSSstring = $this.css('bottom')

      $this.show()

      if (!topCSSstring && !bottomCSSstring) {
        if (options.debug) {
          console.warn(
            'i-sticky: element `top` or `bottom` properties must be set in pixels',
            selector,
            this
          )
        }

        return
      }

      $this
        .data('sticky-id', id)
        .after(
          '<span class="' +
            options.holderClass +
            '" style="display:none;"></span>'
        )

      item = {
        id: id,
        el: this,
        parent: this.parentElement,
        holder: this.nextSibling,
        style: {
          home: 'position:static;',
          top: undefined,
          bottom: undefined,
          current: '',
          height: 0,
          isStuck: false,
          margin: { left: parseInt($this.css('margin-left'), 10) },
        },
        options: {
          holderClass: options.holderClass,
          holderAutoHeight: options.holderAutoHeight,
          fixWidth: options.fixWidth,
          stuckClass: options.stuckClass || '',
        },
      }

      if (topCSSstring !== 'auto') {
        item.style.top = {
          fixed: 'position:fixed;top:' + topCSSstring + ';bottom:auto;',
          opposite: 'position:absolute;bottom:0;top:auto;',
          px: parseInt(topCSSstring, 10),
        }
      }

      if (bottomCSSstring !== 'auto') {
        item.style.bottom = {
          fixed: 'position:fixed;bottom:' + bottomCSSstring + ';top:auto;',
          opposite: 'position:absolute;top:0;bottom:auto;',
          px: parseInt(bottomCSSstring, 10),
        }
      }

      stickies.push(item)

      updateScrollPos()
    })
  }

  function getOffset(elem) {
    var docElem,
      body,
      win,
      clientTop,
      clientLeft,
      scrollTop,
      scrollLeft,
      box = {
        top: 0,
        left: 0,
      },
      doc = elem && elem.ownerDocument

    if (!doc) {
      if (options.debug) {
        console.error('i-sticky: no element.ownerDocument defined')
      }

      return
    }

    if ((body = doc.body) === elem) {
      return {
        top: body.offsetTop,
        left: body.offsetLeft,
      }
    }

    docElem = doc.documentElement

    if (typeof elem.getBoundingClientRect !== 'undefined') {
      box = elem.getBoundingClientRect()
    }

    win = window
    clientTop = docElem.clientTop || body.clientTop || 0
    clientLeft = docElem.clientLeft || body.clientLeft || 0
    scrollTop = win.pageYOffset || docElem.scrollTop
    scrollLeft = win.pageXOffset || docElem.scrollLeft

    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft,
    }
  }

  function setPositions() {
    var scrollTop = lastKnownScrollTop,
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      windowHeight =
        window.innerHeight || document.documentElement.clientHeight,
      scrollBottom = scrollTop + windowHeight

    isAnimationRequested = false

    for (var i = 0, l = stickies.length; i < l; i++) {
      var item = stickies[i],
        height = item.el.offsetHeight,
        parentOffset = getOffset(item.parent),
        homeOffset = item.style.isStuck
          ? getOffset(item.holder)
          : getOffset(item.el),
        topPx = item.style.top ? item.style.top.px : 0,
        bottomPx = item.style.bottom ? item.style.bottom.px : 0,
        style = item.style.home,
        isStuck = true,
        classes = item.el.className.split(' '),
        index = 0,
        points = {
          parent: parentOffset.top,
          home: homeOffset.top - topPx,
          under: parentOffset.top + item.parent.offsetHeight - height - topPx,
          parentBottom: parentOffset.top + height + bottomPx,
          homeBottom: homeOffset.top + height + bottomPx,
        }

      for (index in classes) {
        if (classes[index] === item.options.stuckClass) {
          classes.splice(index, 1)
        }
      }

      item.el.className = classes.join(' ')

      if (item.style.bottom && scrollBottom <= points.parentBottom) {
        style = item.style.bottom.opposite
      } else if (
        item.style.bottom &&
        scrollBottom > points.parentBottom &&
        scrollBottom < points.homeBottom
      ) {
        style = item.style.bottom.fixed
      } else if (
        item.style.top &&
        scrollTop > points.home &&
        scrollTop < points.under
      ) {
        style = item.style.top.fixed
      } else if (item.style.top && scrollTop >= points.under) {
        style = item.style.top.opposite
      } else {
        isStuck = false
      }

      if (item.style.isStuck !== isStuck) {
        item.holder.style.display = isStuck ? 'block' : 'none'
      }

      if (isStuck && item.options.stuckClass) {
        item.el.className += ' ' + item.options.stuckClass
      }

      if (isStuck) {
        style += 'margin-left:-' + (scrollLeft - item.style.margin.left) + 'px;'
      }

      if (item.options.fixWidth) {
        style +=
          'width:' + (isStuck ? item.holder.offsetWidth + 'px;' : 'auto;')
      } else {
        style +=
          'min-width:' + (isStuck ? item.holder.offsetWidth + 'px;' : 'auto;')
      }

      if (style !== item.style.current) {
        item.el.setAttribute('style', style)
        item.style.isStuck = isStuck
        item.style.current = style
      }

      if (
        item.options.holderAutoHeight &&
        isStuck &&
        height != item.style.height
      ) {
        item.holder.style.height = height + 'px'
        item.style.height = height
      }
    }

    lastKnownScrollLeft = scrollLeft
  }

  var timeout

  // Debounced scroll handling
  function updateScrollPos() {
    if (!stickies.length) {
      return
    }

    lastKnownScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop

    // Only trigger a layout change if we’re not already waiting for one
    if (!isAnimationRequested) {
      isAnimationRequested = true

      // Don’t update until next animation frame if we can, otherwise use a
      // timeout - either will help avoid too many repaints
      if (requestAnimationFrame) {
        requestAnimationFrame(setPositions)
      } else {
        if (timeout) {
          clearTimeout(timeout)
        }

        timeout = setTimeout(setPositions, 15)
      }
    }
  }

  function attachWindowEvents() {
    if (areWindowEventsAttached) {
      return
    }

    $(window)
      .on('scroll', updateScrollPos)
      .on('resize', updateScrollPos)

    updateScrollPos()
    areWindowEventsAttached = true
  }

  function checkIfBrowserAffectedWithBug() {
    if (!window.chrome) {
      return false
    }

    var matches = /Chrom(e|ium)\/(\d+)/.exec(navigator.appVersion)

    return matches && ~affectedChromeVersions.indexOf(matches[2])
  }

  if (!hasNativeSupport) {
    attachWindowEvents()
  }
})(jQuery)

/**
 * sticky-header js lib
 * @ Fabio Fumis
 */
;(function() {
  const elSticky = document.querySelector('.it-header-sticky')

  if (!!elSticky) {
    function isHidden(el) {
      let hidden = false
      if (el) {
        const style = window.getComputedStyle(el)
        hidden = style.display === 'none' || style.visibility === 'hidden'
      }
      return hidden
    }

    const elToggler = document.querySelector('.custom-navbar-toggler')
    const isDesktop = isHidden(elToggler)

    let isSticky = false
    let scrollToGap = 0

    let runCheckSticky = undefined

    const initSticky = isDesktop => {
      const elSlim = document.querySelector('.it-header-slim-wrapper')
      const elCenter = document.querySelector('.it-header-center-wrapper')
      const elNavbar = document.querySelector('.it-header-navbar-wrapper')

      const navbarHeight = (elNavbar && elNavbar.offsetHeight) || 0
      const slimHeight = (elSlim && elSlim.offsetHeight) || 0
      let navOffsetTop = slimHeight

      if (isDesktop && navbarHeight) {
        navOffsetTop = slimHeight + elCenter ? elCenter.offsetHeight : 0
      }

      const toggleClonedElement = (isDesktop, toAdd = true, callback) => {
        if (isDesktop) {
          const target = document.querySelector('.menu-wrapper')

          if (toAdd) {
            const elBrand = document.querySelector('.it-brand-wrapper')
            const elSearch = document.querySelector('.it-search-wrapper')
            const elUser = document.querySelector('.it-user-wrapper')

            const clonedBrand = elBrand ? elBrand.cloneNode(true) : null
            const clonedSearch = elSearch ? elSearch.cloneNode(true) : null
            const clonedUser = elUser ? elUser.cloneNode(true) : null

            if (clonedBrand)
              target
                .insertBefore(clonedBrand, target.childNodes[0])
                .classList.add('cloned')
            if (clonedSearch)
              target.appendChild(clonedSearch).classList.add('cloned')
            if (clonedUser)
              target
                .appendChild(clonedUser)
                .classList.add('cloned')
                .remove('show')
          } else {
            const clonedItems = document.getElementsByClassName('cloned')
            clonedItems &&
              Array.from(clonedItems).forEach(item => {
                item.parentElement.removeChild(item)
              })

            if (typeof callback === 'function') {
              callback()
            }
          }
        }

        if (toAdd) {
          elSticky.nextElementSibling.style.paddingTop =
            navbarHeight +
            (isDesktop
              ? navOffsetTop - scrollToGap
              : navbarHeight - scrollToGap) +
            'px'
        } else {
          elSticky.nextElementSibling.style.paddingTop = 0 + 'px'
        }
      }

      const toggleOn = () => {
        isSticky = true
        elSticky.classList.add('is-sticky')
        toggleClonedElement(isDesktop, true)
      }

      const toggleOff = () => {
        isSticky = false
        elSticky.classList.remove('is-sticky')
        toggleClonedElement(isDesktop, false)
      }

      runCheckSticky = () => {
        const nbh = navbarHeight
        if (window.scrollY + scrollToGap >= navOffsetTop && !isSticky) {
          toggleOn()
          if (nbh !== navbarHeight) scrollToGap = navbarHeight - nbh
        } else if (window.scrollY + scrollToGap < navOffsetTop && isSticky) {
          toggleOff()
        }
      }

      window.addEventListener('scroll', runCheckSticky)

      runCheckSticky()
    }

    initSticky(isDesktop)
  }
})()

;(function() {
  const elWrappers = document.getElementsByClassName('sticky-wrapper')
  const elToggler = document.querySelector('.custom-navbar-toggler')
  const isDesktop = isHidden(elToggler)

  let runCheckOnScroll = undefined

  function isHidden(el) {
    let _ret = false
    if (el) {
      const style = window.getComputedStyle(el)
      _ret = style.display === 'none' || style.visibility === 'hidden'
    }
    return _ret
  }

  if (elWrappers && elWrappers.length) {
    let isSticky = false

    const initSticky = isDesktop => {
      const getPadding = (parent, size) => {
        return isDesktop
          ? parseInt(
              (window.getComputedStyle
                ? getComputedStyle(parent, null)
                : parent.currentStyle)[size]
            )
          : 0
      }

      const getPosition = (isNavBottom, gap, position) => {
        if (!isDesktop && isNavBottom && position === 'bottom') {
          return '0px'
        } else if (!isDesktop && isNavBottom && position === 'top') {
          return 'auto'
        } else if (position === 'bottom') {
          return ''
        } else {
          return gap + 'px'
        }
      }

      // Get header height
      const elNavigation = isDesktop
        ? document.querySelector('.it-header-navbar-wrapper')
        : document.querySelector('.it-header-center-wrapper')

      runCheckOnScroll = () => {
        // Set monitoring offset top
        const navOffsetTop = elNavigation ? elNavigation.offsetHeight : 0
        // Check the sticky status
        const runCheckSticky = elSticky => {
          // Check is set on bottom
          // Force position of navscroll to bottom
          // const navBottom = elSticky.outerHTML.includes('it-bottom-navscroll')
          const navBottom = true

          const elHeight = elSticky.offsetHeight
          // Get parent params
          const parent = elSticky.parentNode
          parent.style.position = 'relative'
          const parentWidth = parent.offsetWidth || 0
          const parentHeight = parent.offsetHeight
          const parentPaddingTop = getPadding(parent, 'paddingTop')
          const parentPaddingWidth = getPadding(parent, 'paddingRight')
          // Get distance of a element from top
          const distanceToTop = parent.getBoundingClientRect().top || 0
          const gap = navOffsetTop + parentPaddingTop

          // Check if the element is actually in a sticky position
          // if (!isSticky && distanceToTop <= navOffsetTop) {
          if (distanceToTop <= navOffsetTop) {
            isSticky = true
            elSticky.classList.add('is-sticky')
            elSticky.style.top = getPosition(navBottom, gap, 'top')
            elSticky.style.bottom = getPosition(navBottom, gap, 'bottom')
            if (isDesktop) {
              elSticky.style.width = parentWidth - parentPaddingWidth + 'px'
            } else {
              elSticky.style.width = ''
            }
          } else if (isSticky && distanceToTop > navOffsetTop) {
            isSticky = false
            elSticky.classList.remove('is-sticky')
            elSticky.style.top = ''
            elSticky.style.bottom = ''
            elSticky.style.width = ''
          }

          // Check if at bottom of parent
          if (isSticky && isDesktop) {
            if (
              distanceToTop < 0 &&
              Math.abs(distanceToTop) +
                elHeight +
                parentPaddingTop +
                navOffsetTop >
                parentHeight
            ) {
              elSticky.classList.add('at-bottom')
            } else {
              elSticky.classList.remove('at-bottom')
            }
          }
        }

        Array.from(elWrappers).forEach(elSticky => {
          runCheckSticky(elSticky)
        })
      }

      window.addEventListener('scroll', runCheckOnScroll)

      runCheckOnScroll()
    }

    const onResize = () => {
      if (runCheckOnScroll) {
        window.removeEventListener('scroll', runCheckOnScroll)
        const stillDesktop = isHidden(elToggler)
        initSticky(stillDesktop)
      }
    }

    window.addEventListener('resize', onResize)

    initSticky(isDesktop)
  }
})()

function isIe() {
  return window.navigator.userAgent.indexOf("MSIE ") > 0
    || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}

// Create our stylesheet
var styleNode = document.createElement('style')
const __PUBLIC_PATH__ = window.__PUBLIC_PATH__
  ? window.__PUBLIC_PATH__
  : '/bootstrap-italia/dist/fonts'
styleNode.innerHTML = `
/* Titillium+Web:300,400,600,700 */

/* latin-ext */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 300;
  src: local('Titillium Web Light'), local('TitilliumWeb-Light'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 300;
  src: local('Titillium Web Light'), local('TitilliumWeb-Light'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Light.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 400;
  src: local('Titillium Web Regular'), local('TitilliumWeb-Regular'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 400;
  src: local('Titillium Web Regular'), local('TitilliumWeb-Regular'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Regular.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 600;
  src: local('Titillium Web SemiBold'), local('TitilliumWeb-SemiBold'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 600;
  src: local('Titillium Web SemiBold'), local('TitilliumWeb-SemiBold'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-SemiBold.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 700;
  src: local('Titillium Web Bold'), local('TitilliumWeb-Bold'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Titillium Web';
  font-style: normal;
  font-weight: 700;
  src: local('Titillium Web Bold'), local('TitilliumWeb-Bold'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Titillium_Web/TitilliumWeb-Bold.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* Lora:400,700 */

/* latin-ext */
@font-face {
  font-family: 'Lora';
  font-style: normal;
  font-weight: 400;
  src: local('Lora Regular'), local('Lora-Regular'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Lora';
  font-style: normal;
  font-weight: 400;
  src: local('Lora Regular'), local('Lora-Regular'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Regular.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Lora';
  font-style: normal;
  font-weight: 700;
  src: local('Lora Bold'), local('Lora-Bold'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Lora';
  font-style: normal;
  font-weight: 700;
  src: local('Lora Bold'), local('Lora-Bold'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Lora/Lora-Bold.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* Roboto+Mono:400,700 */

/* latin-ext */
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 400;
  src: local('Roboto Mono'), local('RobotoMono-Regular'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 400;
  src: local('Roboto Mono'), local('RobotoMono-Regular'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Regular.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 700;
  src: local('Roboto Mono Bold'), local('RobotoMono-Bold'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.ttf) format('truetype');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto Mono';
  font-style: normal;
  font-weight: 700;
  src: local('Roboto Mono Bold'), local('RobotoMono-Bold'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.woff2) format('woff2'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.woff) format('woff'),
  url(${__PUBLIC_PATH__}/Roboto_Mono/RobotoMono-Bold.ttf) format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
`

document.getElementsByTagName('head')[0].appendChild(styleNode);

'use strict'

$(function() {
  $.fn.autocomplete = function(options) {
    // Default options
    var defaults = {
      data: {},
    }

    // Get options
    options = $.extend(defaults, options)

    return this.each(function() {
      let $input = $(this)
      let $autocomplete = null
      let data = $input.data('autocomplete')

      if (data && Object.keys(data).length) {
        $autocomplete = $('<ul class="autocomplete-list"></ul>')
        $autocomplete.insertAfter($(this).next())

        // Listen if key was pressed
        $input.on('keyup', function(e) {
          // get value from input
          const q = $input.val()

          $autocomplete.empty()

          // check if input isn't empty
          if (q.length) {
            for (const item in data) {
              let markText = new RegExp('(' + q + ')', 'gi')
              let optionText = data[item].text.replace(
                markText,
                '<mark>$1</mark>'
              )
              let optionLabel = data[item].label
                ? '<em>' + data[item].label + '</em>'
                : ''
              let optionIcon = data[item].icon ? data[item].icon : ''
              let optionLink = data[item].link ? data[item].link : '#'

              if (optionText.toLowerCase().indexOf(q.toLowerCase()) !== -1) {
                $(this)
                  .closest('.form-group')
                  .find('.autocomplete-list')
                  .addClass('autocomplete-list-show')
                let option = $(`<li>
              <a href="${optionLink}">
                ${optionIcon}
                <span class="autocomplete-list-text">
                  <span>${optionText}</span>
                  ${optionLabel}
                </span>
              </a>
             </li>`)
                $autocomplete.append(option)
              }
            }
          } else {
            $(this)
              .closest('.form-group')
              .find('.autocomplete-list')
              .removeClass('autocomplete-list-show')
          }
        })
      }
    })
  }

  $('.autocomplete').autocomplete()
})

$(function() {
  const $backToTopElements = $('a[data-attribute*="back-to-top"]')
  $(window).on('scroll', function() {
    $backToTopElements.toggleClass(
      'back-to-top-show',
      $backToTopElements.length && $(this).scrollTop() >= 100
    )
  })

  $backToTopElements.on('click', function() {
    $('body,html').animate({ scrollTop: 0 }, 800)
  })
})

const ComponenteBase = ($ => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME = `componenteBase`
  const VERSION = `1.0.0`
  const DATA_KEY = `bs.componente-base`
  const EVENT_KEY = `.${DATA_KEY}` // '.bs.componente-base'
  const DATA_API_KEY = `.data-api`
  const JQUERY_NO_CONFLICT = $.fn[NAME]

  const Event = {
    CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`, // 'click.bs.componente-base.data-api'
  }

  const Selector = {
    COMPONENTE_BASE: '.componente-base',
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class ComponenteBase {
    constructor(element) {
      this._element = element
    }

    // Getters

    static get VERSION() {
      return VERSION
    }

    // Public

    publicFunction(element) {
      console.log($(element).data('value'), ComponenteBase.VERSION)
    }

    // Static

    static _jQueryInterface(config) {
      return this.each(function() {
        const $element = $(this)
        let data = $element.data(DATA_KEY)

        if (!data) {
          data = new ComponenteBase(this)
          $element.data(DATA_KEY, data)
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError(`No method named "${config}"`)
          }
          data[config](this)
        }
      })
    }

    static _handleConsole(baseInstance) {
      return function(event) {
        if (event) {
          event.preventDefault()
        }

        baseInstance.publicFunction(this)
      }
    }
  }

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(
    Event.CLICK_DATA_API,
    Selector.COMPONENTE_BASE,
    ComponenteBase._handleConsole(new ComponenteBase())
  )

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = ComponenteBase._jQueryInterface
  $.fn[NAME].Constructor = ComponenteBase
  $.fn[NAME].noConflict = function() {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return ComponenteBase._jQueryInterface
  }

  return ComponenteBase
})($)



const Cookiebar = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME = 'cookiebar'
  const VERSION = '4.0.0'
  const DATA_KEY = 'bs.cookiebar'
  const EVENT_KEY = `.${DATA_KEY}`
  const DATA_API_KEY = '.data-api'
  const JQUERY_NO_CONFLICT = $.fn[NAME]
  const COOKIE_NAME = 'cookies_consent'
  const COOKIE_VALUE = 'true'
  const COOKIE_EXPIRE = 30

  const Selector = {
    COOKIE_BAR: '.cookiebar',
    ACCEPT: '[data-accept="cookiebar"]',
  }

  const Event = {
    CLOSE: `close${EVENT_KEY}`,
    CLOSED: `closed${EVENT_KEY}`,
    LOAD_DATA_API: `load${EVENT_KEY}${DATA_API_KEY}`,
    CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`,
  }

  const ClassName = {
    COOKIE_BAR: 'cookiebar',
    SHOW: 'show',
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Cookiebar {
    constructor(element) {
      this._element = element
    }

    // Getters

    static get VERSION() {
      return VERSION
    }

    // Public

    show(element) {
      $(element)
        .addClass(ClassName.SHOW)
        .attr('aria-hidden', 'false')
        .attr('aria-live', 'polite')
    }

    close(element) {
      element = element || this._element

      const rootElement = this._getRootElement(element)
      const customEvent = this._triggerCloseEvent(rootElement)

      if (customEvent.isDefaultPrevented()) {
        return
      }
      this._setCookieEU()
      this._removeElement(rootElement)
    }

    dispose() {
      $.removeData(this._element, DATA_KEY)
      this._element = null
    }

    // Private

    _setCookieEU() {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + COOKIE_EXPIRE)
      var c_value =
        escape(COOKIE_VALUE) +
        (COOKIE_EXPIRE == null ? '' : '; expires=' + exdate.toUTCString())
      document.cookie = COOKIE_NAME + '=' + c_value + '; path=/'
    }

    _getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (err) {
        return null;
      }
    }

    _getRootElement(element) {
      const selector = this._getSelectorFromElement(element)
      let parent = false

      if (selector) {
        parent = $(selector)[0]
      }

      if (!parent) {
        parent = $(element).closest(`.${ClassName.COOKIE_BAR}`)[0]
      }

      return parent
    }

    _triggerCloseEvent(element) {
      const closeEvent = $.Event(Event.CLOSE)

      $(element).trigger(closeEvent)
      return closeEvent
    }

    _removeElement(element) {
      $(element)
        .removeClass(ClassName.SHOW)
        .attr('aria-hidden', 'true')
        .attr('aria-live', 'off')

      this._destroyElement(element)
    }

    _destroyElement(element) {
      $(element)
        .detach()
        .trigger(Event.CLOSED)
        .remove()
    }

    // Static

    static _jQueryInterface(config) {
      return this.each(function() {
        const $element = $(this)
        let data = $element.data(DATA_KEY)

        if (!data) {
          data = new Cookiebar(this)
          $element.data(DATA_KEY, data)
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError(`No method named "${config}"`)
          }
          data[config](this)
        }
      })
    }

    static _handleAccept(cookiebarInstance) {
      return function(event) {
        if (event) {
          event.preventDefault()
        }

        cookiebarInstance.close(this)
      }
    }

    static _handleConsent(cookiebarInstance) {
      return function(event) {
        if (event) {
          event.preventDefault()
        }

        cookiebarInstance.close(this)
      }
    }

    static _getCookieEU() {
      var i,
        x,
        y,
        ARRcookies = document.cookie.split(';')
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='))
        y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1)
        x = x.replace(/^\s+|\s+$/g, '')
        if (x == COOKIE_NAME) {
          return unescape(y)
        }
      }
    }
  }

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(
    Event.CLICK_DATA_API,
    Selector.ACCEPT,
    Cookiebar._handleAccept(new Cookiebar())
  )

  $(window).on(Event.LOAD_DATA_API, () => {
    const cookiebars = $.makeArray($(Selector.COOKIE_BAR))
    var consent = Cookiebar._getCookieEU()
    if (!consent) {
      for (let i = cookiebars.length; i--; ) {
        const $cookiebar = $(cookiebars[i])
        Cookiebar._jQueryInterface.call($cookiebar, 'show')
      }
    }
  })

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Cookiebar._jQueryInterface
  $.fn[NAME].Constructor = Cookiebar
  $.fn[NAME].noConflict = function() {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return Cookiebar._jQueryInterface
  }

  return Cookiebar
})($)



$(function() {
  // Animazione slide down
  $('.navbar .dropdown').on('show.bs.dropdown', function() {
    if (window.matchMedia('(max-width: 992px)').matches) {
      $(this)
        .find('.dropdown-menu')
        .first()
        .stop(true, true)
        .slideDown(180)
    }
  })

  // Animazione slide up
  $('.navbar .dropdown').on('hide.bs.dropdown', function() {
    if (window.matchMedia('(max-width: 992px)').matches) {
      $(this)
        .find('.dropdown-menu')
        .first()
        .stop(true, true)
        .slideUp(180)
    }
  })

  $(window).resize(function() {
    // reset parametri click iniettati su mobile
    if (window.matchMedia('(min-width: 993px)').matches) {
      $('.navbar .dropdown-menu.show').removeAttr('style')
    }
  })
})

$(function() {
  const inputSelector =
    'input[type="text"],' +
    'input[type="password"],' +
    'input[type="email"],' +
    'input[type="email"],' +
    'input[type="url"],' +
    'input[type="tel"],' +
    'input[type="number"],' +
    'input[type="search"],' +
    'textarea'

  const inputFileSelector = 'input[type="file"]'

  const handleLabelWidth = $input => {
    const labelsForInput = $input.siblings('label:not(.active)')
    if (labelsForInput && labelsForInput.length) {
      let labelWidth =
        labelsForInput[0].offsetWidth > $input[0].offsetWidth - 20
          ? $input[0].offsetWidth
          : 'auto'
      $(labelsForInput[0]).css('width', labelWidth)
    }
  }

  $(document)
    .on('focus', inputSelector, e => {
      const $this = $(e.target)
      $this.siblings('label, i').addClass('active')
      const labelsForInput = $this.siblings('label')
      if (labelsForInput && labelsForInput.length) {
        $(labelsForInput[0]).css('width', 'auto')
      }
    })
    .on('blur', inputSelector, e => {
      const $this = $(e.target)
      const noValue = !$this.val()
      const noPlaceholder = !$this.attr('placeholder')

      if (noValue && noPlaceholder) {
        $this.siblings('label, i').removeClass('active')
        handleLabelWidth($this)
      }
    })
    .on('change', inputSelector, e => {
      const $this = $(e.target)
      updateTextFields($this)
      validateField($this)
    })
    .on('blur', inputFileSelector, e => {
      const $this = $(e.target)
      $this.siblings('label').addClass('active')
    })
    .on('change', inputFileSelector, e => {
      const $this = $(e.target)
      var numFiles = e.currentTarget.files.length
      var nomiFiles = ''
      var multi = ''
      for (i = 0; i < numFiles; i++) {
        fileSize = parseInt(e.currentTarget.files[i].size, 10) / 1024
        filesize = Math.round(fileSize)
        nomiFiles =
          nomiFiles + e.currentTarget.files[i].name + ' (' + filesize + 'kb); '
      }
      if (numFiles > 1) {
        multi = numFiles + ' file da caricare: '
      }
      $this.siblings('.form-file-name').text(multi + nomiFiles)
    })

  const updateTextFields = $input => {
    const $labelAndIcon = $input.siblings('label, i')
    const hasValue = $input.val().length
    const hasPlaceholder = !!$input.attr('placeholder')
    if (hasValue || hasPlaceholder) {
      $labelAndIcon.addClass('active')
    } else {
      $labelAndIcon.removeClass('active')
    }
  }

  const validateField = $input => {
    if ($input.hasClass('validate')) {
      const value = $input.val()
      const noValue = !value.length
      const isValid = !$input[0].validity.badInput
      if (noValue && isValid) {
        $input.removeClass('valid').removeClass('invalid')
      } else {
        const valid = $input.is(':valid')
        const length = Number($input.attr('length')) || 0
        if (valid && (!length || length > value.length)) {
          $input.removeClass('invalid').addClass('valid')
        } else {
          $input.removeClass('valid').addClass('invalid')
        }
      }
    }
  }

  const handleLabelPosition = () => {
    $('body')
      .find(inputSelector)
      .removeClass('valid invalid')
      .each((index, input) => {
        const $this = $(input)
        const hasDefaultValue = !!$this.val()
        const hasPlaceholder = !!$this.attr('placeholder')
        if (hasDefaultValue || hasPlaceholder) {
          $this
            .siblings('label, i')
            .css('transition', 'none')
            .addClass('active')
        }

        if (!hasDefaultValue && !hasPlaceholder) {
          $this.siblings('label, i').removeClass('active')
          handleLabelWidth($this)
        }
      })
  }

  $(window).resize(function() {
    $(inputSelector).each((index, input) => {
      let $this = $(input)
      handleLabelWidth($this)
    })
  })

  handleLabelPosition()

  $(document).on('changed.bs.form-control', handleLabelPosition)

})

$(function() {
  var usingMouse

  $(document)
    .on('keydown mousedown', function(e) {
      usingMouse = e.type === 'mousedown'
    })
    .on('focusin', function(e) {
      if (usingMouse) {
	if (e.target){
		$(e.target).addClass('focus--mouse');
	}
      }
    })
    .on('focusout', function(e) {
      if (e.target){
	   $(e.target).removeClass('focus--mouse');
      }
    })
})

$(function() {
  $('a[data-attribute*="forward"]').on('click', function(event) {
    let target = $(this.hash)
    if (target.length) {
      event.preventDefault()
      $('html, body').animate(
        {
          scrollTop: target.offset().top,
        },
        500
      )
    }
  })
})

$(function() {
  // open / close navbar actions
  var openbutton = $('.custom-navbar-toggler')
  var closebutton = $('.close-div')
  var overlay = $('.overlay')
  var backbutton = $('.it-back-button')
  var navlink = $('.navbar-collapsable a')

  //-open button action
  $(openbutton).on('click', function(event) {
    /* Act on the event */
    var target = $(this).attr('data-target')
    var fadelayer = $(target).find('.overlay')
    $(this).attr('aria-expanded', 'true')
    $(backbutton).fadeIn()
    $(target).show()
    $(fadelayer).fadeIn()
    $(target).addClass('expanded')
  })

  $(overlay).on('click', function() {
    var target = $(this).closest('.navbar-collapsable')
    var buttonrel = $(this)
      .closest('.navbar')
      .find('.custom-navbar-toggler')
    var fadelayer = $(target).find('.overlay')
    $(buttonrel).attr('aria-expanded', 'false')

    $(target).removeClass('expanded')
    $(fadelayer).fadeOut()
    setTimeout(function() {
      $(target).hide()
    }, 300)
  })

  //-close button action
  $(closebutton).on('click', function(event) {
    var target = $(this).closest('.navbar-collapsable')
    var buttonrel = $(this)
      .closest('.navbar')
      .find('.custom-navbar-toggler')
    var fadelayer = $(target).find('.overlay')

    $(buttonrel).attr('aria-expanded', 'false')

    $(target).removeClass('expanded')
    $(fadelayer).fadeOut()
    setTimeout(function() {
      $(target).hide()
    }, 300)
  })

  //-- (a fine elenco viene chiuso il menù ed il focus passa all'elemento successivo)
  $(navlink).on('blur', function(event) {
    closemenu = $(this)
      .closest('.navbar-collapsable')
      .find('.close-div .btn') // determino il pulsante di chiusura
    /* Act on the event */
    if (
      $(this)
        .closest('.navbar-collapsable')
        .hasClass('expanded')
    ) {
      // se il navigatore è a perto
      setTimeout(function() {
        var active = document.activeElement // determino quale elemento ha il focus
        var isMenu = $(active).closest('.navbar-collapsable').length // controllo che l'elemento si trovi all'interno del navigatore

        if (isMenu == 0) {
          // se l'elemento è fuori dal navigatore
          $(closemenu).trigger('click') // simulo il click sul pulsante di chiusura del pannello
        }
      }, 50)
    }
  })

  //-- (a inizio elenco tabbando indietro, dopo il close chiudo il menu)
  $(closebutton).on('blur', function(event) {
    closemenu = $(this)
    /* Act on the event */
    if (
      $(this)
        .closest('.navbar-collapsable')
        .hasClass('expanded')
    ) {
      // se il navigatore è a perto
      setTimeout(function() {
        var active = document.activeElement // determino quale elemento ha il focus
        var isMenu = $(active).closest('.navbar-collapsable').length // controllo che l'elemento si trovi all'interno del navigatore

        if (isMenu == 0) {
          // se l'elemento è fuori dal navigatore
          $(closemenu).trigger('click') // simulo il click sul pulsante di chiusura del pannello
        }
      }, 50)
    }
  })
})

$(function() {
  var openbutton = $('.custom-navbar-toggler')
  var closebutton = $('.close-div')
  var overlay = $('.overlay')
  var backbutton = $('.it-back-button')
  var navlink = $('.navbar-collapsable a')

  $('.it-bottom-navscroll ul li a[href^="#"]').on('click', function(e) {
    e.preventDefault()

    var hash = this.hash

    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top,
      },
      600,
      function() {
        if (history.pushState) {
          history.pushState(null, null, hash)
        } else {
          location.hash = hash
        }
      }
    )
    //close window on click
    $(overlay).trigger('click')
  })

  // navscroll back function
  $(backbutton).click(function(event) {
    $(overlay).trigger('click')
    $(this).fadeOut()
    event.preventDefault()
  })

  // navscroll item on scroll
  $(window)
    .on('scroll', function() {
      var sectionsContainerTop = $('.it-page-sections-container').length ? $(".it-page-sections-container").offset().top : 0
      var scrollDistance = $(window).scrollTop() - sectionsContainerTop
      // Assign active class to nav links while scolling
      $('.it-page-section').each(function(i) {
        if ($(this).position().top <= scrollDistance) {
          $('.it-navscroll-wrapper .menu-wrapper a.active').removeClass(
            'active'
          )
          $('.it-navscroll-wrapper .menu-wrapper a')
            .eq(i)
            .addClass('active')
          var parentsection = $('.it-navscroll-wrapper .menu-wrapper a')
            .eq(i)
            .closest('ul')
            .prev('a')
          var parentparentsection = $(parentsection)
            .closest('ul')
            .prev('a')
          $(parentsection).addClass('active')
          $(parentparentsection).addClass('active')
          var textContent = $('.it-navscroll-wrapper .menu-wrapper a')
            .eq(i)
            .find('span')
            .text()
          var $btn = $('.it-navscroll-wrapper .custom-navbar-toggler')
          var $icon = $btn.find('span.it-list')
          $btn.text(textContent)
          $btn.prepend($icon)
        }
      })
    })
    .scroll()
})

$(function() {
  $('.go-back').on('click', function() {
    window.history.back()
    return false
  })
})

function notificationShow(notificationTarget, notificationTimeOut) {
  $('#' + notificationTarget).fadeIn(300)

  if (!$('#' + notificationTarget).hasClass('dismissable')) {
    //standard (timeout)
    $('#' + notificationTarget).fadeIn(300)
    if (typeof notificationTimeOut == 'number') {
      //timeout set by parameter
      var timeToFade = notificationTimeOut
    } else {
      //timeout default value 7s
      var timeToFade = 7000
    }
    //fadeout
    setTimeout(function() {
      $('#' + notificationTarget).fadeOut(100)
    }, timeToFade)
  }
}

//dismissable close button
$(document).on('click', '.notification-close', function() {
  $(this)
    .closest('.notification')
    .fadeOut(100)
})

$(function() {
  var $form = $('.upload-dragdrop:not(.success)')
  var droppedFiles = false

  $form
    .on('drag dragstart dragend dragover dragenter dragleave drop', function(
      e
    ) {
      e.preventDefault()
      e.stopPropagation()
    })
    .on('dragover dragenter', function() {
      $(this).addClass('dragover')
    })
    .on('dragleave dragend drop', function() {
      $(this).removeClass('dragover')
    })
    .on('drop', function(e) {
      //change drag and drop state
      $(this).addClass('loading')
      //init upload circular loader
      $(this)
        .find('.upload-progress')
        .circularloader({
          backgroundColor: '#ffffff', //background colour of inner circle
          fontColor: '#000000', //font color of progress text
          fontSize: '40px', //font size of progress text
          radius: 130, //radius of circle
          progressBarBackground: 'transparent', //background colour of circular progress Bar
          progressBarColor: '#0073e6', //colour of circular progress bar
          progressBarWidth: 96, //progress bar width
          progressPercent: 0, //progress percentage out of 100, start with 0
        })
    })
})

const progressDonut = (function($) {
  //background colour of inner circle
  const backgroundColor = '#fff'

  //font color of progress text
  const fontColor = '#000'

  //font size of progress text
  const fontSize = 40

  //radius of circle
  const donutRadius = 130

  //progress bar width
  const donutWidth = 96

  //background colour of circular progress Bar
  const donutBackground = 'transparent'

  //colour of circular progress bar
  const donutForeground = '#0073e6'

  /**
   * generate a progress donut
   * @param {string} target - The element
   * @param {string} progress - percentage out of 100, start with 0
   */
  var generate = function(target, progress) {
    $(target).circularloader({
      backgroundColor: backgroundColor,
      fontColor: fontColor,
      fontSize: fontSize,
      radius: donutRadius,
      progressBarBackground: donutBackground,
      progressBarColor: donutForeground,
      progressBarWidth: donutWidth,
      progressPercent: progress,
    })
    $(target)
      .next()
      .html('Progresso ' + progress + '%')
  }

  /**
   * update progress donut percentage
   * @param {string} target - The element
   * @param {string} progress - percentage out of 100, start with 0
   */
  var update = function(target, progress) {
    $(target).circularloader({
      progressPercent: progress,
    })
  }

  return {
    generate: generate,
    update: update,
  }
})($)

$(function() {
  $('.it-has-checkbox').on('click', function(event) {
    var _target = $(this).find('input')
    if ($(_target).prop('checked')) {
      $(_target).prop('checked', false)
      $(this).removeClass('active')
    } else {
      $(_target).prop('checked', true)
      $(this).addClass('active')
    }
    event.preventDefault()
  })
})

$(function() {
  var userAgent, ieReg, ie
  userAgent = window.navigator.userAgent
  ieReg = /msie|Trident.*rv[ :]*11\./gi
  ie = ieReg.test(userAgent)

  if (ie) {
    $('.img-wrapper').each(function() {
      var $container = $(this),
        imgUrl = $container.find('img').prop('src')
      if (imgUrl) {
        $container
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('custom-object-fit')
      }
    })
  }
})

$(function() {
  //resize function
  function inputNumberResize($target) {
    var $inputNumber = $target.closest('.input-number')
    if ($inputNumber.hasClass('input-number-adaptive')) {
      // width = padding (12px + 32px) + number of characters
      if (!$inputNumber.hasClass('input-number-percentage')) {
        $target.css('width', 'calc(44px + ' + $target.val().length + 'ch)')
        if (isIe())
          $target.css(
            'width',
            'calc(44px + (1.5 * ' + $target.val().length + 'ch))'
          )
      }
      if ($inputNumber.hasClass('input-number-currency')) {
        $target.css(
          'width',
          'calc(40px + 44px + ' + $target.val().length + 'ch)'
        )
        if (isIe())
          $target.css(
            'width',
            'calc(40px + 44px + (1.5 * ' + $target.val().length + 'ch))'
          )
      }
    }
  }

  //resize all input numbers field on DR
  $('.input-number input[type=number]').each(function(index) {
    inputNumberResize($(this))
  })

  //add & sub button
  $('.input-number button').click(function(e) {
    e.preventDefault()
    //get target input field
    var $inputTarget = $(this)
      .closest('.input-number')
      .find('input[type=number]')
    var inputTargetVal = parseFloat($inputTarget.val())

    if (!isNaN(inputTargetVal)) {
      var val = 0
      //get min & max
      var inputTargetMax = parseFloat($inputTarget.attr('max'))
      var inputTargetMin = parseFloat($inputTarget.attr('min'))

      //get step
      var inputTargetStep = parseFloat($inputTarget.attr('step'))
      if (!inputTargetStep) {
        inputTargetStep = 1
      }

      if ($(this).hasClass('input-number-add')) {
        //add step
        val =
          !isNaN(inputTargetMax) &&
          inputTargetVal + inputTargetStep >= inputTargetMax
            ? inputTargetMax
            : inputTargetVal + inputTargetStep
        $inputTarget.val(val)
      }

      if ($(this).hasClass('input-number-sub')) {
        //subtract step
        val =
          !isNaN(inputTargetMin) &&
          inputTargetVal - inputTargetStep <= inputTargetMin
            ? inputTargetMin
            : inputTargetVal - inputTargetStep
        $inputTarget.val(val)
      }
    }

    //resize input
    inputNumberResize($inputTarget)
  })

  //manual input
  $('.input-number input[type=number]').change(function(e) {
    //get field val
    var $inputTarget = $(this)
    var inputTargetVal = parseFloat($inputTarget.val())

    if (!isNaN(inputTargetVal)) {
      //get min & max
      var inputTargetMax = parseFloat($inputTarget.attr('max'))
      var inputTargetMin = parseFloat($inputTarget.attr('min'))
      //limit min
      if (inputTargetMin && inputTargetVal < inputTargetMin) {
        inputTargetVal = inputTargetMin
      }
      //limit max
      if (inputTargetMax && inputTargetVal > inputTargetMax) {
        inputTargetVal = inputTargetMax
      }
      $inputTarget.val(inputTargetVal)
    }

    //resize input
    inputNumberResize($inputTarget)
  })

  // Fixing IE11 numeric behavior
  $('input[type=number]').on('keyup', function(e) {
    var value = e && e.target.value
    var regexp = /[^0-9,.]/g
    this.value = value.replace(regexp, '')
  })
})

$(function() {
  var carouselTarget = $('.owl-carousel.it-carousel-all')
  // parameters
  var cnav
  var cloop
  var cmargin
  var citems
  var cnavText
  var cnavSpeed //arrow click
  var csmartSpeed // bullet click
  var cdotsSpeed
  var ccontrolsAriaHidden
  var cmouseDrag
  var ctouchDrag
  var cdots
  var cslideBy
  var cstagePadding
  // mobile params
  var mobnav
  var mobdots
  var mobitems
  var mobstagePadding
  var mobmargin
  // 768 params
  var tabnav
  var tabdots
  var tabitems
  var tabstagePadding
  var tabmargin
  // 992 params
  var desknav
  var deskdots
  var deskitems
  var deskstagePadding
  var deskmargin
  // xl params
  var xlnav
  var xldots
  var xlitems
  var xlstagePadding
  var xlmargin

  $(carouselTarget).each(function() {
    // target definition
    if (
      $(this)
        .closest('.it-carousel-wrapper')
        .hasClass('it-carousel-landscape-abstract-three-cols')
    ) {
      cnav = true
      cloop = false
      cmargin = 24
      citems = 3
      cnavText = []
      cnavSpeed = 300 //arrow click
      csmartSpeed = 500 // bullet click
      cdotsSpeed = 200
      ccontrolsAriaHidden = true
      cmouseDrag = true
      ctouchDrag = true
      cdots = false
      cslideBy = 'page'
      cstagePadding = cstagePadding
      // mobile params
      mobnav = false
      mobdots = true
      mobitems = 1
      mobstagePadding = 40
      mobmargin = 24
      // 768 params
      tabnav = false
      tabdots = true
      tabitems = 2
      tabstagePadding = 40
      tabmargin = 24
      // 992 params
      desknav = false
      deskdots = true
      deskitems = 3
      deskstagePadding = 0
      deskmargin = 0
      // xl params
      xlnav = false
      xldots = true
      xlitems = 3
      xlstagePadding = 0
      xlmargin = 0

      // carousel 3 col with shadow
      if ($(this).hasClass('it-card-bg')) {
        mobstagePadding = 40
        mobmargin = 24
        tabstagePadding = 40
        tabmargin = 24
        deskstagePadding = 12
        deskmargin = 24
        xlstagePadding = 12
        xlmargin = 24
      }

      // carousel 3 img card
      if ($(this).hasClass('it-img-card')) {
        mobstagePadding = 40
        mobmargin = 24
        tabstagePadding = 40
        tabmargin = 24
        deskstagePadding = 0
        deskmargin = 24
        xlstagePadding = 0
        xlmargin = 24
      }
      // carousel img big
      if ($(this).hasClass('it-img-card') && $(this).hasClass('it-big-img')) {
        cloop = true
        mobstagePadding = 0
        mobmargin = 0
        tabstagePadding = 160
        tabmargin = 24
        tabitems = 1
        deskstagePadding = 320
        deskmargin = 48
        deskitems = 1
        xlstagePadding = 320
        xlmargin = 48
        xlitems = 1
      }
      // standard img
      if (
        $(this).hasClass('it-img-card') &&
        $(this).hasClass('it-standard-image')
      ) {
        cloop = true
        mobstagePadding = 40
        mobmargin = 24
        mobitems = 1
        tabstagePadding = 48
        tabmargin = 24
        tabitems = 2
        deskstagePadding = 68
        deskmargin = 24
        deskitems = 3
        xlstagePadding = 48
        xlmargin = 24
        xlitems = 3
      }
    }

    if (
      $(this)
        .closest('.it-carousel-wrapper')
        .hasClass('it-calendar-wrapper')
    ) {
      cnav = true
      cloop = false
      cmargin = 0
      citems = 4
      cnavText = []
      cnavSpeed = 300 //arrow click
      csmartSpeed = 500 // bullet click
      cdotsSpeed = 200
      ccontrolsAriaHidden = true
      cmouseDrag = true
      ctouchDrag = true
      cdots = false
      cslideBy = 'page'
      cstagePadding = cstagePadding
      // mobile params
      mobnav = false
      mobdots = true
      mobitems = 1
      mobstagePadding = 40
      mobmargin = 0
      // 768 params
      tabnav = false
      tabdots = true
      tabitems = 2
      tabstagePadding = 40
      tabmargin = 0
      // 992 params
      desknav = false
      deskdots = true
      deskitems = 4
      deskstagePadding = 0
      deskmargin = 0
      // xl params
      xlnav = false
      xldots = true
      xlitems = 4
      xlstagePadding = 0
      xlmargin = 0

      // carousel 4 col with shadow
      if ($(this).hasClass('it-card-bg')) {
        mobstagePadding = 40
        mobmargin = 0
        tabstagePadding = 40
        tabmargin = 0
        deskstagePadding = 0
        deskmargin = 0
        xlstagePadding = 0
        xlmargin = 0
      }

      // carousel 4 img card
      if ($(this).hasClass('it-img-card')) {
        mobstagePadding = 40
        mobmargin = 0
        tabstagePadding = 40
        tabmargin = 0
        deskstagePadding = 0
        deskmargin = 0
        xlstagePadding = 0
        xlmargin = 0
      }
      // carousel img big
      if ($(this).hasClass('it-img-card') && $(this).hasClass('it-big-img')) {
        cloop = true
        mobstagePadding = 0
        mobmargin = 0
        tabstagePadding = 160
        tabmargin = 0
        tabitems = 1
        deskstagePadding = 320
        deskmargin = 0
        deskitems = 1
        xlstagePadding = 320
        xlmargin = 0
        xlitems = 1
      }
      // standard img
      if (
        $(this).hasClass('it-img-card') &&
        $(this).hasClass('it-standard-image')
      ) {
        cloop = true
        mobstagePadding = 40
        mobmargin = 0
        mobitems = 1
        tabstagePadding = 48
        tabmargin = tabitems = 2
        deskstagePadding = 68
        deskmargin = 0
        deskitems = 4
        xlstagePadding = 48
        xlmargin = 0
        xlitems = 4
      }
    }

    // Landscape abstract --------------------------------------------------------------------------
    if (
      $(this)
        .closest('.it-carousel-wrapper')
        .hasClass('it-carousel-landscape-abstract')
    ) {
      cnav = true
      cloop = false
      cmargin = 24
      citems = 1
      cnavText = []
      cnavSpeed = 300 //arrow click
      csmartSpeed = 500 // bullet click
      cdotsSpeed = 200
      ccontrolsAriaHidden = true
      cmouseDrag = true
      ctouchDrag = true
      cdots = false
      cslideBy = 'page'
      cstagePadding = cstagePadding
      // mobile params
      mobnav = false
      mobdots = true
      mobitems = 1
      mobstagePadding = 0
      mobmargin = 24
      // 768 params
      tabnav = false
      tabdots = true
      tabitems = 1
      tabstagePadding = 24
      tabmargin = 24
      // 992 params
      desknav = false
      deskdots = true
      deskitems = 1
      deskstagePadding = 0
      deskmargin = 0
      // xl params
      xlnav = false
      xldots = true
      xlitems = 1
      xlstagePadding = 0
      xlmargin = 0
    }

    if ($(this).owlCarousel) {
      //carousel settings//
      $(this).owlCarousel({
        //carousel parameters
        nav: cnav,
        loop: cloop,
        margin: 24, //cmargin
        items: citems,
        navText: cnavText,
        navSpeed: cnavSpeed, //arrow click
        smartSpeed: csmartSpeed, // bullet click
        dotsSpeed: cdotsSpeed,
        navElement: 'button',
        dotElement: 'button',
        controlsAriaHidden: ccontrolsAriaHidden,
        mouseDrag: cmouseDrag,
        touchDrag: ctouchDrag,
        dots: cdots,
        slideBy: cslideBy,
        stagePadding: cstagePadding, //cstagePadding,
        responsive: {
          // breakpoint from 0 up
          0: {
            nav: mobnav,
            dots: mobdots,
            items: mobitems,
            stagePadding: mobstagePadding,
            margin: mobmargin,
          },
          // breakpoint from 768 up
          768: {
            nav: tabnav,
            dots: tabdots,
            stagePadding: tabstagePadding,
            items: tabitems,
            margin: tabmargin,
          },
          // breakpoint from 992 up
          992: {
            nav: desknav,
            dots: deskdots,
            items: deskitems,
            stagePadding: deskstagePadding,
            margin: deskmargin,
          },
          // breakpoint from 1200 up
          1200: {
            nav: xlnav,
            dots: xldots,
            stagePadding: xlstagePadding,
            items: xlitems,
            margin: xlmargin,
          },
        },
        onInitialized: function(event) {
          $(event.target)
            .find('.owl-dot')
            .each(function(index) {
              $(this).attr('aria-labelledby', 'owl-dot-' + index)
            })
        },
      })
    }
  })
})

$(function() {
  // header input
  var headerInput = $('.transfer-header input')
  var listInput = $('.transfer-group input')

  // transfer buttons
  var addButton = $('.it-transfer-block').find('a.transfer')
  var inverseButton = $('.it-transfer-block').find('a.backtransfer')
  var resetButton = $('.it-transfer-block').find('a.reset')

  // stato iniziale
  var elemLeft = $('.source .transfer-group .form-check')
  var elemRight = $('.target .transfer-group .form-check')
  var elemLeftNum = elemLeft.length
  var elemRightNum = elemRight.length
  var leftStart = ''
  var rightStart = ''

  $(elemLeft).each(function(el) {
    leftStart = leftStart + this
  })
  $(elemRight).each(function(el) {
    rightStart = rightStart + this
  })

  function disableElement($el) {
    $el
      .removeClass('active')
      .attr('disabled', 'disabled')
      .attr('aria-disabled', 'true')
  }

  function enableElement($el) {
    $el
      .addClass('active')
      .removeAttr('disabled')
      .removeAttr('aria-disabled')
  }

  function checkListHeader(scopeElControl) {
    var listToCheck = $(scopeElControl).find('.transfer-group input')
    var listToCheckControl = $(scopeElControl).find(
      '.transfer-group input:checked'
    )
    var inputHeader = $(scopeElControl).find('.transfer-header input')
    // contextual buttons
    addButton = scopeElControl.closest('.it-transfer-block').find('a.transfer')
    inverseButton = scopeElControl
      .closest('.it-transfer-block')
      .find('a.backtransfer')

    if (listToCheckControl.length > 0) {
      $(listToCheck).prop('checked', false)
      $(inputHeader)
        .removeClass('semi-checked')
        .prop('checked', false)
      // controllo quale pulsante centrale disattivare
      if (scopeElControl.hasClass('source')) {
        disableElement(addButton)
      } else {
        disableElement(inverseButton)
      }
    } else {
      $(listToCheck).prop('checked', true)
      // controllo quale pulsante centrale attivare
      if (scopeElControl.hasClass('source')) {
        enableElement(addButton)
      } else {
        enableElement(inverseButton)
      }
    }
  }

  function checkList(scopeElControl) {
    var listToCheck = $(scopeElControl).find('.transfer-group input')
    var listToCheckControl = $(scopeElControl).find(
      '.transfer-group input:checked'
    )
    var inputHeader = $(scopeElControl).find('.transfer-header input')

    // contextual buttons
    addButton = scopeElControl.closest('.it-transfer-block').find('a.transfer')
    inverseButton = scopeElControl
      .closest('.it-transfer-block')
      .find('a.backtransfer')

    if (listToCheckControl.length == 0) {
      inputHeader.removeClass('semi-checked').prop('checked', false)
      // controllo quale pulsante centrale disattivare
      if (scopeElControl.hasClass('source')) {
        disableElement(addButton)
      } else {
        disableElement(inverseButton)
      }
    } else if (listToCheckControl.length == listToCheck.length) {
      inputHeader.removeClass('semi-checked').prop('checked', true)
      // controllo quale pulsante centrale disattivare
    } else {
      // controllo quale pulsante centrale disattivare
      inputHeader.addClass('semi-checked').prop('checked', false)
      if (scopeElControl.hasClass('source')) {
        enableElement(addButton)
      } else {
        enableElement(inverseButton)
      }
    }
  }

  function addItems(sourceControl, targetControl) {
    var sourceItems = sourceControl.find('.transfer-group input:checked')
    var sourceItemsBlock = sourceItems.closest('.form-check')
    var sourceHeadInput = sourceControl.find('.transfer-header input')
    var sourceHeadLabel = sourceControl.find('.transfer-header span.num')
    var sourceItemsQty = sourceItems.length
    var sourceTotalQty = sourceControl.find('.transfer-group input').length

    var targetDiv = targetControl.find('.transfer-group')
    var targetQty =
      targetControl.find('.transfer-group input').length + sourceItemsQty
    var targetHeadLabel = targetControl.find('.transfer-header span.num')
    var targetHeadInput = targetControl.find('.transfer-header input')

    // ciclo di aggiunta
    sourceItemsBlock.each(function() {
      $(this)
        .detach()
        .appendTo(targetDiv)
        .find('input')
        .prop('checked', false)
    })
    // update label
    var totalSource = sourceTotalQty - sourceItemsQty
    var totalTarget = targetQty

    sourceHeadLabel.text(totalSource)
    targetHeadLabel.text(totalTarget)

    // disattivazione header input se non ci sono più elementi
    if (totalSource == 0) {
      sourceHeadInput.prop('disabled', true)
    }
    if (totalTarget > 0) {
      targetHeadInput.prop('disabled', false)
    }

    // ripristino stato iniziale input header
    sourceHeadInput.removeClass('semi-checked').prop('checked', false)
  }

  function resetAll(contextControl) {
    var left = contextControl.find('.source .transfer-group')
    var right = contextControl.find('.target .transfer-group')
    var textLeft = contextControl.find('.source .transfer-header span.num')
    var textRight = contextControl.find('.target .transfer-header span.num')
    var header = contextControl.find('.transfer-header input')
    var allElement = contextControl.find('.transfer-group input')

    $(left)
      .find('.form-check')
      .detach()
    $(right)
      .find('.form-check')
      .detach()
    $(left).append(elemLeft)
    $(right).append(elemRight)

    $(textLeft).text(elemLeftNum)
    $(textRight).text(elemRightNum)

    $(header)
      .prop('disabled', false)
      .removeClass('semi-checked')
    $(header).prop('checked', false)

    $(allElement).prop('checked', false)
  }

  // click su header
  $(headerInput).on('click', function() {
    var scopeEl = $(this).closest('.it-transfer-wrapper')
    checkListHeader(scopeEl)
  })

  //click su lista
  $(listInput).on('click', function() {
    var scopeEl = $(this).closest('.it-transfer-wrapper')
    checkList(scopeEl)
  })

  //spostamento da sinistra a destra
  $(addButton).on('click', function(event) {
    var source = $(this)
      .closest('.it-transfer-block')
      .find('.source')
    var target = $(this)
      .closest('.it-transfer-block')
      .find('.target')
    resetButton = $(this)
      .closest('.it-transfer-block')
      .find('a.reset')

    // attivo il pulsante di reset
    enableElement(resetButton)

    // disattivo il pulsante corrente
    disableElement($(this))

    addItems(source, target)
    event.preventDefault()
  })

  //spostamento da destra a sinistra
  $(inverseButton).on('click', function(event) {
    var target = $(this)
      .closest('.it-transfer-block')
      .find('.source')
    var source = $(this)
      .closest('.it-transfer-block')
      .find('.target')
    resetButton = $(this)
      .closest('.it-transfer-block')
      .find('a.reset')

    // attivo il pulsante di reset
    enableElement(resetButton)

    // disattivo il pulsante corrente
    disableElement($(this))

    addItems(source, target)
    event.preventDefault()
  })

  $(resetButton).on('click', function(event) {
    var context = $(this).closest('.it-transfer-block')
    var addButton = context.find('a.transfer')
    var reverseButton = context.find('a.backtransfer')
    disableElement(addButton)
    disableElement(reverseButton)
    disableElement($(this))

    resetAll(context)
    event.preventDefault()
  })
})

$(function() {
  let onSelectChange = function() {
    $('.dropdown-menu li.selected')
      .find('input[type="checkbox"]')
      .prop('checked', true)
    $('.dropdown-menu li:not(.selected)')
      .find('input[type="checkbox"]')
      .prop('checked', false)
  }

  // Allows to rewrite options dynamically with an object in the form of
  jQuery.fn.setOptionsToSelect = function(optionsData) {
    var selectElement = $(this).find('select')

    // Destroying selectElement
    $(selectElement)
      .off('changed.bs.select')
      .selectpicker('destroy')
      .empty()

    // Appending options according to the optionsData object
    optionsData.forEach(function(x) {
      $(selectElement).append(
        $('<option>', {
          value: x.value,
          text: x.text,
        })
      )
    })

    // Refreshing selectElement
    $(selectElement)
      .selectpicker('refresh')
      .on('changed.bs.select', onSelectChange)

    return this
  }

  // Bootstrap-select initialisation
  $('.bootstrap-select-wrapper select')
    .selectpicker()
    .on('changed.bs.select', onSelectChange)

  // Fixes for W3C and WCAG 2.0 compliance:
  var $selectWrapper = $('.bootstrap-select-wrapper')

  // Enter generic and non-visible text for empty options
  $selectWrapper
    .find('select option.bs-title-option')
    .text('Nessuna opzione')
  $selectWrapper
    .find('select option[data-content]')
    .text('Annulla');

  // Remove the role="combobox" from the dropdown button
  $selectWrapper
    .find('button.dropdown-toggle')
    .removeAttr('role')

  // Replace any <div>s elements with <span>s as <div>s are not allowed in a button element
  $selectWrapper
    .find('div.filter-option')
    .replaceWith(function() {
      return $('<span />')
        .addClass('filter-option')
        .append($(this).contents())
    })
  $selectWrapper
    .find('div.filter-option-inner')
    .replaceWith(function() {
      return $('<span />')
        .addClass('filter-option-inner')
        .append($(this).contents())
    })
  $selectWrapper
    .find('div.filter-option-inner-inner')
    .replaceWith(function() {
      return $('<span />')
        .addClass('filter-option-inner-inner')
        .append($(this).contents())
    })

  // Add title and WAI-ARIA attribute for the input search
  $selectWrapper
    .find('.bs-searchbox input')
    .attr('title', 'Cerca')
    .attr('aria-expanded', 'false')
})

$(function() {
  $('.rating.rating-label input[type=radio]').on('click', function(event) {
    var stars = $(this).val()
    var starsLabel = 'stelle'
    if (stars == 1) {
      starsLabel = 'stella'
    }
    $(this)
      .closest('.rating-label')
      .find('legend span:not(.sr-only)')
      .text(stars + ' ' + starsLabel)
  })
})

$(function() {
  $.fn.dimmerShow = function() {
    return this.each(function() {
      if ($(this).css('display') != 'flex') {
        $(this)
          .css('display', 'flex')
          .hide()
          .fadeIn(200)
      }
    });
  }

  $.fn.dimmerHide = function (target) {
    return this.each(function() {
      $(this).fadeOut(200)
    });
  }
})

